<template>
  <div class="app-main-inner">
    <el-dialog
      :visible="visible"
      :title="title"
      width="1000px"
      :close-on-click-modal="false"
      :show-close="false"
      top="5vh"
      custom-class="make-invoice-dialog"
    >
      <div class="tabs-container" style="padding: 0;">
        <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
          <el-tab-pane :label="$t('Invoice.invoice_invoiceContent')" name="makeInvoice">
            <div v-if="properties.invoice.ar && [0,1,4].includes(properties.invoice.invoiceType)" id="invoiceIncomeBoard" style="padding: 10px 10px 10px 20px;">
              <span style="display: flex; justify-content: center; font-size: 18px;">{{ $t('CargoMsg.Cargo_Sp1') }}</span>
              <el-form :inline="true" label-width="60px" label-position="left" style="margin-top: 4px;">
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_PayUnit')" class="el-form-item-w250">
                    <el-input v-model="properties.invoice.title" no="1" :disabled="locked" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_InvoiceNo')" class="el-form-item-w190">
                    <el-input v-model="properties.invoice.invoiceNo" no="2" :disabled="!properties.invoiceNoEditable || invoiceReadonly || ['overseaBilling','internalBillInfo'].includes(viewSource) || approvalLocked" />
                  </el-form-item>
                  <el-form-item :label="$t('Invoice.invoice_invoiceDate')" class="el-form-item-date-w190">
                    <el-date-picker
                      v-model="properties.invoice.invoiceDate"
                      no="3"
                      type="date"
                      :clearable="false"
                      :disabled="locked"
                      class="el-form-item__content"
                      @change="invoiceDateChange"
                    />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_OriginalCurrency')" class="el-form-item-w110">
                    <el-input v-model="chargeCurrency" no="4" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_InvoicingCurrency')" class="el-form-item-w110">
                    <el-input v-model="properties.invoice.currency" no="5" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_ExchangeRate')" class="el-form-item-w130">
                    <el-input v-model="rate" no="6" :disabled="true" />
                  </el-form-item>
                  <el-form-item v-if="approvalEditable" :label="$t('CargoMsg.Cargo_OurBank')" class="el-form-item-w250">
                    <cargo-advance-select
                      no="7"
                      filterable
                      :select-type="selectTypeNames.static_data_BankAccount"
                      :cache="false"
                      :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
                      :default-value="ourBankAccountId || ''"
                      :static-options="ourBankAccountArray"
                      :disabled="locked || ourBankAccountAutoLocked"
                      options-width="450px"
                      @parentCallBack="getBankAccountFromChild"
                    />
                  </el-form-item>
                  <el-form-item v-else :label="$t('CargoMsg.Cargo_OurBank')" class="el-form-item-w250">
                    <cargo-advance-select
                      no="7"
                      filterable
                      :select-type="selectTypeNames.static_data_BankAccount"
                      :cache="false"
                      :method-params="{officeId:properties.invoice.branchId}"
                      :default-value="ourBankAccountId || ''"
                      :static-options="ourBankAccountArray"
                      :disabled="locked || ourBankAccountAutoLocked"
                      options-width="450px"
                      @parentCallBack="getBankAccountFromChild"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_OurAccount')" class="el-form-item-w190">
                    <el-input v-model="properties.invoice.bankAccount" no="8" :disabled="true" />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_SubscribePOL')" class="el-form-item-w150">
                    <el-input v-model="pol" no="9" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_PortOfDischarge')" class="el-form-item-w150">
                    <el-input v-model="pod" no="10" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Destination')" class="el-form-item-w150">
                    <el-input v-model="pod2" no="11" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_SailingDate')" class="el-form-item-date-w190">
                    <el-date-picker
                      v-model="properties.invoice.etd"
                      no="12"
                      type="date"
                      :disabled="true"
                      class="el-form-item__content"
                    />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_ArrivalDate')" class="el-form-item-date-w190">
                    <el-date-picker
                      v-model="properties.invoice.eta"
                      no="13"
                      type="date"
                      :disabled="true"
                      class="el-form-item__content"
                    />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_InvoicingRequirements')" class="el-form-item-w320">
                    <el-input v-model="properties.invoice.invoiceDemand" no="14" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_VesselAndVoyage')" class="el-form-item-label65-w250">
                    <el-input v-model="properties.invoice.vesselVoyage" no="15" :disabled="locked" />
                  </el-form-item>
                  <el-form-item label="">
                    <el-radio-group v-model="properties.rbgShowChargeDetail" no="16" @change="onMergeTypeChange">
                      <el-radio id="rbSole" label="detail" :disabled="lockedWithoutBpm">{{ $t('CargoMsg.Cargo_Sp17') }}</el-radio>
                      <el-radio id="rbMerge" label="merge" :disabled="lockedWithoutBpm">{{ $t('CargoMsg.Cargo_Sp18') }}</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_Cargo')" class="el-form-item-textarea-w140">
                    <el-input v-model="properties.invoice.partCargo" no="17" type="textarea" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_ChargeName')" class="el-form-item-textarea-w100">
                    <el-input v-model="properties.invoice.partChargeName" no="18" type="textarea" :disabled="locked" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_AmountNumber')" class="el-form-item-textarea-w80">
                    <el-input v-model="properties.invoice.partQuantity" no="19" type="textarea" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_UnitPrice')" class="el-form-item-textarea-w80">
                    <el-input v-model="properties.invoice.partUnitPrice" no="20" type="textarea" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_OriginalAmount')" class="el-form-item-textarea-w80">
                    <el-input v-model="properties.invoice.partAmount" no="21" type="textarea" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_MonetaryEquivalent')" class="el-form-item-textarea-w80">
                    <el-input v-model="properties.invoice.partAmount2" no="22" type="textarea" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Remarks')" class="el-form-item-textarea-w150">
                    <el-input v-model="properties.invoice.remark" no="23" type="textarea" :disabled="locked" @input="markInvoiceRemarkModified" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Sp24')" class="el-form-item-textarea-w100">
                    <el-input v-model="properties.invoice.remark2" no="24" type="textarea" :disabled="locked" />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_TotalAmount')" class="el-form-item-w210">
                    <el-input v-model="properties.invoice.chineseAmount" no="25" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_AmountTo')" class="el-form-item-w190">
                    <el-input v-model="amount" no="26" :disabled="true" />
                  </el-form-item>
                </div>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_Sp27')" class="el-form-item-w210">
                    <el-input id="tiCompany" no="27" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_Recheck')" class="el-form-item-w190">
                    <el-input v-model="properties.invoice.auditor" no="28" :disabled="true" />
                  </el-form-item>
                  <el-form-item :label="$t('CargoMsg.Cargo_TaxationNbr')" class="el-form-item-w230">
                    <el-input v-model="properties.invoice.taxAccount" no="29" :disabled="locked" />
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div v-if="properties.invoice.ar && [2,3].includes(properties.invoice.invoiceType) && !properties.isEasyInoivceVietnam" id="invoiceAddValueBoard">
              <el-form label-width="100px" label-position="right" class="vatInvoiceForm">
                <el-row type="flex" :gutter="10" class="vatInvoiceForm-header">
                  <el-col :span="7" class="left">
                    <el-form-item :label="`${$t('Invoice.invoice_makeType')}：`">
                      <span>{{ makeType }}</span>
                      <span v-if="properties.invoice.invoiceState === 1 || properties.invoice.invoiceState === 2" style="margin-left:5px;color: red; font-size: 16px;">{{ redPunch }}</span>
                    </el-form-item>
                    <el-form-item :label="`${ $t('Invoice.invoice_invoiceStatus') }：`">
                      <span>{{ isPrinted }}</span>
                      <el-input
                        v-if="properties.invoice.makeType === 0 && properties.invoice.invoiceType === 3 && properties.invoice.invoiceState === 2"
                        v-model="properties.invoice.cnnoticeNo"
                        no="30"
                        :placeholder="$t('CargoMsg.Cargo_PleaseEnterScarletLetterNumber')"
                        max="20"
                        :disabled="!enabledCnnoticeNo || approvalLocked"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" class="center">
                    <div style="width: 100%;">
                      <span id="lbInvoiceType" style="font-size: 22px; color: red; display: block; text-align: center;">{{ lbInvoiceType }}</span>
                      <div style="padding-top: 6px; width: 100%; border-bottom: 1px solid red;" />
                      <div style="padding-top: 3px; width: 100%; border-bottom: 1px solid red;" />
                    </div>
                  </el-col>
                  <el-col :span="7" class="right">
                    <div>
                      <el-form-item :label="$t('CargoMsg.Cargo_InvoiceNo')">
                        <el-input v-model="properties.invoice.invoiceNo" no="31" :disabled="!properties.invoiceNoEditable || invoiceReadonly || ['overseaBilling','internalBillInfo'].includes(viewSource) || approvalLocked" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_InvoiceDate')">
                        <el-date-picker
                          v-model="properties.invoice.invoiceDate"
                          no="32"
                          type="date"
                          :clearable="false"
                          :disabled="locked"
                          style="width: 100%;"
                          @change="invoiceDateChange"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('CargoMsg.Cargo_PurchasingUnit') }}
                    </div>
                  </el-col>
                  <el-col :span="12" class="red-left-top-border-w1" style="padding: 5px 5px;">
                    <el-row :gutter="10" style="width: 100%">
                      <el-form-item :label="$t('CargoMsg.Cargo_Name')">
                        <!--<el-input v-model="properties.invoice.title" />-->
                        <el-col>
                          <cargo-advance-select
                            no="33"
                            :select-type="selectTypeNames.static_data_Title"
                            :allow-create="!arSettlementUnitOptional || !properties.invoice.ar"
                            filterable
                            :cache="false"
                            :disabled="locked"
                            :default-value="properties.invoice.title"
                            :static-options="titleArray"
                            @parentCallBack="titleChangeEvent"
                          />
                        </el-col>
                      </el-form-item>
                      <el-form-item>
                        <line-label slot="label" :label="$t('CargoMsg.Cargo_RegistrationNumber')" />
                        <el-col>
                          <el-input v-model="properties.invoice.buyerTaxAccount" no="34" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_AddressTelNo')">
                        <el-col :span="12" :title="properties.invoice.buyerAddress">
                          <el-input v-model="properties.invoice.buyerAddress" no="35" :disabled="locked" />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.buyerTelephone">
                          <el-input v-model="properties.invoice.buyerTelephone" no="36" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item v-if="bankModeAvailable" class="bank-mode">
                        <el-select slot="label" v-model="properties.invoice.buyerBankMode" no="37" :disabled="locked" @change="buyerBankModeChange">
                          <el-option :label="$t('CargoMsg.Cargo_BankAccountNo')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')" :value="1" />
                        </el-select>
                        <el-col v-if="properties.invoice.buyerBankMode===1" :span="24" :title="properties.invoice.buyerDepositBankAccount">
                          <cargo-rich-textarea ref="buyerDepositBankAccount" no="38" :value="properties.invoice.buyerDepositBankAccount" :disabled="locked" :text-chars="0" :warning-count="-1" style="min-height: 45px;" @change="buyerDepositBankAccountChange" />
                        </el-col>
                        <template v-else>
                          <el-col :span="12" :title="properties.invoice.buyerBank">
                            <cargo-advance-select
                              no="39"
                              :select-type="selectTypeNames.static_data_TitleBank"
                              :allow-create="true"
                              filterable
                              :cache="false"
                              :disabled="locked"
                              tag-value="uuid"
                              :default-value="buyerBankUuid"
                              :static-options="titleBankArray"
                              @parentCallBack="getBankCusFromChild"
                            />
                          </el-col>
                          <el-col :span="12" :title="properties.invoice.buyerBankAccount">
                            <el-input v-model="properties.invoice.buyerBankAccount" no="40" :disabled="locked" />
                          </el-col>
                        </template>
                      </el-form-item>
                      <el-form-item v-if="!bankModeAvailable" :label="$t('CargoMsg.Cargo_BankAccountNo')">
                        <!-- <el-input v-model="properties.invoice.buyerBank" style="width:184px;" /> -->
                        <el-col :span="12" :title="properties.invoice.buyerBank">
                          <cargo-advance-select
                            no="41"
                            :select-type="selectTypeNames.static_data_TitleBank"
                            :allow-create="true"
                            filterable
                            :cache="false"
                            :disabled="locked"
                            tag-value="uuid"
                            :default-value="buyerBankUuid"
                            :static-options="titleBankArray"
                            @parentCallBack="getBankCusFromChild"
                          />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.buyerBankAccount">
                          <el-input v-model="properties.invoice.buyerBankAccount" no="42" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                    </el-row>
                  </el-col>
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('CargoMsg.Cargo_PasswordField') }}
                    </div>
                  </el-col>
                  <el-col :span="10" class="red-both-top-border-w1" />
                </el-row>
                <el-row v-if="!locked" type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-both-top-border-w1" style="display:flex;align-items: flex-end;">
                    <el-form-item>
                      <el-radio-group v-model="properties.rbgShowChargeDetail" :disabled="lookView" no="43" @change="rbgShowChargeDetailChangeHandler">
                        <el-radio label="merge" style="margin-right: 10px;">{{ $t('CargoMsg.Cargo_Sp18') }}</el-radio>
                        <el-radio label="detail" style="margin-right: 10px;" :disabled="!properties.showChargeDetailByInvoice || approvalLocked">{{ $t('CargoMsg.Cargo_ShowDetails') }}</el-radio>
                      </el-radio-group>
                      <el-button-group v-show="!lookView">
                        <el-button @click="addInvoiceItemHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
                        <el-button @click="removeInvoiceItemHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
                        <el-button v-permission="['button_ACInvoice_saveInvoiceAmount']" @click="checkInvoiceNoSaveAndCalcAmountHandler">{{ $t('CargoMsg.Cargo_Reflush') }}</el-button>
                      </el-button-group>
                    </el-form-item>
                  </el-col></el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-both-top-border-w1">
                    <cargo-ag-grid
                      :show-side-bar="false"
                      :grid-params.sync="vatInvoiceGrid.gridParams"
                      :grid-options="vatInvoiceGrid.gridOptions"
                      :column-defs="vatInvoiceGridColumnDefs"
                      :row-data="vatInvoiceGridRowData"
                      :auto-fit-content="false"
                      style="height:123px;width: 100%;"
                      @gridReady="params=>gridApi=params.api"
                    />
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="$selectByLang(4, 5)" class="red-left-top-border-w1">
                    <div class="title-horizontal">
                      {{ $t('CargoMsg.Cargo_TotalPriceWithTaxInWords') }}
                    </div>
                  </el-col>
                  <el-col :span="$selectByLang(20, 19)" class="red-both-top-border-w1">
                    <div style="display: flex;">
                      <el-form-item label="" label-width="0" style="padding: 0 10px;">
                        <el-input v-model="properties.invoice.chineseAmount" no="44" :disabled="true" style="width: 286px;" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_LowerCase')" label-width="50" style="display: flex;">
                        <el-input v-model="amount" no="45" :disabled="true" style="width: 140px;" />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('CargoMsg.Cargo_SellTitle') }}
                    </div>
                  </el-col>
                  <el-col :span="12" class="red-left-top-border-w1" style="padding: 5px 5px;">
                    <el-row :gutter="10" style="width: 100%">
                      <el-form-item :label="$t('CargoMsg.Cargo_Name')">
                        <el-col>
                          <cargo-advance-select
                            no="46"
                            :select-type="selectTypeNames.static_data_InvoiceTitle"
                            :allow-create="true"
                            filterable
                            :cache="false"
                            :disabled="locked || ourInvoiceTitleLocked"
                            :default-value="properties.invoice.sellTitle"
                            :static-options="ourInvoiceTitleArray"
                            @parentCallBack="ourTitleChangeEvent"
                          />
                        </el-col>
                      </el-form-item>
                      <el-form-item>
                        <line-label slot="label" :label="$t('CargoMsg.Cargo_RegistrationNumber')" />
                        <el-col>
                          <el-input v-model="properties.invoice.taxAccount" no="47" :disabled="locked || ourInvoiceTitleLocked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_AddressTelNo')">
                        <el-col :span="12" :title="properties.invoice.address">
                          <el-input v-model="properties.invoice.address" no="48" :disabled="locked" />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.telephone">
                          <el-input v-model="properties.invoice.telephone" no="49" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item v-if="bankModeAvailable" class="bank-mode">
                        <el-select slot="label" v-model="properties.invoice.sellerBankMode" no="50" :disabled="locked" @change="sellerBankModeChange">
                          <el-option :label="$t('CargoMsg.Cargo_BankAccountNo')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')" :value="1" />
                        </el-select>
                        <el-col v-if="properties.invoice.sellerBankMode===1" :span="24" :title="properties.invoice.sellerDepositBankAccount">
                          <cargo-rich-textarea id="txtAccountNo" ref="sellerDepositBankAccount" no="51" :value="properties.invoice.sellerDepositBankAccount" :disabled="locked" :text-chars="0" :warning-count="-1" style="min-height: 45px;" @change="sellerDepositBankAccountChange" />
                        </el-col>
                        <template v-else>
                          <el-col :span="12" :title="getOurBankName()">
                            <cargo-advance-select
                              no="52"
                              filterable
                              :select-type="selectTypeNames.static_data_BankAccount"
                              :cache="false"
                              :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
                              :default-value="ourBankAccountId || ''"
                              :static-options="ourBankAccountArray"
                              :disabled="locked || ourBankAccountAutoLocked"
                              options-width="450px"
                              @parentCallBack="getBankAccountFromChild"
                            />
                          </el-col>
                          <el-col :span="12" :title="properties.invoice.bankAccount">
                            <el-input id="txtAccountNo" v-model="properties.invoice.bankAccount" no="53" :disabled="true" />
                          </el-col>
                        </template>
                      </el-form-item>
                      <el-form-item v-if="!bankModeAvailable" :label="$t('CargoMsg.Cargo_BankAccountNo')">
                        <el-col :span="12" :title="getOurBankName()">
                          <cargo-advance-select
                            no="54"
                            filterable
                            :select-type="selectTypeNames.static_data_BankAccount"
                            :cache="false"
                            :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
                            :default-value="ourBankAccountId || ''"
                            :static-options="ourBankAccountArray"
                            :disabled="locked || ourBankAccountAutoLocked"
                            options-width="450px"
                            @parentCallBack="getBankAccountFromChild"
                          />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.bankAccount">
                          <el-input id="txtAccountNo" v-model="properties.invoice.bankAccount" no="55" :disabled="true" />
                        </el-col>
                      </el-form-item>
                    </el-row>
                  </el-col>
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('CargoMsg.Cargo_Remarks') }}
                    </div>
                    <div class="title-vertical" :title="$selectByLang('', $t('CargoMsg.Cargo_FinancialRemarks'))" :style="$selectByLang('', 'overflow: hidden;text-overflow: ellipsis;white-space: nowrap;')">
                      {{ $t('CargoMsg.Cargo_FinancialRemarks') }}
                    </div>
                  </el-col>
                  <el-col :span="10" class="red-both-top-border-w1">
                    <el-form-item label-width="0" class="el-form-item-textarea-w-full">
                      <el-input v-model="properties.invoice.remark" no="56" type="textarea" :disabled="locked" @input="markInvoiceRemarkModified" />
                      <el-input v-model="properties.invoice.remark2" no="57" type="textarea" :disabled="locked" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding-top: 5px;">
                    <el-form-item :label="$t('CargoMsg.Cargo_Payee')" class="el-form-item-w180">
                      <el-input v-model="properties.invoice.payee" no="58" :disabled="locked" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Recheck')" class="el-form-item-w180">
                      <el-input v-model="properties.invoice.auditor" no="59" :disabled="locked" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoicedBy')" class="el-form-item-w180">
                      <el-input id="txtInputBy" v-model="inputBy" no="60" :disabled="true" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_StampOfSalesUnit')" style="padding-left: 2px;" />
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <!-- 杰贝越南税控 -->
            <div v-if="properties.invoice.ar && [2,3].includes(properties.invoice.invoiceType) && properties.isEasyInoivceVietnam" id="invoiceAddValueBoard">
              <el-form label-width="160px" label-position="right" class="vatInvoiceFormVietnam">
                <el-row type="flex" :gutter="10" class="vatInvoiceForm-header">
                  <el-col :span="7" class="left" />
                  <el-col :span="10" class="center">
                    <div style="width: 100%;">
                      <span id="lbInvoiceType" style="font-size: 22px; color: red; display: block; text-align: center;">HÓA ĐƠN GIÁ TRỊ GIA TĂNG</span>
                      <span id="lbMakeType" style="font-size: 22px; color: red; display: block; text-align: center;">(VAT INVOICE)</span>
                      <span id="lbInvoiceDate" style="display: block; text-align: center;">{{ invoiceDateVietnam }}</span>
                    </div>
                  </el-col>
                  <el-col :span="7" class="right">
                    <div>
                      <el-form-item label="Ký hiệu (Serial): ">
                        <span>{{ patternVietnam }}</span>
                      </el-form-item>
                      <el-form-item label="Số (No.): ">
                        <el-input v-model="properties.invoice.invoiceNo" no="121" :disabled="!properties.invoiceNoEditable || invoiceReadonly || ['overseaBilling','internalBillInfo'].includes(viewSource) || approvalLocked" />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="18" class="vietnam-top-border-w1" style="padding: 5px 5px;">
                    <el-row :gutter="10" style="width: 100%">
                      <el-form-item label="Đơn vị bán hàng (Seller):">
                        <el-col>
                          <cargo-advance-select
                            no="122"
                            :select-type="selectTypeNames.static_data_InvoiceTitle"
                            :allow-create="true"
                            filterable
                            :cache="false"
                            :disabled="locked || ourInvoiceTitleLocked"
                            :default-value="properties.invoice.sellTitle"
                            :static-options="ourInvoiceTitleArray"
                            @parentCallBack="ourTitleChangeEvent"
                          />
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Mã số thuế (Tax code):">
                        <el-col>
                          <el-input v-model="properties.invoice.taxAccount" no="123" :disabled="locked || ourInvoiceTitleLocked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Địa chỉ (Address): ">
                        <el-col :span="18" :title="properties.invoice.address">
                          <el-input v-model="properties.invoice.address" no="124" :disabled="locked" />
                        </el-col>
                        <el-col :span="6" :title="properties.invoice.telephone">
                          <el-input v-model="properties.invoice.telephone" no="125" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                    </el-row>
                  </el-col>
                  <el-col :span="6" class="vietnam-top-border-w1" />
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="18" class="vietnam-top-border-w1" style="padding: 5px 5px;">
                    <el-row :gutter="10" style="width: 100%">
                      <el-form-item label="Họ tên người mua hàng (Buyer):" label-width="200px">
                        <el-col>
                          <el-input no="126" readonly />
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Tên đơnvị (Company's name):" label-width="200px">
                        <el-col>
                          <cargo-advance-select
                            no="127"
                            :select-type="selectTypeNames.static_data_Title"
                            :allow-create="true"
                            filterable
                            :cache="false"
                            :disabled="locked"
                            :default-value="properties.invoice.title"
                            :static-options="titleArray"
                            @parentCallBack="titleChangeEvent"
                          />
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Mã số thuế (Tax code):" label-width="200px">
                        <el-col>
                          <el-input v-model="properties.invoice.buyerTaxAccount" no="128" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item label="Địa chỉ (Address):" label-width="200px">
                        <el-col :span="18" :title="properties.invoice.buyerAddress">
                          <el-input v-model="properties.invoice.buyerAddress" no="129" :disabled="locked" />
                        </el-col>
                        <el-col :span="6" :title="properties.invoice.buyerTelephone">
                          <el-input v-model="properties.invoice.buyerTelephone" no="130" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                    </el-row>
                  </el-col>
                  <el-col :span="6" class="vietnam-top-border-w1" />
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="24" class="vietnam-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding: 5px 5px;">
                    <el-form-item label="Hình thứcthanh toán (Payment method):" label-width="230px">
                      <el-select v-model="properties.invoice.paymentMethod" no="131" style="width:175px;" :disabled="locked">
                        <el-option
                          v-for="item in InvoiceConstant.PAYMENT_METHOD_VIETNAM"
                          :key="item.code"
                          :label="item.englishName"
                          :value="item.code"
                        />
                      </el-select>
                    </el-form-item>
                    <el-form-item class="bank-mode" label-width="180px">
                      <el-select slot="label" v-model="properties.invoice.buyerBankMode" no="132" :disabled="true" @change="buyerBankModeChange">
                        <el-option label="Số tài khoản (A/C number):" :value="0" />
                        <el-option :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')" :value="1" />
                      </el-select>
                      <el-col :span="12" :title="properties.invoice.buyerBank">
                        <cargo-advance-select
                          no="133"
                          :select-type="selectTypeNames.static_data_TitleBank"
                          :allow-create="true"
                          filterable
                          :cache="false"
                          :disabled="locked"
                          tag-value="uuid"
                          :default-value="buyerBankUuid"
                          :static-options="titleBankArray"
                          @parentCallBack="getBankCusFromChild"
                        />
                      </el-col>
                      <el-col :span="10" :title="properties.invoice.buyerBankAccount">
                        <el-input v-model="properties.invoice.buyerBankAccount" no="134" :disabled="locked" />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="24" style="flex-direction: row;justify-content: flex-start;padding: 5px 5px;">
                    <el-form-item label="Remark:" label-width="100px">
                      <el-col>
                        <el-input v-model="properties.invoice.remark" no="remark" :disabled="locked" style="width:783px;" @input="markInvoiceRemarkModified" />
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="!locked" type="flex" class="vatInvoiceForm-section">
                  <el-col class="vietnam-both-top-border-w1" style="display:flex;align-items: flex-end;">
                    <el-form-item>
                      <el-radio-group v-model="properties.rbgShowChargeDetail" no="135" @change="rbgShowChargeDetailChangeHandler">
                        <el-radio label="merge" style="margin-right: 10px;">Details of Combination</el-radio>
                        <el-radio label="detail" style="margin-right: 10px;" :disabled="!properties.showChargeDetailByInvoice || approvalLocked">Show details</el-radio>
                      </el-radio-group>
                      <el-button-group>
                        <el-button no="136" @click="addInvoiceItemHandler">Add</el-button>
                        <el-button no="137" @click="removeInvoiceItemHandler">Delete</el-button>
                        <el-button v-permission="['button_ACInvoice_saveInvoiceAmount']" no="138" @click="checkInvoiceNoSaveAndCalcAmountHandler">Update</el-button>
                      </el-button-group>
                    </el-form-item>
                  </el-col></el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="vietnam-both-top-border-w1">
                    <cargo-ag-grid
                      :show-side-bar="false"
                      :grid-params.sync="vatInvoiceGrid.gridParams"
                      :grid-options="vatInvoiceGrid.gridOptions"
                      :column-defs="vatInvoiceGridColumnDefsVietnam"
                      :row-data="vatInvoiceGridRowData"
                      :auto-fit-content="false"
                      style="height:123px;width: 100%;"
                      @gridReady="params=>gridApi=params.api"
                    />
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="18" class="vietnam-left-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding: 5px 5px;">
                    <el-form-item label="Ty giá(Exchange rate):" label-width="200px">
                      <el-col>
                        <el-input v-model="rateVietnam" no="139" :disabled="true" />
                      </el-col>
                    </el-form-item>
                    <el-form-item label="Cộng tiên hàng (Sub total):" label-width="200px" style="padding-left: 120px" />
                  </el-col>
                  <el-col :span="6" class="vietnam-both-top-border-w1">
                    <el-input v-model="excludingTaxAmountVietnam" no="140" :disabled="true" style="width: 140px;" />
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="18" class="vietnam-left-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding: 5px 5px;">
                    <el-form-item label="Thué suãt GTGT(VAT rate):" label-width="200px">
                      <el-col>
                        <el-input v-model="taxRateVietnam" no="141" :disabled="true" />
                      </el-col>
                    </el-form-item>
                    <el-form-item label="Tiên thué GTGT(VAT amount):" label-width="200px" style="padding-left: 120px" />
                  </el-col>
                  <el-col :span="6" class="vietnam-both-top-border-w1">
                    <el-input v-model="taxAmountVietnam" no="142" :disabled="true" style="width: 140px;" />
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="18" class="vietnam-left-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding: 5px 5px;">
                    <el-form-item label="Töng công tien thanh toan (Total payment):" label-width="360px" style="padding-left: 315px" />
                  </el-col>
                  <el-col :span="6" class="vietnam-both-top-border-w1">
                    <el-input v-model="amountVietnam" no="143" :disabled="true" style="width: 140px;" />
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="vietnam-both-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding: 5px 5px;">
                    <el-form-item label="Số tiền viết bằng chữ (Amount in words):" label-width="250px">
                      <el-input v-model="properties.invoice.chineseAmount" no="144" :disabled="chineseAmountDisabledVietnam" style="width: 620px" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="vietnam-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding-top: 5px;">
                    <el-form-item v-if="false" label="Người mua hàng (Buyer):" label-width="200px" />
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <!-- 电子发票(增值税专用发票)、电子发票(普通发票) -->
            <div v-if="properties.invoice.ar && [6, 7].includes(properties.invoice.invoiceType)" id="invoiceFei">
              <el-form label-width="100px" label-position="right" class="vatInvoiceForm">
                <el-row type="flex" :gutter="10" class="vatInvoiceForm-header">
                  <el-col :span="7" class="left">
                    <el-form-item :label="`${$t('Invoice.invoice_makeType')}：`">
                      <span>{{ makeType }}</span>
                      <span v-if="properties.invoice.invoiceState === 1 || properties.invoice.invoiceState === 2" style="margin-left:5px;color: red; font-size: 16px;">{{ redPunch }}</span>
                    </el-form-item>
                    <el-form-item :label="`${ $t('Invoice.invoice_invoiceStatus') }：`">
                      <span>{{ isPrinted }}</span>
                      <el-input
                        v-if="properties.invoice.makeType === 0 && properties.invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code && properties.invoice.invoiceState === 2"
                        v-model="properties.invoice.cnnoticeNo"
                        :placeholder="$t('CargoMsg.Cargo_PleaseEnterScarletLetterNumber')"
                        max="20"
                        :disabled="!enabledCnnoticeNo || approvalLocked"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="10" class="center">
                    <div style="width: 100%;">
                      <span style="font-size: 22px; color: red; display: block; text-align: center;">{{ lbInvoiceType }}</span>
                      <div style="padding-top: 6px; width: 100%; border-bottom: 1px solid red;" />
                      <div style="padding-top: 3px; width: 100%; border-bottom: 1px solid red;" />
                    </div>
                  </el-col>
                  <el-col :span="7" class="right">
                    <div>
                      <el-form-item :label="$t('CargoMsg.Cargo_InvoiceNo')">
                        <el-input v-model="properties.invoice.invoiceNo" :disabled="!properties.invoiceNoEditable || invoiceReadonly || approvalLocked" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_InvoiceDate')">
                        <el-date-picker
                          v-model="properties.invoice.invoiceDate"
                          type="date"
                          :clearable="false"
                          :disabled="locked"
                          style="width: 100%;"
                          @change="invoiceDateChange"
                        />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('Invoice.PurchaserInformation') }}
                    </div>
                  </el-col>
                  <el-col :span="11" class="red-left-top-border-w1" style="padding: 5px 5px;">
                    <el-row :gutter="10" style="width: 100%">
                      <el-form-item :label="$t('CargoMsg.Cargo_Name')">
                        <el-col>
                          <cargo-advance-select
                            :select-type="selectTypeNames.static_data_Title"
                            :allow-create="!arSettlementUnitOptional || !properties.invoice.ar"
                            filterable
                            :cache="false"
                            :disabled="locked"
                            :default-value="properties.invoice.title"
                            :static-options="titleArray"
                            @parentCallBack="titleChangeEvent"
                          />
                        </el-col>
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_RegistrationNumber')">
                        <el-col>
                          <el-input v-model="properties.invoice.buyerTaxAccount" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_AddressTelNo')">
                        <el-col :span="12" :title="properties.invoice.buyerAddress">
                          <el-input v-model="properties.invoice.buyerAddress" :disabled="locked" />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.buyerTelephone">
                          <el-input v-model="properties.invoice.buyerTelephone" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item v-if="bankModeAvailable" class="bank-mode">
                        <el-select slot="label" v-model="properties.invoice.buyerBankMode" :disabled="locked" @change="buyerBankModeChange">
                          <el-option :label="$t('CargoMsg.Cargo_BankAccountNo')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')" :value="1" />
                        </el-select>
                        <el-col v-if="properties.invoice.buyerBankMode===1" :span="24" :title="properties.invoice.buyerDepositBankAccount">
                          <el-input v-model="properties.invoice.buyerDepositBankAccount" :disabled="locked" />
                        </el-col>
                        <template v-else>
                          <el-col :span="12" :title="properties.invoice.buyerBank">
                            <cargo-advance-select
                              :select-type="selectTypeNames.static_data_TitleBank"
                              :allow-create="true"
                              filterable
                              :cache="false"
                              :disabled="locked"
                              tag-value="uuid"
                              :default-value="buyerBankUuid"
                              :static-options="titleBankArray"
                              @parentCallBack="getBankCusFromChild"
                            />
                          </el-col>
                          <el-col :span="12" :title="properties.invoice.buyerBankAccount">
                            <el-input v-model="properties.invoice.buyerBankAccount" :disabled="locked" />
                          </el-col>
                        </template>
                      </el-form-item>
                      <el-form-item v-if="!bankModeAvailable" :label="$t('CargoMsg.Cargo_BankAccountNo')">
                        <!-- <el-input v-model="properties.invoice.buyerBank" style="width:184px;" /> -->
                        <el-col :span="12" :title="properties.invoice.buyerBank">
                          <cargo-advance-select
                            :select-type="selectTypeNames.static_data_TitleBank"
                            :allow-create="true"
                            filterable
                            :cache="false"
                            :disabled="locked"
                            tag-value="uuid"
                            :default-value="buyerBankUuid"
                            :static-options="titleBankArray"
                            @parentCallBack="getBankCusFromChild"
                          />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.buyerBankAccount">
                          <el-input v-model="properties.invoice.buyerBankAccount" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox v-model="properties.invoice.displayBuyer" :disabled="locked || isDisplayDisabled" style="margin-left: 4px;">{{ $t('CargoMsg.Cargo_DisplayBuyer') }}</el-checkbox>
                      </el-form-item>
                    </el-row>
                  </el-col>
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('Invoice.SellerInformation') }}
                    </div>
                  </el-col>
                  <el-col :span="11" class="red-left-top-border-w1" style="padding: 5px 5px;">
                    <el-row :gutter="10" style="width: 100%">
                      <el-form-item :label="$t('CargoMsg.Cargo_Name')">
                        <el-col>
                          <cargo-advance-select
                            :select-type="selectTypeNames.static_data_InvoiceTitle"
                            :allow-create="true"
                            filterable
                            :cache="false"
                            :disabled="locked || ourInvoiceTitleLocked"
                            :default-value="properties.invoice.sellTitle"
                            :static-options="ourInvoiceTitleArray"
                            @parentCallBack="ourTitleChangeEvent"
                          />
                        </el-col>
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_RegistrationNumber')">
                        <el-col>
                          <el-input v-model="properties.invoice.taxAccount" :disabled="locked || ourInvoiceTitleLocked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_AddressTelNo')">
                        <el-col :span="12" :title="properties.invoice.address">
                          <el-input v-model="properties.invoice.address" :disabled="locked" />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.telephone">
                          <el-input v-model="properties.invoice.telephone" :disabled="locked" />
                        </el-col>
                      </el-form-item>
                      <el-form-item v-if="bankModeAvailable" class="bank-mode">
                        <el-select slot="label" v-model="properties.invoice.sellerBankMode" :disabled="locked" @change="sellerBankModeChange">
                          <el-option :label="$t('CargoMsg.Cargo_BankAccountNo')" :value="0" />
                          <el-option :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')" :value="1" />
                        </el-select>
                        <el-col v-if="properties.invoice.sellerBankMode===1" :span="24" :title="properties.invoice.sellerDepositBankAccount">
                          <el-input v-model="properties.invoice.sellerDepositBankAccount" :disabled="locked" />
                        </el-col>
                        <template v-else>
                          <el-col :span="12" :title="getOurBankName()">
                            <cargo-advance-select
                              filterable
                              :select-type="selectTypeNames.static_data_BankAccount"
                              :cache="false"
                              :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
                              :default-value="ourBankAccountId || ''"
                              :static-options="ourBankAccountArray"
                              :disabled="locked || ourBankAccountAutoLocked"
                              options-width="450px"
                              @parentCallBack="getBankAccountFromChild"
                            />
                          </el-col>
                          <el-col :span="12" :title="properties.invoice.bankAccount">
                            <el-input v-model="properties.invoice.bankAccount" :disabled="true" />
                          </el-col>
                        </template>
                      </el-form-item>
                      <el-form-item v-if="!bankModeAvailable" :label="$t('CargoMsg.Cargo_BankAccountNo')">
                        <el-col :span="12" :title="getOurBankName()">
                          <cargo-advance-select
                            filterable
                            :select-type="selectTypeNames.static_data_BankAccount"
                            :cache="false"
                            :method-params="{officeUuid:$store.getters.currentOfficeUuid}"
                            :default-value="ourBankAccountId || ''"
                            :static-options="ourBankAccountArray"
                            :disabled="locked || ourBankAccountAutoLocked"
                            options-width="450px"
                            @parentCallBack="getBankAccountFromChild"
                          />
                        </el-col>
                        <el-col :span="12" :title="properties.invoice.bankAccount">
                          <el-input v-model="properties.invoice.bankAccount" :disabled="true" />
                        </el-col>
                      </el-form-item>
                      <el-form-item>
                        <el-checkbox v-model="properties.invoice.displaySell" :disabled="locked || isDisplayDisabled" style="margin-left: 4px;">{{ $t('CargoMsg.Cargo_DisplaySell') }}</el-checkbox>
                      </el-form-item>
                    </el-row>
                  </el-col>
                </el-row>
                <el-row v-if="!locked" type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-both-top-border-w1" style="display:flex;align-items: flex-end;">
                    <el-form-item>
                      <el-radio-group v-model="properties.rbgShowChargeDetail" :disabled="lookView" @change="rbgShowChargeDetailChangeHandler">
                        <el-radio label="merge" style="margin-right: 10px;">{{ $t('CargoMsg.Cargo_Sp18') }}</el-radio>
                        <el-radio label="detail" style="margin-right: 10px;" :disabled="!properties.showChargeDetailByInvoice || approvalLocked">{{ $t('CargoMsg.Cargo_ShowDetails') }}</el-radio>
                      </el-radio-group>
                      <el-button-group v-show="!lookView">
                        <el-button @click="addInvoiceItemHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
                        <el-button @click="removeInvoiceItemHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
                        <el-button v-permission="['button_ACInvoice_saveInvoiceAmount']" @click="checkInvoiceNoSaveAndCalcAmountHandler">{{ $t('CargoMsg.Cargo_Reflush') }}</el-button>
                      </el-button-group>
                    </el-form-item>
                  </el-col></el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-both-top-border-w1">
                    <cargo-ag-grid
                      :show-side-bar="false"
                      :grid-params.sync="vatInvoiceGrid.gridParams"
                      :grid-options="vatInvoiceGrid.gridOptions"
                      :column-defs="vatInvoiceGridColumnDefs"
                      :row-data="vatInvoiceGridRowData"
                      :auto-fit-content="false"
                      style="height:123px;width: 100%;"
                      @gridReady="params=>gridApi=params.api"
                    />
                  </el-col>
                </el-row>
                <!-- 特定约束类型 为 货物运输服务 时显示 -->
                <el-row v-if="properties.invoice.specificConstraintType === InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code" type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-both-top-border-w1">
                    <cargo-ag-grid
                      :show-side-bar="false"
                      :grid-params.sync="cargoTransportGrid.gridParams"
                      :grid-options="cargoTransportGrid.gridOptions"
                      :column-defs="cargoTransportGridColumnDefs"
                      :row-data="cargoTransportGridRowData"
                      :auto-fit-content="false"
                      style="height:123px;width: 100%;"
                      @gridReady="params=>cargoTransportGrid.gridApi=params.api"
                    />
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="4" class="red-left-top-border-w1">
                    <div class="title-horizontal">
                      {{ $t('CargoMsg.Cargo_TotalPriceWithTaxInWords') }}
                    </div>
                  </el-col>
                  <el-col :span="20" class="red-both-top-border-w1">
                    <div style="display: flex;">
                      <el-form-item label="" label-width="0" style="padding: 0 10px;">
                        <el-input v-model="properties.invoice.chineseAmount" :disabled="true" style="width: 286px;" />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_LowerCase')" label-width="50" style="display: flex;">
                        <el-input v-model="amount" :disabled="true" style="width: 140px;" />
                      </el-form-item>
                    </div>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('CargoMsg.Cargo_Remarks') }}
                    </div>
                  </el-col>
                  <el-col :span="11" class="red-left-top-border-w1" style="padding: 5px 5px;">
                    <el-form-item label-width="0" class="el-form-item-textarea-w-full">
                      <el-input v-model="properties.invoice.remark" type="textarea" :disabled="locked" @input="markInvoiceRemarkModified" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="1" class="red-left-top-border-w1">
                    <div class="title-vertical">
                      {{ $t('CargoMsg.Cargo_FinancialRemarks') }}
                    </div>
                  </el-col>
                  <el-col :span="11" class="red-both-top-border-w1">
                    <el-form-item label-width="0" class="el-form-item-textarea-w-full">
                      <el-input v-model="properties.invoice.remark2" type="textarea" :disabled="locked" />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" class="vatInvoiceForm-section">
                  <el-col class="red-top-border-w1" style="flex-direction: row;justify-content: flex-start;padding-top: 5px;">
                    <el-form-item :label="$t('CargoMsg.Cargo_Payee')" class="el-form-item-w240">
                      <el-input v-model="properties.invoice.payee" :disabled="locked" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Recheck')" class="el-form-item-w240">
                      <el-input v-model="properties.invoice.auditor" :disabled="locked" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoicedBy')" class="el-form-item-w240">
                      <el-input v-if="!openInvoicerConfig" v-model="inputBy" no="inputBy1" :disabled="true" />
                      <cargo-advance-select
                        v-if="openInvoicerConfig"
                        no="inputBy"
                        filterable
                        :select-type="selectTypeNames.static_data_User"
                        :default-value="properties.invoice.inputBy||''"
                        :disabled="locked"
                        :cache="false"
                        tag-value="userId"
                        :static-options="invoicerUsersList"
                        @parentCallBack="p=>{properties.invoice.inputBy=p.value;}"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <div v-if="!properties.invoice.ar" id="invoicePayBoard" style="padding: 10px 20px;">
              <el-form :inline="true" :label-width="$selectByLang('90px', '100px')" label-position="left">
                <div style="display: flex;flex-direction: row;">
                  <div style="flex: 1">
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_invoiceNo')" :class="$selectByLang('el-form-item-label90-w220', 'el-form-item-label100-w230')">
                        <el-input v-model="properties.invoice.invoiceNo" no="95" :disabled="invoiceReadonly" />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_invoicingDate')" class="el-form-item-date-w130">
                        <el-date-picker
                          v-model="properties.invoice.invoiceDate"
                          no="96"
                          type="date"
                          :clearable="false"
                          :disabled="locked"
                          @change="invoiceDateChange"
                        />
                      </el-form-item>
                    </div>
                    <!--开票抬头-->
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_invoiceHeader')" :class="$selectByLang('el-form-item-label90-w280', 'el-form-item-label100-w290')">
                        <!--                        <el-input v-model="properties.invoice.title" :disabled="invoiceReadonly" no="97" />-->
                        <cargo-advance-select
                          no="97"
                          :select-type="selectTypeNames.static_data_Title"
                          :allow-create="true"
                          filterable
                          :cache="false"
                          :disabled="invoiceReadonly"
                          :default-value="properties.invoice.title"
                          :static-options="customerTitles"
                          @parentCallBack="apTitleChangeEvent"
                        />
                      </el-form-item>
                    </div>
                    <!--收票抬头-->
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_ReceiptInvoiceTitle')" :class="$selectByLang('el-form-item-label90-w280', 'el-form-item-label100-w290')">
                        <cargo-advance-select
                          no="receiptInvoiceTitle"
                          :select-type="selectTypeNames.static_data_InvoiceTitle"
                          :allow-create="true"
                          filterable
                          :cache="false"
                          :disabled="invoiceReadonly"
                          :default-value="properties.invoice.receiptInvoiceTitle"
                          :static-options="ourInvoiceTitleArray"
                          @parentCallBack="apReceiptInvoiceTitleChangeEvent"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_exchangeRate')" :class="$selectByLang('el-form-item-label90-w220', 'el-form-item-label100-w230')">
                        <el-input v-model="rate" :disabled="true" no="98" />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_totalAmount')" :class="$selectByLang('el-form-item-label90-w220', 'el-form-item-label100-w230')">
                        <el-input v-model="properties.invoice.chineseAmount" :disabled="true" no="99" />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_total')">
                        <div style="display: flex">
                          <el-input-number
                            v-model="properties.invoice.amount"
                            :disabled="invoiceReadonly"
                            no="100"
                            :precision="2"
                            :step="1"
                            :min="-999999999999"
                            :max="999999999999"
                            controls-position="right"
                            @change="amountChangeHandler"
                          />
                          <el-button v-permission="['button_ACInvoice_saveInvoiceAmount']" :disabled="invoiceReadonly" @click="checkInvoiceNoSaveAndCalcAmountHandlerPayable">{{ $t('CargoMsg.Cargo_Reflush') }}</el-button>
                        </div>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_taxFreeAmount')">
                        <el-input-number
                          v-model="properties.invoice.excludingTaxAmount"
                          :disabled="invoiceReadonly"
                          no="101"
                          :precision="2"
                          :step="1"
                          :min="-999999999999"
                          :max="999999999999"
                          controls-position="right"
                          @change="taxFreeAmountChangeHandler"
                        />
                      </el-form-item>
                    </div>
                    <div v-if="(eiTaxControlInterfaceName === 'NUONUO')" class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_InvoiceNature')" :class="$selectByLang('el-form-item-label90-w220', 'el-form-item-label100-w230')">
                        <cargo-advance-select
                          no="invoiceNature"
                          filterable
                          :cache="false"
                          :disabled="invoiceReadonly"
                          :default-value="properties.invoice.invoiceNature"
                          :static-options="InvoiceConstant.INVOICE_NATURE"
                          tag-value="code"
                          :tag-name="isZh ? 'chineseName' : 'englishName'"
                          @parentCallBack="apInvoiceNatureChangeEvent"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.billingJob_taxRate')">
                        <el-input-number
                          v-model="properties.invoice.taxRate"
                          :disabled="invoiceReadonly || apTaxRateReadonly"
                          no="102"
                          :precision="2"
                          :step="1"
                          :min="0"
                          :max="100"
                          controls-position="right"
                          @change="taxRateChangeHandler"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_taxAmount')">
                        <el-input-number
                          v-model="properties.invoice.taxAmount"
                          :disabled="invoiceReadonly"
                          no="103"
                          :precision="2"
                          :step="1"
                          :min="-999999999999"
                          :max="999999999999"
                          controls-position="right"
                          @change="taxAmountChangeHandler"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_approvedBy')" :class="$selectByLang('el-form-item-label90-w220', 'el-form-item-label100-w230')">
                        <el-input v-model="properties.invoice.auditor" :disabled="true" no="104" />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_actualReceiptDate')" class="el-form-item-date-w130">
                        <el-date-picker
                          v-model="properties.invoice.actualReceiptDate"
                          :disabled="locked"
                          no="105"
                          type="date"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('Payment.paymentPeriod')" class="el-form-item-date-w130" style="padding-left: 20px;">
                        <el-date-picker
                          v-model="properties.invoice.paymentTerm"
                          :disabled="locked"
                          no="paymentTerm"
                          type="date"
                          :placeholder="incomePayDate"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Invoice.invoice_notesOnReceipt')" :class="$selectByLang('el-form-item-textarea-label90-w350', 'el-form-item-textarea-label100-w360')">
                        <el-input v-model="properties.invoice.remark" :disabled="locked" type="textarea" no="106" @input="markInvoiceRemarkModified" />
                      </el-form-item>
                      <el-form-item style="margin-left: 50px" :label="$t('CargoMsg.Cargo_FinancialRemarks')" :class="$selectByLang('el-form-item-textarea-label90-w350', 'el-form-item-textarea-label120-w380')">
                        <el-input v-model="properties.invoice.remark2" :disabled="locked" type="textarea" no="107" />
                      </el-form-item>
                    </div>
                  </div>
                </div>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane id="dgCharge" :lazy="true" :label="$t('Invoice.invoice_chargeDetails')" name="chargeDetails">
            <div class="app-main-inner-row row-grid" style="height: 450px; padding: 0;">
              <cargo-ag-grid
                v-if="visible && activeTabName==='chargeDetails'"
                :grid-params.sync="chargeGrid.gridParams"
                :grid-options="chargeGrid.gridOptions"
                :column-defs="chargeGrid.columnDefs"
                :row-data="chargeGridRowData"
                config-module="20220406"
                style="width: 100%;min-height: 450px;"
                @gridReady="onGridReady"
              />
            </div>
            <div style="display: flex; justify-content: flex-end; padding-right: 10px; font-size: 12px; background-color: #f5f7f7; flex-direction: row;">
              <span v-text="$t('Invoice.invoice_total')" />
              <charge-currency-total-group
                :key="1"
                mode="group"
                type="auto"
                source="invoiceDetail"
                data-field="amount"
                rate-field="invoiceRate"
                currency-field="currency"
                ar-field="isReceivable"
                :data-provider="chargeGridRowData"
                :amount-to-currency="properties.invoice.currency"
                :currency-conversion-in-invoices="currencyConversionInInvoices"
              />
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="!lookView" id="dgFileAttachment" :lazy="true" :label="fileAttachmentTitle" name="fileAttachment">
            <file-attachment v-if="visible" :invoice="properties.invoice" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div v-if="!isBpm" slot="footer" class="dense-btns">
        <span>
          <el-button type="primary" :disabled="!(properties.currentPage>1)" no="108" @click="btPreClickHandler">{{ $t('Invoice.invoice_theLastPage') }}</el-button>
          <el-button type="primary" :disabled="!(properties.currentPage<properties.totalPage)" no="109" @click="btNextClickHandler">{{ $t('Invoice.invoice_theNextPage') }}</el-button>
          <span style="font-size: 14px; margin-left: 6px;">{{ properties.currentPage }} / {{ properties.totalPage }}</span>
        </span>
        <cargo-button-group-slider align="right" style="flex: 1">
          <div v-show="!lookView">
            <el-button v-show="!properties.invoice.ar" v-permission="['button_ACInvoice_receiptAssociation']" type="primary" no="InvoiceAssociation" @click="showInvoicePoolDialog">{{ $t('CargoMsg.Cargo_InvoiceAssociation') }}</el-button>
            <el-button v-if="properties.invoice.ar && properties.toExoSystemYGSH && [2,3,4,6,7].includes(properties.invoice.invoiceType)" type="primary" no="110" @click="addEmailHandler">{{ $t('CargoMsg.Cargo_SupplementaryInformation') }}</el-button>
            <el-button v-show="properties.invoice.ar && [2,3,4,6,7].includes(properties.invoice.invoiceType)" type="primary" no="111" @click="updateInvoiceRemarkHandler">{{ $t('Invoice.invoice_updateRemark') }}</el-button>
            <el-button v-show="!properties.isEasyInoivceVietnam" :disabled="properties.invoice.jobSalesChannel === 'eTowerOne'" type="primary" no="112" @click="differenceAdjustmentClickHandler">{{ $t('Invoice.invoice_differenceAdjustment') }}</el-button>
            <el-button v-show="properties.invoice.ar" type="primary" no="113" @click="downloadClickHandler">{{ $t('Invoice.invoice_downLoad') }}</el-button>
            <el-button v-show="properties.invoice.ar && !properties.isEasyInoivceVietnam" type="primary" no="114" :disabled="!enableSelectInoviceNo" @click="selectInvoiceEvent">{{ $t('Invoice.invoice_selectInvoiceNo') }}</el-button>
            <el-button type="primary" :disabled="!enableSave" no="115" @click="saveHandler">{{ $t('Invoice.invoice_save') }}</el-button>
            <el-button type="danger" :disabled="!enableDelete" no="invoiceDelete" @click="deleteHandler(false)">{{ $t('Invoice.invoice_delete') }}</el-button>
            <el-button v-show="properties.invoice.ar" v-permission="['button_fmMakeInvoice_print']" type="primary" no="116" :disabled="!enablePrint" @click="printHandler">{{ $t('Invoice.invoice_print') }}</el-button>
            <el-button v-show="properties.invoice.ar" type="primary" no="117" :disabled="!enablePrint" @click="printAllHandler">{{ $t('Invoice.invoice_printAll') }}</el-button>
            <el-button v-show="properties.invoice.ar && [2,3,6,7].includes(properties.invoice.invoiceType) && !valInvoiceCodeIsEmpty" type="primary" no="119" :disabled="!enableInterfaceExport" @click="interfacePrintHandler">{{ $t('Invoice.invoice_CATISPrint') }}</el-button>
          </div>
        </cargo-button-group-slider>
        <span>
          <el-button @click="closeHandler">{{ $t('common.btn.close') }}</el-button>
        </span>
      </div>
      <template v-if="isBpm" slot="footer" style="height: 65px">
        <approval-comments-and-btns
          v-if="isBpm"
          :process-info="processInfo"
          :records="records"
          :type="type"
          :form-subtype="MAKE_INVOICE_INTERNAL_INVOICE.code"
          :application-dimension="APPLICATION_DIMENSION_MAKE_INVOICE.code"
          :dashboard-url="dashboardUrl"
          @close="$emit('close')"
          @closeAndRefresh="$emit('closeAndRefresh')"
        />
      </template>
    </el-dialog>
    <!--  差额调整弹窗页  -->
    <difference-adjustment-dialog
      v-if="adjustBalanceDialog.show"
      :visible.sync="adjustBalanceDialog.show"
      :invoice="adjustBalanceDialog.invoice"
      :rbg-show-charge-detail="adjustBalanceDialog.rbgShowChargeDetail"
      :location="location"
      @differenceAdjustmentCallBackEvent="differenceAdjustmentCallBackEvent"
    />
    <!--  选择发票号弹窗页  -->
    <invoice-no-selector-dialog
      v-if="selectInvoiceDialog.show"
      :visible.sync="selectInvoiceDialog.show"
      :invoice-type="selectInvoiceDialog.invoiceType"
      :invoice-count="selectInvoiceDialog.invoiceCount"
      @selectedInvoiceNoCallBackEvent="selectedInvoiceNoCallBackEvent"
    />
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :printed-callback="templateSelectorDialog.printedCallback"
    />
    <!-- 修改备注    -->
    <invoice-update-remark-window
      v-if="remarkUpdateWindow.show"
      :visible.sync="remarkUpdateWindow.show"
      :invoice-uuid="remarkUpdateWindow.invoiceUuid"
      @updateRemarkCallBackEvent="updateRemarkCallBackHandler"
    />
    <!-- 关联邮件 -->
    <invoice-email-window
      v-if="invoiceEmailWindow.visible"
      ref="invoiceEmailWindow"
      :visible.sync="invoiceEmailWindow.visible"
      :invoice="invoiceEmailWindow.invoice"
      :invoice-email="invoiceEmailWindow.email"
      :account-id="invoiceEmailWindow.accountId"
      @relationEmailSuccess="relationEmailCallBackHandler"
    />
    <!-- 二维码弹框 -->
    <el-dialog
      v-if="ewmDialog.visible"
      v-el-drag-dialog
      :visible.sync="ewmDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column;">
        <el-form label-width="75px" label-position="right">
          <el-form-item label-width="0">
            <div class="el-message-box__status el-icon-warning" />
            <div class="el-message-box__message">
              {{ this.$t('Invoice.WeChatScanningAgain') }}
            </div>
          </el-form-item>
          <div style="margin: 0 auto;width: fit-content;">
            <vue-qr class="vue-qr" :text="ewmDialog.ewm" :logo-scale="200" :size="200" />
          </div>
        </el-form>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button no="Certified" type="primary" :disabled="ewmDialog.time" @click="realPersonAuthentication(true)">{{ ewmDialog.time ? ($t('Invoice.Certified') + '(' + ewmDialog.time + ')') : $t('Invoice.Certified') }}</el-button>
      </div>
    </el-dialog>
    <!-- 批量提交、批量同意、批量拒绝 错误弹窗-->
    <batch-submit-or-approve-dialog
      :visible.sync="batchSubmitOrApproveDialog.visible"
      :row-data="batchSubmitOrApproveDialog.rowData"
      :is-submit="true"
    />

    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :res-data="batchCheckingWindow.resData"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
    />

    <!-- 发票池弹窗 -->
    <invoice-pool-dialog
      v-if="invoicePoolDialog.visible"
      :visible.sync="invoicePoolDialog.visible"
      :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
      @confirm="invoiceAssociationHandle"
    />
  </div>
</template>

<script>
import invoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog'
import { getGridSelected } from '@/utils/agGrid'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import StrUtils from '@/utils/StrUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import URL from '@/api/urlTranslator'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { getTitleBankList } from '@/api/partner/titleBank'
import * as NumberUtils from '@/utils/NumberUtils'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import {
  checkInvoiceNoExist2,
  updateInvoices,
  saveAmount,
  getInvoiceDetails,
  checkToVoucher,
  deleteInvoices,
  outInterfaceExport,
  outInterfaceExportEi,
  outInterfacePrint,
  outInterfaceCancel,
  taxEasyInvoiceDownLoad,
  showChargeDetailChange,
  printedInvoices,
  getInvoiceNos,
  authRecognition,
  checkExchangeRate, cancelEasyInvoice, getInvoiceCreditDetail
} from '@/api/clearing/invoice'
import { queryInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import differenceAdjustmentDialog from './differenceAdjustmentDialog'
import invoiceNoSelectorDialog from './invoiceNoSelectorDialog'
import { getToken } from '@/utils/auth'
import { ApiCacheManage } from '@/utils/commonUtil'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { Invoice } from '@/class/model/act/Invoice'
import InvoiceUpdateRemarkWindow from '@/views/cargo/v0/Clearing/components/makeInvoice/InvoiceUpdateRemarkWindow'
import invoiceEmailWindow from '@/views/cargo/v0/Clearing/components/makeInvoice/invoiceEmailWindow'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import CargoAgGridCascadeCityEditor from '@/components/Cargo/Common/CargoAgGridCascadeCityEditor'
import { getBankAccountList } from '@/api/bankAccount'
import { getInvoicerList } from '@/api/office'
import { getInvoiceTitlesByOffice, queryInvoiceTitleByOfficeFunc } from '@/api/sysManage/officeInvoiceTitle'
import fileAttachment from '@/views/cargo/v0/Clearing/components/makeInvoice/fileAttachment'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { multiply } from '@/utils/commonUtil'
import { queryLtsInvoiceFunc } from '@/api/clearing/invoice'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import OperationRender from '@/components/OperationRender'
import { getCacheListByKey, getObjectByCache } from '@/utils/basicDataCache'
import UIDUtil from '@/utils/uidUtil'
import { WorkflowUtil } from '@/class/cargo/model/utils/WorkflowUtil'
import {
  APPLICATION_DIMENSION_MAKE_INVOICE, COLLECT_INVOICE,
  MAKE_INVOICE, MAKE_INVOICE_INTERNAL_INVOICE
} from '@/class/cargo/model/parameters/WorkflowConstants'
import { workflowActionBatch } from '@/api/workflow'
import batchSubmitOrApproveDialog from '@/components/Cargo/Common/Wrokflow/batchSubmitOrApproveDialog'
import ApprovalCommentsAndBtns from '@/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns'
import { BPM_STATES_UN_APPROVED } from '@/class/cargo/model/parameters/SystemConstants'
import { Office } from '@/class/model/sys/Office'
import CargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { cache, cacheName } from '@/utils/cacheManager'
import moment from 'moment'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import { queryInvoiceChargeItem } from '@/api/clearing/invoiceChargeItem'
import { BSWarningUtil } from '@/class/cargo/model/utils/BSWarningUtil'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow'
import { checkChargeByInvoiceSaveNode } from '@/api/booking/job'
import { getDashboardUrl } from '@/api/sysManage/businessIntelligence/businessIntelligenceDashboard'
import { getLatestInvoiceRemark, getRemarkConfig } from '@/api/sysManage/baseConfig/diyInvoiceRemark'
import { InvoiceUtils } from '@/class/cargo/model/utils/InvoiceUtils'
import { getCurrency, useAmountCarryRule } from '@/class/cargo/model/utils/RateUtil'
import { getTransportServiceHistory, saveTransportServiceHistory } from '@/api/clearing/transportServiceHistory'
import { RMBBigTransForm } from '@/class/cargo/model/utils/RMBBigTransForm'

export default {
  name: 'MakeInvoiceDialog',
  components: {
    CargoUserSelect, invoicePoolDialog,
    CargoButtonGroupSlider, CargoAdvanceSelect, differenceAdjustmentDialog, invoiceNoSelectorDialog, cargoRichTextarea,
    ChargeCurrencyTotalGroup, cargoTemplateSelectorDialog, InvoiceUpdateRemarkWindow, fileAttachment, invoiceEmailWindow,
    batchSubmitOrApproveDialog, ApprovalCommentsAndBtns, BatchCheckingWindow },
  props: {
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    /**
     * params.mode: 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
     * params.paymentType: 收付方式[default:1] 1-应收开票 2-应付开票
     * params.makeInvoiceMethod: 开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单 5-付款申请模块收票弹窗
     * params.originMakeInvoiceMethod: 原始开票方式[default:1] 1-费用 2-业务 3-账单 4-对账单
     * properties.invoiceType: 发票类型[default:1] 1-普通发票 2-专用发票 3-增值税普通发票 4-增值税专用发票 5-内部发票
    params: { type: Object, required: true },*/
    properties: { type: Object, required: true },
    viewSource: { type: String, default: '' }, // 页面请求发起方
    isBpm: { type: Boolean, default: false }, // 审批事项-双击时-值为true（bpm使用）
    processInfo: { type: Object, default: () => {} }, // 审核流程
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    records: { type: Array, default: () => [] }, // 审核记录
    lastProcessNode: { type: Object, default: () => {} }, // 最新节点
    lookView: { type: Boolean, default: false }, // 仅查看
    location: { type: String, default: '' }
  },
  data() {
    return {
      ifAutoUpdateRemark: false, // 是否自动更新备注（切换 银行信息、抬头信息时 触发）
      modifiedInvoiceRemarkMap: {}, // 已手动修改备注的发票，避免切换发票时自动备注覆盖
      invoicePoolDialog: {
        visible: false
      },
      dashboardUrl: '', // 仪表盘url
      InvoiceConstant,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      activeTabName: 'makeInvoice',
      chargeGrid: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCopyRowsToClipboard: true,
          suppressRowSelection: true,
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          processCellForClipboard: this.processCellForClipboard,
          onCellClicked: this.cellEventCallback,
          pagination: false,
          defaultColDef: {
            filter: false
          }
        },
        columnDefs: [
          { headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo', width: 150 },
          { headerName: this.$t('Invoice.invoice_mblNo'), field: 'jobMbl', width: 130 },
          { headerName: this.$t('Invoice.invoice_invoiceNo'), field: 'invoiceNo', width: 130 },
          { headerName: this.$t('Invoice.invoice_vesselAndVoyage'), field: 'jobVesselFlight', width: 130 },
          { headerName: this.$t('Invoice.invoice_portOfLoading'), field: 'loadingPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            width: 120,
            filter: false,
            filterParams: {}
          },
          { headerName: this.$t('Invoice.invoice_portOfDestination'), field: 'destinationPortCode',
            cellRenderer: (params) => {
              let portName = ''
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'AE' || params.data.jobLob === 'AI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'englishName')
              } else if (params.data.jobLob === 'RE' || params.data.jobLob === 'RI') {
                portName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', params.value, 'englishName')
              }
              return (!StrUtils.isEmpty(portName)) ? portName : params.value
            },
            width: 120,
            filter: false,
            filterParams: {}
          },
          { headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 90 },
          { headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }, width: 100 },
          { headerName: this.$t('Invoice.invoice_revenueAndExpenditureType'), field: 'isReceivable',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }, width: 90 },
          { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', width: 70 },
          { headerName: this.$t('Invoice.invoice_exchangeRate'), field: 'invoiceRate',
            cellRenderer: (params) => {
              return ColumnUtils.roundHalfUp(params.value, 8)
            }, width: 90 },
          { headerName: this.$t('Invoice.invoice_unitPrice'), field: 'unitRate',
            cellRenderer: (params) => {
              return ColumnUtils.roundHalfUp(params.value, 2, '0.00')
            }, width: 80 },
          { headerName: this.$t('Invoice.invoice_quantity'), field: 'quantity', width: 80 },
          { headerName: this.$t('Invoice.invoice_amount'), field: 'amount',
            cellRenderer: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }, width: 80 },
          {
            headerName: this.$t('CargoMsg.Cargo_ChargeChanger'),
            colId: 'changer',
            field: 'changer',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxFreeAmount'),
            colId: 'excludingTaxAmount',
            field: 'excludingTaxAmount',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxRate'),
            colId: 'taxRate',
            field: 'taxRate',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_TaxAmount'),
            colId: 'taxAmount',
            field: 'taxAmount',
            initialWidth: 180,
            hide: true,
            valueFormatter: (params) => {
              return ColumnUtils.realProfitFunc(params.value)
            }
          }

        ]
      },
      vatInvoiceGrid: {
        rowData: [],
        gridParams: {},
        gridOptions: {
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor
          },
          rowSelection: 'single',
          rowHeight: 31,
          suppressCellSelection: true,
          suppressContextMenu: true,
          suppressClipboardPaste: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: false,
            resizable: false,
            menuTabs: []
          }
        }
      },
      cargoTransportGrid: { // 货物运输服务明细
        rowData: [],
        gridParams: {},
        gridApi: null,
        gridOptions: {
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridCascadeCityEditor
          },
          rowSelection: 'single',
          rowHeight: 31,
          suppressCellSelection: true,
          suppressContextMenu: true,
          suppressClipboardPaste: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          gridApi: null,
          context: {
            componentParent: this
          },
          defaultColDef: {
            sortable: false,
            resizable: false,
            menuTabs: []
          }
        }
      },
      adjustBalanceDialog: {
        show: false,
        rbgShowChargeDetail: 'merge', // 当前发票界面是否合并明细
        invoice: {}
      },
      selectInvoiceDialog: {
        show: false,
        invoiceType: 0,
        invoiceCount: 0
      },
      originalInputUserId: 0, // 原始开票人员
      invoiceEmailWindow: {
        visible: false,
        invoice: null,
        accountId: 0
      },
      mergeType: 1, // 0=展开明细，1=合并明细：(_invoice.partAmount && _invoice.partAmount.indexOf("\n") > -1)
      titleArray: [], // 购货单位名称
      titleBankArray: [], // 购货单位银行
      printFlag: 0, // 打印标识.1->打印. 2->打印所有
      invoiceGoodsNameArray: [], // 增票发票项目
      typeOfTransportArray: [], // 运输工具类型
      loading: null,
      gridApi: null,
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'INVOICE',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        },
        printedCallback: null
      },
      remarkUpdateWindow: {
        show: false,
        invoiceUuid: null
      },
      gridApi_charge: null,
      columnApi_charge: null,
      // buyerBankAccount: '', // 购货方银行账号
      buyerBankUuid: '', // 购货方银行uuid
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      ourInvoiceTitleLocked: false, // 我方抬头是否锁定
      isConfirmingSellTitleChange: false, // 销方抬头变更确认中（抑制 watcher 副作用，避免确认前触发备注/银行联动）
      autoMatchedSellerTaxAccount: '',
      lastInvoiceUuidForTitleAutoMatch: '',
      ourBankAccountArray: [], // 我方银行选项
      allOurBankAccountArray: [], // 所有我方发票抬头选项
      ourBankAccountId: 0, // 我方银行Id
      ourBankAccountAutoLocked: false, // 自动匹配到默认银行账号后，禁止手工修改
      autoMatchedOurBankAccountKey: '', // sellTitle|currency|accountId
      cityListOptions: [], // 起始地 交货地
      transportServiceHistory: { // 运输工具历史数据
        transportNumber: [],
        pol: [],
        pod: [],
        name: []
      },
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      getBankAccountListCache: new ApiCacheManage(getBankAccountList, officeUuid => officeUuid), // getBankAccountList缓存管理
      ewmDialog: { // 二维码弹框
        visible: false,
        ewm: '',
        curTime: null, // 当前倒计时
        time: 15 // 倒计时 15s
      },
      batchSubmitOrApproveDialog: {
        visible: false,
        rowData: []
      },
      invoiceIssuer: 0, // 开票员配置：0-对应开票员开票 1-所有用户共用 多抬头情况
      taxAccountMap: new Map(), // 税号对应开票员
      invoiceIssuerMap: new Map(), // 开票员标识
      customerTitles: [], // 费用结算单位的开票抬头
      bpmStatesUnApproved: BPM_STATES_UN_APPROVED.code,
      invoicerUsersList: [], // 开票员
      MAKE_INVOICE_INTERNAL_INVOICE: MAKE_INVOICE_INTERNAL_INVOICE,
      APPLICATION_DIMENSION_MAKE_INVOICE: APPLICATION_DIMENSION_MAKE_INVOICE,
      invoiceChargeItemArray: [], // 开票-费用设置
      incomePayDate: '',
      arSettlementUnitOptional: false,
      currencyConversionInInvoices: false,
      invoicesaveprompt: false,
      batchCheckingWindow: {
        lob: SystemConstants.SE.code,
        visible: false,
        jobs: [],
        resData: {},
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null
      },
      eiTaxControlInterfaceName: '',
      isNuoNuoFei: false
    }
  },
  computed: {
    url() {
      return URL
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    currentOfficeId() {
      return this.$store.getters.currentOfficeId
    },
    currentOfficeUuid() {
      return this.$store.getters.currentOfficeUuid
    },
    // 费用列表
    chargeGridRowData() {
      console.log('chargeGridRowData', this.properties)
      if (this.properties !== null && this.properties.invoice !== null) {
        if (this.properties.enableCustomizeRevokeInvoice) {
          return this.properties.invoice.chargeList
        } else {
          if (this.properties.invoice.revoked || this.properties.invoice.invoiceState === 2) {
            return this.properties.invoice.nullifyChargeList
          } else {
            return this.properties.invoice.chargeList
          }
        }
      }
      return this.chargeGrid.rowData
    },
    vatInvoiceGridColumnDefs() {
      const columnDefs = [
        { headerName: this.invoiceTypeFei ? this.$t('CargoMsg.Cargo_Project') : this.$t('CargoMsg.Cargo_DOCOTS'), field: 'goodsName', width: 150,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              allowCreate: true,
              tagValue: 'goodsName',
              tagName: 'goodsName',
              staticOptions: this.invoiceGoodsNameArray
            }
          },
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.$t('CargoMsg.Cargo_ModelSpecification'), field: 'dimension', width: 100,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.$t('CargoMsg.Cargo_Unit'), field: 'unit', width: 70,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.$t('CargoMsg.Cargo_AmountNumber'), field: 'quantity', width: 70,
          valueFormatter: params => {
            return params.value
          },
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.$t('CargoMsg.Cargo_UnitPrice'), field: 'unitRate', width: 100,
          valueFormatter: params => {
            const scale = (this.isHtxx || this.isNuoNuo) ? '0.00000000' : '0.00'
            const unitRate = this.$numeral(params.value).format(scale)
            return unitRate > 0 ? unitRate : scale
          },
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: (this.isHtxx || this.isNuoNuo) ? 8 : 2
            }
          },
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.invoiceTypeFei ? this.$t('CargoMsg.Cargo_Amount') : this.$t('CargoMsg.Cargo_TaxFreeAmount'), field: 'amount', width: 110,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: params => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceNature'), field: 'invoiceNature', width: 100,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              allowCreate: true,
              tagValue: 'code',
              tagName: this.isZh ? 'chineseName' : 'englishName',
              staticOptions: InvoiceConstant.INVOICE_NATURE
            }
          },
          hide: !(this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO),
          valueFormatter: (params) => {
            return ColumnUtils.columnLabelFunc(InvoiceConstant.INVOICE_NATURE_LIST, params.value)
          },
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxRate'), field: 'taxRate', width: 80,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => { this.onCellChange(p) }
        },
        { headerName: this.$t('CargoMsg.Cargo_TaxAmount'), field: 'taxAmount', width: 105,
          valueFormatter: params => {
            return this.$numeral(params.value).format('0.00')
          },
          editable: params => false,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_AmountTo'), field: 'sumAmount', width: 130,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false
            }
          },
          onCellValueChanged: p => { this.onCellChange(p) }
        }
      ]
      return columnDefs
    },
    // 发票项目列表
    vatInvoiceGridRowData() {
      console.log('vatInvoiceGridRowData', this.properties)
      if (this.properties !== null && this.properties.invoice !== null) {
        // CARGO-15706 圣世特 4408 开票时 无法根据填写数量自动计算不含税单价; 此时在invoiceItem需要加一个临时字段sumAmount，用来记录合计
        for (const invoiceItem of this.properties.invoice.invoiceItemList) {
          // invoiceItem.sumAmount = NumberUtils.roundHalfUp2((isNaN(invoiceItem.amount) ? 0.0 : invoiceItem.amount) + (isNaN(invoiceItem.taxAmount) ? 0.0 : invoiceItem.taxAmount), 2)
          invoiceItem.sumAmount = NumberUtils.roundHalfUp2(RateUtil.getAmountByCurrency((isNaN(invoiceItem.amount) ? 0.0 : invoiceItem.amount) + (isNaN(invoiceItem.taxAmount) ? 0.0 : invoiceItem.taxAmount), this.properties.invoice.currency), 2)
        }
        return this.properties.invoice.invoiceItemList
      }
      return this.vatInvoiceGrid.rowData
    },
    // 货物运输服务明细列表
    cargoTransportGridColumnDefs() {
      // 全电
      const columnDefs = [
        { headerName: this.$t('Invoice.TypeOfTransport'), field: 'type', width: 150, flex: 1,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              tagValue: 'code',
              tagName: 'chineseName',
              staticOptions: Array.from(InvoiceConstant.INVOICE_CARGO_TRANSPORT)
            }
          },
          cellRenderer: (params) => {
            return ColumnUtils.typeOfTransportFunction(params.value)
          },
          onCellValueChanged: p => { this.onCargoCellChange(p) }
        },
        { headerName: this.$t('Invoice.TransportVehicleBrand'), field: 'transportNumber', width: 150, flex: 1,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              tagValue: 'value',
              tagName: 'value',
              staticOptions: this.transportServiceHistory.transportNumber.map(item => ({ value: item, label: item })),
              allowCreate: true
            }
          },
          onCellValueChanged: p => { this.onCargoCellChange(p) }
        },
        { headerName: this.$t('Invoice.Origin'), field: 'pol', width: 150, flex: 1,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              tagValue: 'value',
              tagName: 'value',
              staticOptions: this.transportServiceHistory.pol.map(item => ({ value: item, label: item })),
              allowCreate: true
            }
          },
          onCellValueChanged: p => { this.onCargoCellChange(p) }
        },
        { headerName: this.$t('Invoice.Destination'), field: 'pod', width: 150, flex: 1,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              tagValue: 'value',
              tagName: 'value',
              staticOptions: this.transportServiceHistory.pod.map(item => ({ value: item, label: item })),
              allowCreate: true
            }
          },
          onCellValueChanged: p => { this.onCargoCellChange(p) }
        },
        { headerName: this.$t('Invoice.NameOfGoodsTransported'), field: 'name', width: 150, flex: 1,
          editable: params => !this.locked,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              cache: false,
              filterable: true,
              tagValue: 'value',
              tagName: 'value',
              staticOptions: this.transportServiceHistory.name.map(item => ({ value: item, label: item })),
              allowCreate: true
            }
          },
          onCellValueChanged: p => { this.onCargoCellChange(p) }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: '',
          minWidth: 150,
          flex: 1,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_NewTo'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.addCargoHandler(params)
                },
                visible: (params) => params
              }, {
                title: this.$t('CargoMsg.Cargo_OrderDelete'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.delCargoHandler(params)
                },
                visible: (params) => params
              }
            ]
          }
        }
      ]
      return columnDefs
    },
    // 货物运输服务明细
    cargoTransportGridRowData() {
      console.log('cargoTransportGridRowData', this.properties)
      if (this.properties && this.properties.invoice) {
        return this.properties.invoice.transportList || []
      }
      return this.cargoTransportGrid.rowData
    },
    approvalStatusNum() {
      const s = this.properties && this.properties.invoice ? this.properties.invoice.approvalStatus : null
      if (s === null || s === undefined || s === '') return 0
      const n = Number(s)
      return Number.isNaN(n) ? 0 : n
    },
    // Only approvalStatus=0 or -1 (BPM_STATES_UN_APPROVED) can edit/save/delete.
    approvalEditable() {
      return this.approvalStatusNum === 0 || this.approvalStatusNum === this.bpmStatesUnApproved
    },
    approvalLocked() {
      return !this.approvalEditable
    },
    // 是否只读
    locked() {
      if (this.properties !== null && this.properties.invoice !== null) {
        // approvalStatus not in {0, -1} means the whole invoice should be read-only.
        if (this.properties.invoice.printed || (this.properties.invoice.revoked && !StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo)) || this.approvalLocked) {
          return true
        }
      }
      return false
    },
    // 是否只读
    lockedWithoutBpm() {
      if (this.properties !== null && this.properties.invoice !== null) {
        if (this.properties.invoice.printed || (this.properties.invoice.revoked && !StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo))) {
          return true
        }
      }
      return false
    },
    // 原币种
    chargeCurrency() {
      return StrUtils.isEmpty(this.properties.invoice.chargeCurrency1) ? this.properties.invoice.currency : this.properties.invoice.chargeCurrency1
    },
    // 汇率
    rate() {
      const rate = StrUtils.isEmpty(this.properties.invoice.chargeCurrency1) ? this.properties.invoice.rate : this.properties.invoice.chargeExchangeRate1
      return (StrUtils.isEmpty(rate)) ? '' : rate.toFixed(8)
    },
    // 起运地
    pol() {
      let pol = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.properties.invoice.pol, 'englishName')
      if (StrUtils.isEmpty(pol)) {
        pol = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', this.properties.invoice.pol, 'englishName')
      }
      if (StrUtils.isEmpty(pol)) {
        pol = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', this.properties.invoice.pol, 'englishName')
      }
      return (!StrUtils.isEmpty(pol)) ? pol : this.properties.invoice.pol
    },
    // 卸船港
    pod() {
      let pod = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.properties.invoice.pod, 'englishName')
      if (StrUtils.isEmpty(pod)) {
        pod = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', this.properties.invoice.pod, 'englishName')
      }
      if (StrUtils.isEmpty(pod)) {
        pod = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', this.properties.invoice.pod, 'englishName')
      }
      return (!StrUtils.isEmpty(pod)) ? pod : this.properties.invoice.pod
    },
    // 目的地
    pod2() {
      let pod2 = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', this.properties.invoice.pod2, 'englishName')
      if (StrUtils.isEmpty(pod2)) {
        pod2 = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', this.properties.invoice.pod2, 'englishName')
      }
      if (StrUtils.isEmpty(pod2)) {
        pod2 = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_RailwayStation, 'code', this.properties.invoice.pod2, 'englishName')
      }
      return (!StrUtils.isEmpty(pod2)) ? pod2 : this.properties.invoice.pod2
    },
    // 发票种类
    makeType() {
      return ColumnUtils.electronicInvoiceColumnFunc(this.properties.invoice.makeType)
    },
    // 发票状态
    isPrinted() {
      return ColumnUtils.invoicePrintedLableFun(this.properties.invoice.printed ? 1 : 0)
    },
    // 红冲/被红冲
    redPunch() {
      return ColumnUtils.redPunchLableFun(this.properties.invoice.invoiceState)
    },
    // 开票人
    inputBy() {
      return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', this.properties.invoice.inputBy, 'chineseName')
    },
    // 红字通知单号
    enabledCnnoticeNo() {
      if (this.properties !== null && this.properties.invoice !== null) {
        if (!this.properties.invoice.exportToGoldenTax && StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo)) {
          return true
        }
      }
      return false
    },
    // 发票类型
    lbInvoiceType() {
      return ColumnUtils.invoiceTypeFunc(this.properties.invoice.invoiceType)
    },
    // 发票代码是否为空
    valInvoiceCodeIsEmpty() {
      return StrUtils.isEmpty(this.properties.invoice.valInvoiceCode)
    },
    // 合计金额格式
    amount() {
      const amount = this.properties.invoice.amount
      return (StrUtils.isEmpty(amount)) ? '' : amount.toFixed(2)
    },
    // 选择发票号按钮
    enableSelectInoviceNo() {
      if (this.properties !== null && this.properties.invoice !== null) {
        // (overviewPage.invoice.invoiceNo == null || overviewPage.invoice.invoiceNo.length == 0) &amp;&amp; overviewPage.invoice.selectedInvoiceNo == null
        if (StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo)) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    // 保存按钮
    enableSave() {
      if (this.approvalLocked) return false
      if (this.properties !== null && this.properties.invoice !== null) {
        // !(overviewPage.invoice.isPrinted || overviewPage.invoice.isRevoked &amp;&amp; StringUtil.trim(overviewPage.invoice.invoiceNo).length &gt; 0) || (overviewPage.invoice.makeType == 0 &amp;&amp; overviewPage.invoice.invoiceType == 3 &amp;&amp; overviewPage.invoice.invoiceState == 2  &amp;&amp; !overviewPage.invoice.isExportToGoldenTax &amp;&amp; StringUtil.trim(overviewPage.invoice.invoiceNo).length == 0)
        if (!(this.properties.invoice.printed || (this.properties.invoice.revoked && !StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo))) ||
          (this.properties.invoice.makeType === 0 && this.properties.invoice.invoiceType === 3 && this.properties.invoice.invoiceState === 2 && !this.properties.invoice.exportToGoldenTax && StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo))) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    enableDelete() {
      return this.approvalEditable && this.properties && this.properties.invoice && !StrUtils.isEmpty(this.properties.invoice.uuid)
    },
    // 打印按钮
    enablePrint() {
      if (this.properties !== null && this.properties.invoice !== null) {
        // !(overviewPage.invoice.isPrinted || overviewPage.invoice.isRevoked &amp;&amp; StringUtil.trim(overviewPage.invoice.invoiceNo).length &gt; 0)
        if (!(this.properties.invoice.printed || (this.properties.invoice.revoked && !StrUtils.isEmpty(this.properties.invoice.actualInvoiceNo)))) {
          return true
        } else {
          return false
        }
      }
      return true
    },
    // 金税导出按钮
    enableInterfaceExport() {
      if (this.properties !== null && this.properties.invoice !== null) {
        // !overviewPage.invoice.isRevoked
        if (!this.properties.invoice.revoked) {
          return true
        } else {
          return this.invoiceTypeFei
        }
      }
      return true
    },
    grid() {
      // todo: 设置表格配置项
      const chargeColumnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Clearing.BusinessNumber'),
          field: 'job_no'
        },
        {
          headerName: this.$t('Clearing.MasterBillNumber'),
          field: 'job_mbl'
        },
        {
          headerName: this.$t('Clearing.VesselVoyage'),
          field: 'job_vesselFlight'
        },
        {
          headerName: this.$t('Clearing.DeparturePort'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Clearing.DestinationPort'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Clearing.BusinessDate'),
          field: 'job.businessDate'
        },
        {
          headerName: this.$t('Clearing.CostName'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Clearing.PaymentType'),
          field: 'isReceivable'
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Clearing.TaxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Clearing.BillingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Clearing.BillingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const billingJobColumnDefs = [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Clearing.BillBusinessNumber'),
          field: 'billingNo'
        },
        {
          headerName: this.$t('Clearing.BillBusinessDate'),
          field: 'inputDate'
        },
        {
          headerName: this.$t('Clearing.MasterBillNumber'),
          field: 'mbl'
        },
        {
          headerName: this.$t('Clearing.VesselVoyage'),
          field: 'voyageFlight'
        },
        {
          headerName: this.$t('Clearing.DeparturePort'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Clearing.DestinationPort'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Clearing.CostName'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Clearing.PaymentType'),
          field: 'revenueAndExpenditureType'
        },
        {
          headerName: this.$t('Clearing.TaxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Clearing.BillingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Clearing.BillingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const billingColumnDefs = [
        // {
        //   headerName: '', width: 55, checkboxSelection: true, pinned: 'left',
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        // {
        //   headerName: '对账单/账单/业务号',
        //   field: 'billingNo'
        // },
        {
          headerName: this.$t('Clearing.BillBusinessDate'),
          field: 'inputDate'
        },
        {
          headerName: this.$t('Clearing.MasterBillNumber'),
          field: 'mbl'
        },
        {
          headerName: this.$t('Clearing.VesselVoyage'),
          field: 'voyageFlight'
        },
        {
          headerName: this.$t('Clearing.DeparturePort'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Clearing.DestinationPort'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Clearing.CostName'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Clearing.TaxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Clearing.PriceExclusiveOfTax'),
          field: 'excludingTaxAmount'
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Clearing.BillingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Clearing.BillingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const billingGroupColumnDefs = [
        // {
        //   headerName: '', width: 55, checkboxSelection: true, pinned: 'left',
        //   sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        //   headerCheckboxSelection: true
        // },
        // {
        //   headerName: '付款通知/业务号',
        //   field: 'billPaymentNo'
        // },
        {
          headerName: this.$t('Clearing.MasterBillNumber'),
          field: 'mbl'
        },
        {
          headerName: this.$t('Clearing.VesselVoyage'),
          field: 'voyageFlight'
        },
        {
          headerName: this.$t('Clearing.DeparturePort'),
          field: 'loadingPortCode'
        },
        {
          headerName: this.$t('Clearing.DestinationPort'),
          field: 'destinationPortCode'
        },
        {
          headerName: this.$t('Clearing.CostName'),
          field: 'chargeItemId'
        },
        {
          headerName: this.$t('Clearing.PaymentType'),
          field: 'revenueAndExpenditureType'
        },
        {
          headerName: this.$t('Clearing.TaxIncludedPrice'),
          field: 'amount'
        },
        {
          headerName: this.$t('Clearing.Currency'),
          field: 'currency'
        },
        {
          headerName: this.$t('Clearing.BillingExchangeRate'),
          field: 'invoiceRate'
        },
        {
          headerName: this.$t('Clearing.BillingAmount'),
          field: 'invoiceAmount2'
        }
      ]
      const gridOptionsType1 = {
        rowSelection: 'single',
        suppressCellSelection: true,
        pagination: false
      }
      const gridOptionsType2 = {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('Clearing.BillBusinessNumber'),
          field: 'billingNo',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        }
      }
      let columnDefs = []
      let gridOptions = {}
      switch (this.params.makeInvoiceType) {
        case 1: columnDefs = [...chargeColumnDefs]
          gridOptions = { ...gridOptionsType1 }
          break
        case 2: columnDefs = [...billingJobColumnDefs]
          gridOptions = { ...gridOptionsType1 }
          break
        case 3: columnDefs = [...billingColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          break
        case 4: columnDefs = [...billingGroupColumnDefs]
          gridOptions = { ...gridOptionsType2 }
          gridOptions.autoGroupColumnDef.field = 'billPaymentNo'
          break
      }
      return { columnDefs, gridOptions }
    },
    fileAttachmentTitle() {
      return this.title === this.$t('Invoice.invoice_invoiceInformation') ? this.$t('CargoMsg.Cargo_Attachment') : this.$t('CargoMsg.Cargo_AttachmentInvoice')
    },
    // 百旺金穗云
    isBwjsy() {
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY
    },
    // 百旺金穗云全电、诺诺全电、容津全电使用，其它接口置灰处理【阳光速航无需这两个字段】
    isDisplayDisabled() {
      return this.properties.interfaceNameEI !== InvoiceConstant.INVOICE_BWJSY && this.properties.interfaceNameEI !== InvoiceConstant.INVOICE_NUONUO && this.properties.interfaceNameEI !== InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS
    },
    isHtxx() { // 航天信息
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_HTXX || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX
    },
    isNuoNuo() { // 诺诺全电
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
    },
    // 银行账号模式可用
    bankModeAvailable() {
      return this.properties.invoice.ar && (this.properties.invoice.invoiceType === 2 || this.properties.invoice.invoiceType === 3)
    },
    // 发票号是否只读
    invoiceReadonly() {
      if (this.viewSource === 'tabInvoiceQuery') {
        const invoice = this.properties.invoice
        const flag = invoice.invoiceState === 3 || invoice.invoiceState === 4 || invoice.review || (invoice.chargeList && invoice.chargeList.findIndex(p => p.voucherInvoice) > -1) || (!!invoice.approvalStatus && invoice.approvalStatus !== BPM_STATES_UN_APPROVED.code)
        if (invoice.ar) {
          return flag || invoice.exportToGoldenTax || invoice.printed
        } else {
          return flag
        }
      }
      return false
    },
    // 收票，税率是否可以修改
    apTaxRateReadonly() {
      return this.properties.invoice.invoiceNature && this.properties.invoice.invoiceNature !== InvoiceConstant.INVOICE_NATURE_NORMAL.code
    },
    invoiceTypeFei() { // 全电发票类型
      return [6, 7].includes(this.properties.invoice.invoiceType)
    },
    isAisinoEi() { // 航信全电
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI
    },
    isFei() { // 是否支持全电
      return this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.isAisinoEi || this.properties.toExoSystemYGSH
    },
    openInvoicerConfig() { // 开票员配置
      const office = this.$store.getters.currentOffice
      // 多抬头情况下
      if (office.titleMode === 1) {
        return this.invoiceIssuer && this.isFei
      }
      return this.$store.getters.currentOffice.invoicerConfig === 1 && this.isFei
    },
    invoiceDateVietnam() {
      if (this.properties.invoice.invoiceDate) {
        const invoiceDate = this.properties.invoice.invoiceDate
        return 'Ngày (Date)  ' + moment(invoiceDate).format('DD') + ' tháng (month)  ' + moment(invoiceDate).format('MM') + ' năm (year)  ' + moment(invoiceDate).format('yyyy')
      }
      return ''
    },
    patternVietnam() {
      if (this.properties.invoice.branchId) {
        const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', this.properties.invoice.branchId)
        if (office && office.authorizationCodeEi) return office.authorizationCodeEi
      }
      return '1C23TVN'
    },
    companyNameVietnam() {
      if (this.properties.invoice.accountId) {
        return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', this.properties.invoice.accountId, 'chineseName')
      }
      return ''
    },
    vatInvoiceGridColumnDefsVietnam() {
      const columnDefs = [
        { headerName: 'STT(No.)', field: '', width: 80,
          children: [
            { headerName: '\u3000（1）', field: 'level', initialWidth: 80, minWidth: 80,
              cellStyle: { textAlign: 'right' }
            }
          ]
        }
      ]
      // 显示明细
      if (this.properties.rbgShowChargeDetail === 'detail') {
        const self = this
        columnDefs.push({ headerName: 'Tên hàng hóa, dịch vụ(Description)', field: '', width: 220,
          children: [
            { headerName: '\u3000\u3000\u3000\u3000\u3000（2）', field: 'goodsName', initialWidth: 220, minWidth: 220,
              editable: params => !this.locked,
              cellEditor: 'CargoAgGridCommonInputEditor',
              tooltipValueGetter: (params) => { return self.goodsNameVietnamTipFunc(params.value) },
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ]
        })
      } else {
        columnDefs.push({ headerName: 'Tên hàng hóa, dịch vụ(Description)', field: '', width: 220,
          children: [
            { headerName: '\u3000\u3000\u3000\u3000\u3000（2）', field: 'goodsName', initialWidth: 220, minWidth: 220,
              editable: params => !this.locked,
              cellEditor: 'CargoAgGridAdvanceSelectEditor',
              cellEditorParams: {
                selectProps: {
                  cache: false,
                  filterable: true,
                  allowCreate: true,
                  tagValue: 'goodsName',
                  tagName: 'goodsName',
                  staticOptions: this.invoiceGoodsNameArray
                }
              },
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ]
        })
      }
      columnDefs.push(...[
        { headerName: 'Đơn vị tính(Unit)', field: '', width: 130,
          children: [
            { headerName: '\u3000\u3000（3）', field: 'unit', initialWidth: 130, minWidth: 130,
              cellStyle: { textAlign: 'center' },
              editable: params => !this.locked,
              cellEditor: 'CargoAgGridCommonInputEditor',
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ]
        },
        { headerName: 'Số lượng(Quantity)', field: '', width: 140,
          children: [
            { headerName: '\u3000\u3000（4）', field: 'quantity', initialWidth: 140, minWidth: 140,
              cellStyle: { textAlign: 'right' },
              valueFormatter: params => {
                return params.value
              },
              editable: params => !this.locked,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false
                }
              },
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ]
        },
        { headerName: 'Đơn giá(Unit price)', field: '', width: 140,
          children: [
            { headerName: '\u3000\u3000（5）', field: 'unitRate', initialWidth: 140, minWidth: 140,
              cellStyle: { textAlign: 'right' },
              valueFormatter: params => {
                const scale = (this.isHtxx || this.isNuoNuo) ? '0.00000000' : '0.00'
                const unitRate = this.$numeral(params.value).format(scale)
                return unitRate > 0 ? unitRate : scale
              },
              editable: params => !this.locked,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: (this.isHtxx || this.isNuoNuo) ? 8 : 2
                }
              },
              onCellValueChanged: p => { this.onCellChange(p) }
            }
          ]
        },
        { headerName: 'Thành tiền trước thuế(Amount)', field: '', width: 180,
          children: [
            { headerName: '\u3000（6）=（4）×（5）', field: 'amount', initialWidth: 180, minWidth: 180,
              cellStyle: { textAlign: 'right' },
              valueFormatter: params => {
                return this.$numeral(params.value).format('0.00')
              },
              editable: params => false,
              cellEditor: 'CargoAgGridCommonInputEditor',
              cellEditorParams: {
                isNumber: true,
                inputProps: {
                  controls: false,
                  precision: 2
                }
              }
            }
          ]
        }
      ])
      return columnDefs
    },
    localCurrency() {
      if (this.properties.invoice.currency) return RateUtil.localCurrencyByOfficeId(this.properties.invoice.branchId)
      return ''
    },
    // 显示外币
    currencyVietnam() {
      if (this.properties.invoice.currency && this.properties.invoice.currency !== this.localCurrency) {
        return ' ' + this.properties.invoice.currency
      }
      return ''
    },
    rateVietnam() {
      if (this.currencyVietnam && this.properties.invoice.rate) {
        const rate = CurrencyUtil.truncateRateByCurrency(this.properties.invoice.currency, this.properties.invoice.rate)
        return rate + ' (' + this.properties.invoice.currency + '/' + this.localCurrency + ')'
      }
      return ''
    },
    amountVietnam() {
      const amount = this.properties.invoice.amount
      return StrUtils.isEmpty(amount) ? '0' : NumberUtils.formatNumberByCurrency(amount, 2, this.properties.invoice.currency) + this.currencyVietnam
    },
    excludingTaxAmountVietnam() {
      const excludingTaxAmount = this.properties.invoice.excludingTaxAmount
      return StrUtils.isEmpty(excludingTaxAmount) ? '0' : NumberUtils.formatNumberByCurrency(excludingTaxAmount, 2, this.properties.invoice.currency) + this.currencyVietnam
    },
    taxRateVietnam() {
      const taxRate = this.properties.invoice.taxRate
      return (StrUtils.isEmpty(taxRate) ? '0' : taxRate) + '%'
    },
    taxAmountVietnam() {
      const taxAmount = this.properties.invoice.taxAmount
      return StrUtils.isEmpty(taxAmount) ? '0' : NumberUtils.formatNumberByCurrency(taxAmount, 2, this.properties.invoice.currency) + this.currencyVietnam
    },
    chineseAmountDisabledVietnam() {
      return !StrUtils.isEmpty(this.properties.invoice.invoiceNo)
    },
    // CARGO-46482 点击保存或关闭，取消“发票号未录入，确认关闭窗口吗”提示 只控制 应收发票
    invoicesavepromptAndAr() {
      return this.invoicesaveprompt && this.properties.invoice.ar
    }
  },
  watch: {
    // visible(newVal, oldVal) {
    //   this.innerVisible = newVal
    // },
    // innerVisible(newVal, oldVal) {
    //   this.$emit('update:visible', newVal)
    // }
    visible(newVal) {
      if (newVal) {
        this.properties.invoice.incomePayDate = ''
        this.invoiceDateChange()
        if (this.properties.invoices.length === 0) {
          return
        }
        const invoiceMap = new Map()
        for (const invoice of this.properties.invoices) {
          invoice.incomePayDate = ''
          invoiceMap.set(invoice.uuid, invoice)
        }
        getInvoiceCreditDetail({ keys: [...invoiceMap.keys()] }).then(res => {
          for (const item of res.data) {
            const invoice = invoiceMap.get(item.invoiceUuid)
            if (invoice) {
              invoice.incomePayDate = item.incomePayDate
            }
          }
        })
        this.initIfAutoUpdateRemark()
        // 打开弹窗时尝试按销售方抬头 + 币种自动匹配默认我方银行，并在匹配成功后锁定不可修改
        if (this.ourBankAccountArray && this.ourBankAccountArray.length > 0) {
          this.bringDefaultOurBankAccount()
        }
      }
    },
    'properties.invoice.incomePayDate': {
      immediate: true,
      handler(newVal) {
        this.incomePayDate = newVal ? newVal.substr(0, 10) : ''
      }
    },
    'properties.invoice.sellTitle': {
      handler() {
        if (!this.visible) return
        // 销方抬头变更确认流程中，由 applyOurTitleChange 统一触发联动，此处跳过避免重复/提前执行
        if (this.isConfirmingSellTitleChange) return
        this.initOurBankAccountArray()
        this.bringDefaultOurBankAccount()
      }
    },
    'properties.invoice.currency': {
      handler() {
        if (!this.visible) return
        this.bringDefaultOurBankAccount()
      }
    },
    'properties.invoice.chargeCurrency1': {
      handler() {
        if (!this.visible) return
        this.bringDefaultOurBankAccount()
      }
    },
    currentOfficeId: {
      immediate: true,
      async handler(newVal) {
        // 获取发票抬头列表
        const res = await this.getInvoiceTitlesByOfficeCache.execute({ officeId: newVal })
        if (newVal === this.currentOfficeId) {
          this.ourInvoiceTitleArray = res.data || []
          // 抬头列表变化会影响可选银行范围，顺带刷新并尝试自动匹配默认银行
          this.initOurBankAccountArray()
          if (this.visible) {
            this.bringDefaultOurBankAccount()
          }
        }
      }
    },
    currentOfficeUuid: {
      immediate: true,
      handler(newVal) {
        if (this.approvalEditable) {
          // 获取银行列表
          this.getBankAccountListCache.execute(newVal).then(res => {
            if (newVal === this.currentOfficeUuid) {
              this.allOurBankAccountArray = res.data
              this.initOurBankAccountArray()
              if (this.visible) {
                this.bringDefaultOurBankAccount()
              }
            }
          })
          // 获取开票员
          this.getInvoicerUsersList()
        }
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    console.log('created()', this.properties)
    // // 初始化银行列表
    // this.ourBankAccountArray = await getBankAccountList(this.$store.getters.currentOfficeUuid).then(res => res.data)
    this.invoicesaveprompt = Number(cache.config.get('invoicesaveprompt')) === 1 // 是否关闭发票号保存提示 CARGO-46482 点击保存或关闭，取消“发票号未录入，确认关闭窗口吗”提示
    this.arSettlementUnitOptional = Number(cache.config.get('ArSettlementUnitOptional')) === 1
    this.currencyConversionInInvoices = Number(cache.config.get('CurrencyConversionInInvoices')) === 1
    this.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
  },
  mounted() {
    // 初始化数据
    // this.fetchData()
    // this.activeTabName = 'makeInvoice'
    // // 开票抬头
    // console.log('mounted', this.properties)
    // this.queryTitleList(this.properties.invoice.accountId)
    // this.toQueryInvoiceGoodsName()
  },
  methods: {
    // Log helper removed: keep code clean after debugging.
    // (Previously used for invoice title auto-match troubleshooting.)
    isApprovalEditableStatus(status) {
      if (status === null || status === undefined || status === '') return true
      const n = Number(status)
      if (Number.isNaN(n)) return true
      return n === 0 || n === this.bpmStatesUnApproved
    },
    async initIfAutoUpdateRemark() {
      // 初始化 自动更新备注 标识
      this.ifAutoUpdateRemark = false
      await cache.load(cacheName.CONFIG)
      if (cache.config.get('InvoiceRemarkConfig') === '0') {
        getRemarkConfig(this.currentOfficeId).then(result => {
          if (result.data !== null) {
            this.ifAutoUpdateRemark = result.data.ifAutoUpdateRemark || false
          }
        })
      }
    },
    // 初始化 我方银行下拉
    initOurBankAccountArray() {
      if (this.$store.getters.currentOffice.multiTitleBankMode) {
        if (this.allOurBankAccountArray && this.allOurBankAccountArray.length > 0) {
          const officeInvoiceTitle = this.ourInvoiceTitleArray.find(p => p.invoiceTitle === this.properties.invoice.sellTitle)
          // 名称 未填写时，或是填写的是未维护的抬头时，银行 下拉 取 所有未绑定的抬头的银行；
          // 名称填写是已维护的抬头，但是抬头未绑定任何银行， 银行 下拉 取 所有未绑定的抬头的银行；
          // 名称填写是已维护的抬头，抬头已绑定银行， 银行 下拉 取 所有未绑定的抬头的银行，和已绑定当前抬头的 银行。
          this.ourBankAccountArray = this.allOurBankAccountArray.filter(p => !p.officeInvoiceTitleUuid || (officeInvoiceTitle && officeInvoiceTitle.uuid === p.officeInvoiceTitleUuid))
        }
      } else {
        this.ourBankAccountArray = this.allOurBankAccountArray
      }
    },
    // 带出 默认我方银行
    bringDefaultOurBankAccount() {
      console.log('bringDefaultOurBankAccount', this.ourBankAccountArray)
      const currency = this.properties.invoice.chargeCurrency1 ? this.properties.invoice.chargeCurrency1 : this.properties.invoice.currency
      if (StrUtils.isEmpty(currency) || !this.ourBankAccountArray || this.ourBankAccountArray.length === 0) {
        this.resetAutoMatchedOurBankAccount()
        return
      }

      const targetBank = this.findDefaultOurBankAccountByTitleAndCurrency(currency)
      if (!targetBank) {
        this.resetAutoMatchedOurBankAccount()
        return
      }

      // 匹配上默认值后：自动带出银行信息，并锁定不可修改
      const sellTitle = this.properties.invoice.sellTitle || ''
      const accountId = targetBank.accountId || ''
      const nextKey = `${sellTitle}|${currency}|${accountId}`
      this.ourBankAccountAutoLocked = true
      this.autoMatchedOurBankAccountKey = nextKey

      // 避免反复触发带出逻辑（例如 watcher 多次执行）
      if (this.ourBankAccountId !== targetBank.accountId || this.properties.invoice.bankAccount !== targetBank.accountNo) {
        this.getBankAccountFromChild(targetBank)
      }
    },
    resetAutoMatchedOurBankAccount() {
      this.ourBankAccountAutoLocked = false
      this.autoMatchedOurBankAccountKey = ''
    },
    findDefaultOurBankAccountByTitleAndCurrency(currency) {
      const matchDefaultFlag = (bank) => {
        return bank.defaultReceive && bank.currency === currency
      }

      if (!currency) {
        return null
      }

      const office = this.$store.getters.currentOffice
      if (!office.multiTitleBankMode) {
        const targetBanks = this.ourBankAccountArray.filter(p => p.currency === currency && matchDefaultFlag(p))
        return targetBanks && targetBanks.length > 0 ? targetBanks[0] : null
      }

      const officeInvoiceTitle = this.ourInvoiceTitleArray.find(p => p.invoiceTitle === this.properties.invoice.sellTitle)

      // 名称 未填写时，或是填写的是未维护的抬头时：只匹配未绑定抬头的银行
      if (officeInvoiceTitle == null) {
        const targetBanks = this.ourBankAccountArray.filter(p => !p.officeInvoiceTitleUuid && p.currency === currency && matchDefaultFlag(p))
        return targetBanks && targetBanks.length > 0 ? targetBanks[0] : null
      }

      const boundBanks = this.ourBankAccountArray.filter(p => p.officeInvoiceTitleUuid === officeInvoiceTitle.uuid)
      if (!boundBanks || boundBanks.length === 0) {
        // 切换抬头时，如果该抬头没有维护默认银行，则保持可编辑（不回退到“未绑定抬头”的默认银行）
        return null
      }

      // 该抬头已绑定银行：匹配已绑定当前抬头的默认银行
      const targetBanks = boundBanks.filter(p => p.currency === currency && matchDefaultFlag(p))
      return targetBanks && targetBanks.length > 0 ? targetBanks[0] : null
    },
    showInvoicePoolDialog() {
      if (this.properties.invoice.chargeList && this.properties.invoice.chargeList.length > 0) {
        this.invoicePoolDialog.sellerTaxNameDefaultValue = this.properties.invoice.chargeList[0].invoiceTitle
      }
      this.invoicePoolDialog.visible = true
    },
    // 收票关联（关联发票池中发票）
    invoiceAssociationHandle(invoicePool) {
      this.properties.invoice.invoicePoolUuid = invoicePool.uuid
      this.properties.invoice.invoiceNo = invoicePool.invoiceNo
      this.properties.invoice.invoiceDate = invoicePool.invoiceTime
      // 开票抬头
      this.properties.invoice.title = invoicePool.sellerTaxName
      // 收票抬头
      this.properties.invoice.receiptInvoiceTitle = invoicePool.payerName
      // 合计
      this.properties.invoice.amount = invoicePool.totalAmount || 0
      // 不含税额
      this.properties.invoice.excludingTaxAmount = invoicePool.exTaxAmount || 0
      // 税额
      this.taxFreeAmountChangeHandler(this.properties.invoice.excludingTaxAmount, true)
      // 实际收票日期
      this.properties.invoice.actualReceiptDate = new Date()
      // 购方税号
      this.properties.invoice.buyerTaxAccount = invoicePool.payerTaxNo
      // 销方税号
      this.properties.invoice.taxAccount = invoicePool.sellerTaxNo
      // 税率标识
      this.properties.invoice.invoiceNature = InvoiceConstant.INVOICE_NATURE_NORMAL.code
    },
    async initBaseData() {
      this.buyerBankUuid = ''
      this.titleBankArray = []
      // Auto-match state should be per-invoice; otherwise after delete/re-create it may stay "locked"
      // and skip re-applying the correct seller tax account / sellTitle.
      const invoiceUuid = this.properties && this.properties.invoice ? (this.properties.invoice.uuid || '') : ''
      if (invoiceUuid !== this.lastInvoiceUuidForTitleAutoMatch) {
        this.ourInvoiceTitleLocked = false
        this.autoMatchedSellerTaxAccount = ''
        this.lastInvoiceUuidForTitleAutoMatch = invoiceUuid
      }
      // 获取银行列表
      const office = await Office.getOfficeById(this.properties.invoice.branchId)
      await this.getBankAccountListCache.execute(office.uuid).then(res => {
        this.allOurBankAccountArray = res.data
        this.initOurBankAccountArray()
      })
      console.log('initBaseData', 'makeInvoiceDialog.initBaseData')
      this.activeTabName = 'makeInvoice'
      this.originalInputUserId = this.properties.invoice.inputBy
      this.toQueryInvoiceGoodsName()
      this.toQueryInvoiceChargeItem()
      this.getOurBankAccountId()
      this.getInvoicerUsersList()
      /* 从缓存中获取银行账号模式 */
      let buyerBankModeModified = false
      let sellerBankModeModified = false
      if (this.bankModeAvailable) {
        if (LocalStorageUtilsNew.hasConfiguration('buyerBankMode')) {
          const buyerBankMode = LocalStorageUtilsNew.getConfiguration('buyerBankMode')
          if (this.properties.invoice.buyerBankMode !== buyerBankMode) {
            this.properties.invoice.buyerBankMode = buyerBankMode
            buyerBankModeModified = true
          }
        }
        if (LocalStorageUtilsNew.hasConfiguration('sellerBankMode')) {
          const sellerBankMode = LocalStorageUtilsNew.getConfiguration('sellerBankMode') || 0
          if (this.properties.invoice.sellerBankMode !== sellerBankMode) {
            this.properties.invoice.sellerBankMode = sellerBankMode
            sellerBankModeModified = true
          }
        }
      }

      // 开票抬头 / 我方抬头 自动匹配：统一从一个入口处理，避免到处触发导致状态错乱
      await this.refreshTitleAutoMatch('initBaseData')

      // 初始化开票抬头、收票抬头
      this.customerTitles = []
      if (!this.properties.invoice.ar && this.properties.invoice.chargeList && this.properties.invoice.chargeList.length > 0) {
        await InvoiceUtils.initTitlesMap(this.properties.invoice.chargeList, this)
      }
      /* 银行账号change处理 */
      if (buyerBankModeModified) {
        this.buyerBankModeChange()
      }
      if (sellerBankModeModified) {
        this.sellerBankModeChange()
      }

      // CARGO-31753 应付收票 实际收票日期默认当天
      if (!this.properties.invoice.ar && !this.properties.invoice.invoiceNo && this.viewSource !== 'tabInvoiceQuery') {
        this.properties.invoice.actualReceiptDate = new Date()
      }

      if (this.properties.invoice.specificConstraintType === InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code) {
        // 如果没有运输服务明细，默认加一条
        if (!this.properties.invoice.transportList || this.properties.invoice.transportList.length <= 0) {
          this.addCargoHandler()
        }
        this.cityListOptions = this.initCityList()
        // 加载运输工具历史数据
        this.loadTransportServiceHistory()
      }

      // 判断是否配置仪表盘ID
      if (this.isBpm && this.lastProcessNode && this.lastProcessNode.dashboardId && this.properties.invoice && this.properties.invoice.invoiceNo) {
        const paramsDashboard = {}
        paramsDashboard.anyInteger = this.lastProcessNode.dashboardId
        paramsDashboard.branchId = this.$store.getters.currentOfficeId
        paramsDashboard.anyStr = 'invoice_no' // 参数名称
        paramsDashboard.anyStr1 = this.properties.invoice.invoiceNo // 参数值
        // paramsDashboard.anyStr2 = 'invoice_uuid' // 参数名称
        // paramsDashboard.anyStr3 = this.properties.invoice.uuid // 参数值
        if (this.$store.getters.env !== 'prod') {
          // 方便测试
          paramsDashboard.anyStr1 = '1000001'
        }
        await getDashboardUrl(paramsDashboard).then(res => {
          this.dashboardUrl = res.data
        })
      }
    },
    isInvoiceAlreadyInvoiced() {
      const invoice = this.properties && this.properties.invoice ? this.properties.invoice : null
      if (!invoice) return false
      // invoiceState: 0=未开票, 1=部分开票, 2=全部开票
      if (Number(invoice.invoiceState) === Number(InvoiceConstant.INVOICE_STATE_FULL.code)) return true
      // Some tenants use actualInvoiceNo as the "issued" marker.
      if (!StrUtils.isEmpty(invoice.actualInvoiceNo)) return true
      return false
    },
    async refreshTitleAutoMatch(reason = '') {
      const invoice = this.properties && this.properties.invoice ? this.properties.invoice : null
      const accountId = invoice ? invoice.accountId : null
      const isInvoiced = this.isInvoiceAlreadyInvoiced()

      // Prefer buyer title from selected charges (chargeInvoiceTitle) when creating invoices.
      // Only apply when it is unambiguous (all selected charges share the same non-empty title).
      let usedChargeInvoiceTitle = false
      if (invoice && !isInvoiced && StrUtils.isEmpty(invoice.title)) {
        const titleSet = new Set()
        const chargeList = invoice.chargeList || []
        for (const c of chargeList) {
          const t = String((c && c.chargeInvoiceTitle) || '').trim()
          if (!StrUtils.isEmpty(t)) titleSet.add(t)
        }
        if (titleSet.size === 1) {
          invoice.title = Array.from(titleSet)[0]
          usedChargeInvoiceTitle = true
        }
      }

      // Load buyer title options and ensure invoice.title is a maintained option when possible.
      // 已开票：仅反显（不覆盖/不自动带出）；未开票：允许自动带出默认值
      await this.queryTitleList(accountId, {
        autofillBuyerTitle: !isInvoiced,
        // If invoice.title comes from chargeInvoiceTitle (free-text), don't overwrite it.
        overwriteBuyerTitleIfNotFound: !isInvoiced && !usedChargeInvoiceTitle,
        fillBuyerFieldsWhenMissing: !isInvoiced
      })

      // Ensure our invoice title options are ready for matching.
      if (!this.ourInvoiceTitleArray || this.ourInvoiceTitleArray.length === 0) {
        try {
          const officeId = this.currentOfficeId
          const res = await this.getInvoiceTitlesByOfficeCache.execute({ officeId })
          this.ourInvoiceTitleArray = res && res.data ? res.data : []
        } catch (e) {
          this.ourInvoiceTitleArray = this.ourInvoiceTitleArray || []
        }
      }

      // 校验锁定：如果 sellTitle 与 buyer title 推导结果一致，锁定 ourInvoiceTitleLocked
      this.verifyAndLockSellTitle()
    },
    /**
     * 校验当前 sellTitle 是否与 buyer title → sellerTaxAccount 推导结果一致。
     * 如果一致，锁定 ourInvoiceTitleLocked，防止后续任何逻辑覆盖。
     * 不一致时不锁定（保留用户手动修改的可能性）。
     */
    verifyAndLockSellTitle() {
      if (!this.properties || !this.properties.invoice) return
      if (!this.ourInvoiceTitleArray || this.ourInvoiceTitleArray.length === 0) return
      if (StrUtils.isEmpty(this.properties.invoice.sellTitle)) return

      const sellerTaxAccount = this.getSellerTaxAccountFromBuyerTitle()
      if (StrUtils.isEmpty(sellerTaxAccount)) return

      const matchedTitle = this.ourInvoiceTitleArray.find(item => item.taxAccount === sellerTaxAccount)
      if (matchedTitle && this.properties.invoice.sellTitle === matchedTitle.invoiceTitle) {
        // sellTitle 与推导结果一致，锁定
        this.ourInvoiceTitleLocked = true
        this.autoMatchedSellerTaxAccount = sellerTaxAccount
      }
    },
    getSellerTaxAccountFromBuyerTitle() {
      if (!this.titleArray || this.titleArray.length === 0) {
        return ''
      }
      const buyerTitle = this.properties && this.properties.invoice ? this.properties.invoice.title : ''
      if (!buyerTitle) {
        return ''
      }
      const matched = this.titleArray.find(item => item.title === buyerTitle)
      if (matched && matched.sellerTaxAccount) {
        return matched.sellerTaxAccount
      }
      return ''
    },
    // 我方发票抬头下拉选择时，相关处理
    ourTitleChangeEvent(obj) {
      const oldSellTitle = this.properties.invoice.sellTitle || ''
      const newSellTitle = obj.value || ''
      // 仅当原值非空且发生实际变更时，才弹出确认（首次选择/选回原值 不弹）
      if (oldSellTitle && newSellTitle !== oldSellTitle) {
        // 先同步下拉显示，同时抑制 watcher 副作用，避免确认前联动银行/备注
        this.isConfirmingSellTitleChange = true
        this.properties.invoice.sellTitle = newSellTitle
        this.$confirm(this.$t('CargoMsg.Cargo_SellTitleChangeTip'), this.$t('CargoMsg.Cargo_SellTitleChangeTitle'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning',
          closeOnClickModal: false
        }).then(() => {
          // 确认：清除备注手动修改标记，确保备注随抬头变更而更新
          this.isConfirmingSellTitleChange = false
          this.clearInvoiceRemarkModified()
          this.applyOurTitleChange(obj)
        }).catch(() => {
          // 取消：还原销方抬头（触发组件 defaultValue watcher 回显旧值）
          this.properties.invoice.sellTitle = oldSellTitle
          this.$nextTick(() => {
            this.isConfirmingSellTitleChange = false
          })
        })
        return
      }
      this.applyOurTitleChange(obj)
    },
    // 执行销方抬头变更的实际逻辑（更新抬头相关字段、银行、备注）
    applyOurTitleChange(obj) {
      this.properties.invoice.sellTitle = obj.value
      if (obj.uuid) {
        this.properties.invoice.taxAccount = obj.taxAccount
        this.properties.invoice.address = obj.invoiceAddress
        this.properties.invoice.telephone = obj.phone
        if (obj.payee) {
          this.properties.invoice.payee = obj.payee
        }
        if (obj.auditor) {
          this.properties.invoice.auditor = obj.auditor
        }
        if (this.properties.invoice.sellerBankMode === 1) {
          this.properties.invoice.sellerDepositBankAccount = obj.depositBankAccount
        }
        this.getTitleByOffice(true)
      }
      this.initOurBankAccountArray()
      this.bringDefaultOurBankAccount()
      if (!this.$store.getters.currentOffice.multiTitleBankMode) {
        // 多抬头银行模式下，bringDefaultOurBankAccount会执行 getLatestInvoiceRemark，这里避免重复执行
        this.getLatestInvoiceRemark()
      }
    },
    // 清除当前发票的备注手动修改标记，使切换抬头时备注可被自动更新覆盖
    clearInvoiceRemarkModified() {
      const key = this.getInvoiceRemarkKey()
      if (key && this.modifiedInvoiceRemarkMap[key]) {
        this.$delete(this.modifiedInvoiceRemarkMap, key)
      }
    },
    // 我方银行账号下拉选择时,带出默认维护的银行账号
    getBankAccountFromChild(obj) {
      console.log('getBankAccountFromChild', obj)
      this.properties.invoice.bankAccount = obj.accountNo
      this.properties.invoice.bank = obj.bankChineseName
      this.properties.invoice.bankCurrency = obj.currency
      this.ourBankAccountId = obj.accountId
      this.getLatestInvoiceRemark()
    },
    // 根据最新发票 获取 自动生成备注
    getLatestInvoiceRemark() {
      if (this.ifAutoUpdateRemark) {
        if (this.isInvoiceRemarkModified()) {
          return
        }
        const loading = getLoading4Cxt(this)
        getLatestInvoiceRemark(this.properties.invoice).then(res => {
          this.properties.invoice.remark = res.data
        }).finally(() => {
          loading.close()
        })
      }
    },
    getInvoiceRemarkKey() {
      const invoice = this.properties && this.properties.invoice ? this.properties.invoice : null
      if (!invoice) return ''
      return invoice.uuid || `page-${this.properties.currentPage}`
    },
    markInvoiceRemarkModified() {
      const key = this.getInvoiceRemarkKey()
      if (key) {
        this.$set(this.modifiedInvoiceRemarkMap, key, true)
      }
      const remark = this.properties.invoice.remark || ''
      if (remark.length > 200) {
        this.properties.invoice.remark = remark.substring(0, 200)
        this.$message.warning(this.$t('CargoMsg.Cargo_RemarkAutoTruncated'))
      }
    },
    isInvoiceRemarkModified() {
      const key = this.getInvoiceRemarkKey()
      return !!(key && this.modifiedInvoiceRemarkMap[key])
    },
    getOurBankAccountId() {
      if (this.ourBankAccountArray) {
        const bankCurrency = StrUtils.isEmpty(this.properties.invoice.bankCurrency) ? this.properties.invoice.currency : this.properties.invoice.bankCurrency
        let bank = this.ourBankAccountArray.find(bank => bank.accountNo === this.properties.invoice.bankAccount && bank.currency === bankCurrency)
        if (bank) { // 银行账号、币种
          this.ourBankAccountId = bank.accountId
        } else { // 银行账号
          bank = this.ourBankAccountArray.find(bank => bank.accountNo === this.properties.invoice.bankAccount)
          this.ourBankAccountId = bank ? bank.accountId : 0
        }
      }
    },
    getOurBankName() {
      const { ourBankAccountArray, ourBankAccountId } = this
      if (ourBankAccountArray && ourBankAccountId) {
        const ourBank = ourBankAccountArray.find(item => item.accountId === ourBankAccountId)
        if (ourBank) {
          return ourBank.bankChineseName
        }
      }
      return ''
    },
    // 0=展开明细，1=合并明细
    onMergeTypeChange(mergeType) {
      console.log('onMergeTypeChange:', mergeType)
      const invoiceMap = { 'invoiceUuid': this.properties.invoice.uuid, 'showChargeDetail': this.properties.rbgShowChargeDetail === 'detail' }
      this.loading = getLoading()
      showChargeDetailChange(invoiceMap).then(res => {
        console.log('showChargeDetail', res)
        const invoice = res.data
        // 刷新
        this.properties.invoice.partChargeName = invoice.partChargeName
        this.properties.invoice.partQuantity = invoice.partQuantity
        this.properties.invoice.partUnitPrice = invoice.partUnitPrice
        this.properties.invoice.partCurrency = invoice.partCurrency
        this.properties.invoice.partAmount = invoice.partAmount
        this.properties.invoice.partAmount2 = invoice.partAmount2
      }).finally(() => {
        this.loading.close()
      })
      // 多票连续操作，其中票会无效果：附件截图：数据值与 界面展示不一致
      this.$forceUpdate()
    },
    // 差额调整
    differenceAdjustmentClickHandler() {
      this.adjustBalanceDialog.rbgShowChargeDetail = this.properties.rbgShowChargeDetail
      this.adjustBalanceDialog.invoice = { ...this.properties.invoice }
      this.adjustBalanceDialog.show = true
    },
    // 差额调整回调函数
    async differenceAdjustmentCallBackEvent(invoice = null) {
      // 重新加载费用
      if (invoice) {
        this.loading = getLoading()
        await getInvoiceDetails({ 'keys': [invoice.uuid] }).then(res => {
          if (res.data && res.data.length > 0) {
            this.properties.invoice = { ...res.data[0], incomePayDate: this.properties.invoice.incomePayDate }
            this.originalInputUserId = this.properties.invoice.inputBy
          }
          // 如果是合并明细状态下，保存差额以后会把invoiceItemList返回
          if (this.properties.rbgShowChargeDetail === 'merge') {
            for (const oldInvoice of this.properties.invoices) {
              if (oldInvoice.uuid === this.properties.invoice.uuid) {
                Object.assign(oldInvoice, this.properties.invoice)
              }
            }
            this.$emit('pageChange', 'saveSuccess')
            this.$emit('saveSuccess', this.properties.invoices)
          }
        }).finally(() => {
          this.loading.close()
        })
      }
      this.$message.success(this.$t('CargoMsg.Cargo_DifferentialAdjustedSuccessfully'))
      this.adjustBalanceDialog.show = false
    },
    // 下载
    downloadClickHandler() {
      // 开票种类(0.纸质发票 1.电子发票)
      if (this.properties.invoice.makeType.toString() !== '1') {
        this.$message.warning(this.$t('CargoMsg.Cargo_NEICTBD'))
        return
      }
      if (StrUtils.isEmpty(this.properties.invoice.invoiceNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoElectronicInvoiceNoToCreate'))
        return
      }
      this.downElectronicInvoiceHandler(this.properties.invoice)
    },
    /**
     * 下载最新电子发票函数
     * @param invoice
     */
    downElectronicInvoiceHandler(invoice) {
      if (invoice !== null && !StrUtils.isEmpty(invoice.uuid)) {
        if (StrUtils.isEmpty(invoice.invoiceNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoElectronicInvoiceNoToCreate'))
          return
        }
        // CARGO-7664，电子发票下载速度慢
        // StorageManager.getInstance().init(getLastedFile)
        if (StrUtils.isEmpty(invoice.webPdfFile)) {
          // 记录云存储UUID
          //					MessageDialog.info("没有找到云存储文件，请重新导出")
          //					return

          // 判断电子发票下载地址是否为空
          if (StrUtils.isEmpty(invoice.webPdfUrl)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PCITIHBI'))
            return
          }
          //
          console.log('taxEasyInvoiceDownLoad', invoice)
          this.loading = getLoading()
          taxEasyInvoiceDownLoad(invoice).then(res => {
            console.log('taxEasyInvoiceDownLoad', res)
            // 刷新
            this.properties.invoice = { ...res.data, incomePayDate: this.properties.invoice.incomePayDate }
            this.originalInputUserId = this.properties.invoice.inputBy
            invoice = this.properties.invoice
            if (!StrUtils.isEmpty(invoice.webPdfFile)) {
              window.open(URL.common.findByFileId + '/' + invoice.webPdfFile + '?sessionId=' + getToken())
            }
          }).finally(() => {
            this.loading.close()
          })
        } else {
          window.open(URL.common.findByFileId + '/' + invoice.webPdfFile + '?sessionId=' + getToken())
        }
      }
    },
    // 选择发票号
    selectInvoiceEvent() {
      const invoices = this.getNonInvoiceNos()
      this.selectInvoiceDialog.invoiceCount = invoices.length
      this.selectInvoiceDialog.invoiceType = this.properties.invoice.invoiceType
      this.selectInvoiceDialog.show = true
    },
    // 保存
    saveHandler() {
      this.loading = getLoading()
      if (!this.properties.invoice.ar && cache.hqConfig.get('ToFinanceApi') === 'HM') { // 上海虹迈
        for (const invoice of this.properties.invoices) {
          if (invoice.invoiceNo && !invoice.actualReceiptDate) {
            this.$message.warning(this.$t('Clearing.PushUFIDANeedReceiptDate'))
            this.closeLoading()
            return
          }
        }
      }
      if (!this.checkCargoHandler()) {
        this.closeLoading()
        return
      }
      // CARGO-3084，增加提示：红字通知单号未录入
      let hasEmptyCnnoticeNo = false
      for (const invoice of this.properties.invoices) {
        // 纸质专票红冲、没有发票号
        if (invoice.makeType === 0 && invoice.invoiceType === 3 && invoice.invoiceState === 2 && !invoice.exportToGoldenTax && StrUtils.isEmpty(invoice.invoiceNo)) {
          // 没有红字通知单号
          if (StrUtils.isEmpty(invoice.invoiceNo)) {
            hasEmptyCnnoticeNo = true
            break
          }
        }
      }
      if (hasEmptyCnnoticeNo) {
        this.closeLoading()
        this.$confirm(this.$t('CargoMsg.Cargo_SLNECTS'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          this.printFlag = 0
          this.checkInvoiceNo(false, this.properties.invoice.ar, this.doSave)
        }).catch(() => {
          //
        })
      } else {
        this.printFlag = 0
        this.checkInvoiceNo(false, this.properties.invoice.ar, this.doSave)
      }
    },
    closed() {
      this.$emit('lastFinsh')
    },
    // 应收更新汇率验证发票号
    checkInvoiceNoSaveAndCalcAmountHandler() {
      this.checkInvoiceNo(false, this.properties.invoice.ar, this.saveAndCalcAmountHandler)
    },
    // 应付更新汇率验证发票号
    checkInvoiceNoSaveAndCalcAmountHandlerPayable() {
      this.checkInvoiceNo(false, this.properties.invoice.ar, this.updateInvoiceAmount)
    },
    // 验证发票号
    checkInvoiceNo(isPrint, isInvoiceNoCheck = false, doInvoice = null) {
      console.log('checkInvoiceNo')
      let hasEmptyInvoiceNo = false
      const invoiceNoMap = new Map()
      let count = 0
      for (const invoice of this.properties.invoices) {
        if (invoice.invoiceNo && invoice.invoiceNo.length > 32) {
          this.$message.warning(this.$t('Message.InvoiceNoLength'))
          this.closeLoading()
          return
        }
        if (StrUtils.isEmpty(invoice.invoiceNo)) {
          hasEmptyInvoiceNo = true
          break
        } else if (!invoice.printed) {
          invoiceNoMap.set(invoice.uuid, invoice.invoiceNo)
          count++
        }
      }

      if (hasEmptyInvoiceNo && isPrint) {
        this.closeLoading()
        this.$confirm(this.$t('CargoMsg.Cargo_INNECTP'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.checkInvoiceNoExist(invoiceNoMap, count, doInvoice)
        }).catch(() => {
          //
        })
      } else if (hasEmptyInvoiceNo && !isPrint && isInvoiceNoCheck && !this.invoicesavepromptAndAr) {
        this.closeLoading()
        this.$confirm(this.$t('CargoMsg.Cargo_INNECTS'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.checkInvoiceNoExist(invoiceNoMap, count, doInvoice)
        }).catch(() => {
          //
        })
      } else {
        this.checkInvoiceNoExist(invoiceNoMap, count, doInvoice)
      }
    },
    // 检查发票号是否存在
    async checkInvoiceNoExist(invoiceNoMap, count, doInvoice = null) {
      if (!this.loading) {
        this.loading = getLoading()
      }
      if (count === 0) {
        doInvoice()
      } else {
        // msp转object
        const obj = Object.create(null)
        for (const [k, v] of invoiceNoMap) {
          obj[k] = v
        }
        const requestBody = { 'invoiceNoMap': obj, 'officeId': this.$store.getters.currentOfficeId }
        console.log('checkInvoiceNoExist', requestBody)
        await checkInvoiceNoExist2(requestBody).then(res => {
          if (res.data) {
            const isAllowInvoiceNoRepeat = Number(cache.config.get('isAllowInvoiceNoRepeat'))
            if (isAllowInvoiceNoRepeat === 0) {
              this.closeLoading()
              this.$confirm(this.$t('CargoMsg.Cargo_InvoiceNoExistedContinue'), this.$t('CargoMsg.Cargo_Tips'), {
                confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                type: 'warning'
              }).then(() => {
                doInvoice()
              }).catch(() => {
                //
              })
            } else if (isAllowInvoiceNoRepeat === 1) {
              this.closeLoading()
              this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceRepeat'))
            }
          } else {
            doInvoice()
          }
        }).catch(() => {
          this.closeLoading()
        })
      }
    },
    // 保存所有
    doSave() {
      console.log('doSave')
      if (this.validate()) {
        // 是否销货单位开户行与银行账号不匹配
        // if (overviewPage.needConirmBankAccount()) // 记在同一个字段 invoice.bankAccount
        //
        this.checkingBuyerBankAccountNo()
      } else {
        this.closeLoading()
      }
    },
    hasInvoiceAmountMismatch(amount, total) {
      return Math.abs(NumberUtils.ToFixed2(amount - total, 2)) > 0.01
    },
    // 验证
    validate(flag = true) {
      console.log('validate')
      for (const invoice of this.properties.invoices) {
        if (this.isApprovalEditableStatus(invoice.approvalStatus)) {
          const remark = invoice.remark || ''
          if (remark.length > 200) {
            this.$message.warning(this.$t('CargoMsg.Cargo_RemarkMax200'))
            return false
          }
        }
      }
      if (this.properties.invoice.ar) {
        if ([2, 3].includes(this.properties.invoice.invoiceType) || this.invoiceTypeFei) { // invoiceAddValue.validate()
          let total = 0
          for (const item of this.properties.invoice.invoiceItemList) {
            total += item.amount + item.taxAmount
            //
            total = NumberUtils.roundHalfUp(total, 2)
          }
          total = NumberUtils.roundHalfUp(total, 2)
          if (flag && this.hasInvoiceAmountMismatch(this.properties.invoice.amount, total)) {
            // this.$alert('费用项目金额总和与发票金额不相同!', '警告', {
            //   callback: action => {
            //     return false
            //   }
            // })
            this.$message.warning(this.$t('CargoMsg.Cargo_TOEIAADFIA'))
            return false
          }
          if (this.properties.invoice.sellerBankMode !== 1) {
            if (StrUtils.isEmpty(this.properties.invoice.bankAccount)) {
            // this.$alert('请输入销货单位开户行/银行账号.', '警告', {
            //   callback: action => {
            //     return false
            //   }
            // })
              this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSalesCompanySBank'))
              return false
            }
          }
          // 默认
          return true
        } else { // invoiceNormal.validate()
          if (StrUtils.isEmpty(this.properties.invoice.bankAccount)) {
            // this.$alert('请选择我方银行/账号.', '警告', {
            //   callback: action => {
            //     return false
            //   }
            // })
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectOurBank'))
            return false
          }
          // 默认
          return true
        }
      } else { // invoicePay.validate()
        if (StrUtils.isEmpty(this.properties.invoice.invoiceNo)) {
          // this.$alert('发票号未输入.', '警告', {
          //   callback: action => {
          //     return false
          //   }
          // })
          this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceNoNotEntered'))
          return false
        }
        if (this.properties.invoice.chargeList && this.properties.invoice.chargeList.length > 0) {
          let total = 0
          // 新增：当 currencyConversionInInvoices 参数开启时，采用新的计算逻辑
          if (this.currencyConversionInInvoices) {
            // 按币种分组汇总原币金额
            const currencyAmountMap = {}

            for (const item of this.properties.invoice.chargeList) {
              const index = (this.properties.invoice.ar === item.receivable) ? 1 : -1
              const currency = item.currency

              if (!currencyAmountMap[currency]) {
                currencyAmountMap[currency] = 0
              }

              // 累加原币金额
              currencyAmountMap[currency] += NumberUtils.ToFixed2(multiply(item.amount, index), 2)
            }
            let scale = 2 // 小数位数
            const carryRule = useAmountCarryRule()
            if (carryRule && this.properties.invoice.currency) {
              const currencyData = getCurrency(this.properties.invoice.currency)
              if (currencyData !== null) {
                scale = currencyData.defaultFractionDigits
              }
            }
            // 统一按币种乘以汇率
            for (const currency in currencyAmountMap) {
              const currencyTotal = currencyAmountMap[currency]

              if (currency === this.properties.invoice.currency) {
                // 同币种：直接累加
                total = total + currencyTotal
              } else {
                // 不同币种：(币种1费用汇总) * 汇率1 + (币种2费用汇总) * 汇率2
                if (currency === this.properties.invoice.chargeCurrency1) {
                  total += NumberUtils.ToFixed2(multiply(currencyTotal, this.properties.invoice.chargeExchangeRate1), scale)
                } else if (currency === this.properties.invoice.chargeCurrency2) {
                  total += NumberUtils.ToFixed2(multiply(currencyTotal, this.properties.invoice.chargeExchangeRate2), scale)
                }
              }
            }
            total = NumberUtils.ToFixed2(total, scale)
          } else {
            // 原有逻辑：每条费用单独乘以汇率再累加
            for (const item of this.properties.invoice.chargeList) {
              const index = (this.properties.invoice.ar === item.receivable) ? 1 : -1
              if (item.currency === this.properties.invoice.currency) {
                total += NumberUtils.ToFixed2(multiply(item.amount, index), 2)
              } else {
                if (item.currency === this.properties.invoice.chargeCurrency1) {
                  total += NumberUtils.ToFixed2(multiply(item.amount, this.properties.invoice.chargeExchangeRate1), 2) * index
                } else if (item.currency === this.properties.invoice.chargeCurrency2) {
                  total += NumberUtils.ToFixed2(multiply(item.amount, this.properties.invoice.chargeExchangeRate2), 2) * index
                }
              }
              total = NumberUtils.ToFixed2(total, 2)
            }
          }
          if (this.hasInvoiceAmountMismatch(this.properties.invoice.amount, total)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_TOEIAADFIA'))
            return false
          }
        }
        // 默认
        return true
      }
    },
    // 购货方
    checkingBuyerBankAccountNo() {
      // 购货单位开户行及账号,不是【" + overviewPage.invoice.title + "】所属的银行账户
      //
      this.checkingBankAccountNo()
    },
    // 销货方
    checkingBankAccountNo() {
      // 销货单位银行名称与系统中维护的不匹配
      //
      try {
        this.checkSave(this.save)
      } catch (e) {
        if (this.loading) {
          this.loading.close()
        }
      }
    },
    // 保存之前的校验规则
    async checkSave(method) {
      // 判断是否开启验证规则
      if (String(cache.config.get('ToExoSystem')) === 'OJ') {
        const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
        // 查询是否存在节点
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_INVOICE.code, this.$store.getters.currentOfficeId)
        if (useCheckRule && checkNodeFlag) {
          const result = await this.checkNodeResult()
          if (result.needShowDialog) {
            if (this.loading) {
              this.loading.close()
            }
            this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_SAVE_INVOICE.code
            this.batchCheckingWindow.jobs = result.jobList
            this.batchCheckingWindow.resData = result.resData
            this.batchCheckingWindow.callBack = await method
            this.batchCheckingWindow.callBack2 = null
            this.batchCheckingWindow.visible = true
            return
          }
        }
      }
      await method()
    },
    // 校验是否全部通过验证，是则跳过
    async checkNodeResult() {
      const result = { needShowDialog: false, jobList: [], resData: [] }
      const saveList = []
      // 参与保存的发票
      for (const invoice of this.properties.invoices) {
        if (this.isApprovalEditableStatus(invoice.approvalStatus)) {
          saveList.push(invoice)
          if (invoice.chargeList && invoice.chargeList.length > 0) {
            invoice.chargeList.forEach((item) => {
              result.jobList.push({ lob: item.jobLob, chargeUuid: item.uuid, jobNo: item.jobNo, jobUuid: item.jobUuid })
            })
          }
        }
      }
      if (saveList.length === 0 || result.jobList.length === 0) {
        return result
      }
      const data = {
        checkNode: CheckRuleConstants.NODE_SAVE_INVOICE.code,
        chargeUuidList: result.jobList.map(item => item.chargeUuid),
        branchId: this.$store.getters.currentOfficeId,
        paymentMethod: this.properties.invoice.ar,
        entities: saveList
      }
      let needShowDialog = false
      await checkChargeByInvoiceSaveNode(data).then(res => {
        result.resData = res.data || []
        if (result.resData) {
          for (const key of Object.keys(result.resData)) {
            for (const item of result.resData[key]) {
              if (item.expressions) {
                for (const express of item.expressions) {
                  if (!express.match) {
                    needShowDialog = true
                    break
                  }
                }
              }
            }
            if (needShowDialog) {
              break
            }
          }
        }
      })
      result.needShowDialog = needShowDialog
      return result
    },
    // 保存
    async save() {
      // 验证是否需要更改汇率，如果是的话则需要弹框确认
      const isUpdateRate = await this.checkExchangeRate()
      if (!this.loading) {
        this.loading = getLoading()
      }
      console.log('save')
      const saveList = []
      const noSaveList = []
      for (const invoice of this.properties.invoices) {
        invoice.updateRate = isUpdateRate
        // 处理货物运输服务类型
        if (invoice.specificConstraintType === InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code && invoice.transportList && invoice.transportList.length > 0) {
          for (const transport of invoice.transportList) {
            if (transport.pol && transport.pol instanceof Array) {
              transport.pol = transport.pol ? transport.pol.join(',') : transport.pol
            }
            if (transport.pod && transport.pod instanceof Array) {
              transport.pod = transport.pod ? transport.pod.join(',') : transport.pod
            }
          }
        }
        // 是否有修改
        // if (invoice.isDeepDirty()) {
        // CARGO-34026 只保存【未审批】状态数据
        if (this.isApprovalEditableStatus(invoice.approvalStatus)) {
          saveList.push(invoice)
        } else {
          noSaveList.push(invoice)
        }
        // }
      }
      if (this.properties.invoices.length === 0) {
        //
      } else {
        if (saveList.length > 0) {
          updateInvoices(saveList, this.location).then(async res => {
            for (const item of res.data) {
              for (const saveItem of saveList) {
                if (saveItem.uuid === item.uuid) {
                  item.incomePayDate = saveItem.incomePayDate
                  break
                }
              }
            }
            this.properties.invoices = [...noSaveList, ...res.data]
            // 否则，第一次保存成功后的再次保存，页面值与mode没有同步
            this.$emit('pageChange', 'saveSuccess')
            this.$emit('saveSuccess', this.properties.invoices)
            if (this.printFlag === 0) {
              this.$message.success(this.$t('Message.SaveSuccessfully') + (isUpdateRate ? this.$t('Invoice.RateChangedSuccess') : ''))
            }
            // 保存展示销售方银行账号单选框的值到本地缓存
            if (this.properties.invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_VAT_FEI.code || this.properties.invoice.invoiceType === InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code) {
              LocalStorageUtilsNew.setConfiguration('invoiceDisplaySell', this.properties.invoice.displaySell)
            }
            // 保存运输工具信息
            if (saveList.length > 0) {
              saveList.forEach(invoice => {
                if (invoice.specificConstraintType === InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code && invoice.transportList && invoice.transportList.length > 0 && invoice.accountId) {
                  invoice.transportList.forEach(transport => {
                    const transportData = {
                      accountId: invoice.accountId,
                      transportGrade: transport.transportNumber,
                      originalPlace: transport.pol,
                      destination: transport.pod,
                      transportGoodName: transport.name
                    }
                    saveTransportServiceHistory(transportData)
                  })
                }
              })
            }

            this.$nextTick(() => {
              this.closeLoading()
            })
            // CARGO-34026 1.开票模块调整方案，新增“BPM开票审批触发节点”参数InvoicingNode。
            // 过滤出【应收发票】，支持【增值税普通发票、增值税专用发票、内部发票、两种全电发票】
            const invoices = res.data.filter(item => item.ar && [2, 3, 4, 6, 7].includes(item.invoiceType))
            const invoicesByAp = res.data.filter(item => !item.ar && [2, 3, 4, 6, 7].includes(item.invoiceType))
            if (invoices && invoices.length > 0) {
              // 应收（相当于开票） 且 开票【保存】触发bpm节点 是否 开启
              if (this.properties.invoiceTriggerBpm) {
                // 是否 存在 【开票】相关的审批流
                if (await WorkflowUtil.isBpmEnabled({
                  documentConfigId: MAKE_INVOICE.code,
                  officeId: invoices[0].branchId
                })) {
                  // 点击确认之后往下执行
                  await this.$confirm(this.$t('CargoMsg.Cargo_SubmitInvoiceTip'), this.$t('Message.Prompt'), {
                    confirmButtonText: this.$t('common.btn.ok'),
                    cancelButtonText: this.$t('common.btn.cancel'),
                    showCancelButton: true,
                    type: 'warning'
                  })
                  const params = []
                  invoices.forEach(invoice => {
                    const param = {
                      documentConfigId: MAKE_INVOICE.code,
                      docId: invoice.uuid,
                      docNo: invoice.invoiceId,
                      actionType: 7000,
                      officeId: invoice.branchId,
                      applicationDimension: APPLICATION_DIMENSION_MAKE_INVOICE.code
                    }
                    params.push(param)
                  })
                  this.loading = getLoading()
                  await workflowActionBatch(params).then(res => {
                    this.$emit('toStepHandler', '')
                    if (!res.data || res.data.length === 0) {
                      this.$emit('refresh')
                      this.$message.success(this.$t('SeaExport.Submission') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
                    } else {
                      this.batchSubmitOrApproveDialog.visible = true
                      this.batchSubmitOrApproveDialog.rowData = res.data
                      // 全部失败无需刷新
                      if (invoices.length !== res.data.length) {
                        this.$emit('refresh')
                      }
                    }
                  }).catch(() => {
                    this.loading.close()
                  }).finally(() => {
                    this.loading.close()
                  })
                }
              }
            }
            if (invoicesByAp && invoicesByAp.length) {
              // 是否 存在 【收票】相关的审批流
              const result = await WorkflowUtil.isBpmEnabled({ documentConfigId: COLLECT_INVOICE.code, officeId: invoicesByAp[0].branchId })
              if (result) {
                // 点击确认之后往下执行
                await this.$confirm(this.$t('CargoMsg.Cargo_SubmitCollectionInvoiceTip'), this.$t('Message.Prompt'), {
                  confirmButtonText: this.$t('common.btn.ok'),
                  cancelButtonText: this.$t('common.btn.cancel'),
                  showCancelButton: true,
                  type: 'warning'
                })
                const params = []
                invoicesByAp.forEach(invoice => {
                  const param = {
                    documentConfigId: COLLECT_INVOICE.code,
                    docId: invoice.uuid,
                    docNo: invoice.invoiceId,
                    actionType: 7000,
                    officeId: invoice.branchId,
                    applicationDimension: APPLICATION_DIMENSION_MAKE_INVOICE.code
                  }
                  params.push(param)
                })
                this.loading = getLoading()
                await workflowActionBatch(params).then(res => {
                  this.$emit('toStepHandler', '')
                  if (!res.data || res.data.length === 0) {
                    this.$emit('refresh')
                    this.$message.success(this.$t('SeaExport.Submission') + this.$t('CargoMsg.Cargo_ApprovedSuccess'))
                  } else {
                    this.batchSubmitOrApproveDialog.visible = true
                    this.batchSubmitOrApproveDialog.rowData = res.data
                    // 全部失败无需刷新
                    if (invoicesByAp.length !== res.data.length) {
                      this.$emit('refresh')
                    }
                  }
                }).catch(() => {
                  this.loading.close()
                }).finally(() => {
                  this.loading.close()
                })
              }
            }
            if (this.printFlag !== 0) {
              this.doPrint()
            }
          }).catch(() => {
            this.$nextTick(() => {
              this.closeLoading()
            })
          }).finally(() => {
            this.closeLoading()
          })
        } else if (this.printFlag !== 0) {
          this.closeLoading()
          this.doPrint()
        }
      }
    },
    async checkDeleteable(force = false) {
      const invoice = this.properties && this.properties.invoice ? this.properties.invoice : null
      if (!invoice || StrUtils.isEmpty(invoice.uuid)) return false

      if (!this.isApprovalEditableStatus(invoice.approvalStatus)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_DeleteUnApprovedInvoiceTips'))
        return false
      }
      if (!force && invoice.printed) {
        this.$message.warning(this.$t('CargoMsg.Cargo_InvoicePrintedCanTBeDeleted'))
        return false
      }
      if (!force && invoice.revoked) {
        this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceVoidedCanTBeDeleted'))
        return false
      }
      const invoiceNo = !StrUtils.isEmpty(invoice.actualInvoiceNo) ? invoice.actualInvoiceNo : invoice.invoiceNo
      if (!force && !StrUtils.isEmpty(invoiceNo)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanTDeleteItemsWithInvoiceNo'))
        return false
      }
      return true
    },
    async deleteHandler(force = false) {
      // In templates, `@click="deleteHandler"` would pass MouseEvent as first arg.
      // Force must be boolean, otherwise backend rejects (and UI may spin).
      if (typeof force !== 'boolean') force = false

      const invoice = this.properties && this.properties.invoice ? this.properties.invoice : null
      if (!invoice || StrUtils.isEmpty(invoice.uuid)) return

      if (!(await this.checkDeleteable(force))) return

      const keys = [invoice.uuid]
      const invoiceNoMap = new Map()
      invoiceNoMap.set(invoice.uuid, invoice.invoiceNo)

      try {
        let resultKeys = []
        const voucherRes = await checkToVoucher({ keys })
        resultKeys = (voucherRes && voucherRes.data) ? voucherRes.data : []
        let invoiceNoStr = ''
        if (resultKeys && resultKeys.length > 0 && !this.properties.autoGenerateVoucher) {
          for (const invoiceUuid of resultKeys) {
            if (!invoiceUuid) continue
            if (!invoiceNoStr) {
              invoiceNoStr = invoiceNoMap.get(invoiceUuid)
            } else {
              invoiceNoStr += (',' + invoiceNoMap.get(invoiceUuid))
            }
          }
        }

        const msgTpl = this.$t('CargoMsg.Cargo_SureToDeleteTheInvoice')
        // Avoid hard dependency on global String.prototype.format.
        let msg = (msgTpl && typeof msgTpl.format === 'function')
          ? msgTpl.format(1)
          : String(msgTpl || '').replace(/\{0\}/g, 1)
        if (invoiceNoStr) {
          msg = (msg + '<br>' + this.$t('CargoMsg.Cargo_GeneratedVoucherInvoice') + '<br>' + invoiceNoStr)
        }
        await this.$confirm(msg, this.$t('CargoMsg.Cargo_Tips'), {
          dangerouslyUseHTMLString: true,
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        })

        const requestBody = {
          keys,
          isRevoke: false,
          // Backend expects null here (not boolean true).
          copyInvoiceNo: null,
          branchId: this.$store.getters.currentOfficeId,
          force,
          // Align with backend expectation for invoice deletion.
          location: 'makeInvoice'
        }
        await deleteInvoices(requestBody)
        this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))

        // Remove the deleted invoice from local page list and refresh current page.
        this.properties.invoices = (this.properties.invoices || []).filter(p => p && p.uuid !== invoice.uuid)
        if (!this.properties.invoices || this.properties.invoices.length === 0) {
          this.$emit('toStepHandler', '')
          return
        }
        if (this.properties.currentPage > this.properties.invoices.length) {
          this.properties.currentPage = this.properties.invoices.length
        }
        this.$emit('pageChange', 'delete')
      } catch (e) {
        // Cancel confirm -> ignore.
        if (e === 'cancel' || e === 'close') return
        const msg = (typeof e === 'string' && e) || (e && e.message) || '删除失败，请稍后重试'
        this.$message.error(msg)
      }
    },
    // 关闭
    closeHandler() {
      if (StrUtils.isEmpty(this.properties.invoice.invoiceNo) && !this.invoicesavepromptAndAr) {
        this.$confirm(this.$t('CargoMsg.Cargo_INNECTCW'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {
          this.$emit('toStepHandler', '')
        }).catch(() => {
          //
        })
      } else {
        this.$emit('toStepHandler', '')
      }
    },
    // 打印
    printHandler() {
      this.printFlag = 1
      this.checkInvoiceNo(true, false, this.doSave)
    },
    // 全部打印
    printAllHandler() {
      this.printFlag = 2
      this.checkInvoiceNo(true, false, this.doSave)
    },
    // 金税导出
    async interfaceExportHandler() {
      const allowTaxOperation = await BSWarningUtil.checkTaxExpire()
      if (!allowTaxOperation) {
        return
      }
      // 审批状态校验：未审批通过(approvalStatus!==3)拦截，与后端一致
      if (this.properties.invoice && this.properties.invoice.approvalStatus !== 3) {
        this.$message.warning('该发票未审批通过，无法金税导出')
        return
      }
      if (this.properties.QdWarning) {
        this.$confirm(this.$t('Invoice.QdWarningTip'), this.$t('common.tips.prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          showCancelButton: false,
          closeOnClickModal: false,
          type: 'warning'
        })
        return
      }
      if (!this.checkCargoHandler) return
      if (this.properties.toExoSystemYGSH) {
        this.loading = getLoading()
        const list = [this.properties.invoice.uuid]
        queryLtsInvoiceFunc(list).then(res => {
          if (res.data === 'ok') {
            this.$message.success(this.$t('Message.SynchronizationSucceeded'))
          } else if (res.data === 'not data') {
            this.$message.warning(this.$t('Message.NoSynchronizationContent'))
          } else {
            this.$message.warning(res.data)
          }
        }).finally(() => {
          this.loading.close()
        })
      } else {
        let flag = false
        const invoiceItemList = this.properties.invoice.invoiceItemList
        for (const item of invoiceItemList) {
          if (!(item.quantity > 0 && item.unitRate !== '0.00')) {
            flag = true
          }
        }
        if (flag) {
          this.$confirm(this.$t('Message.PriceAndNumIsNull'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            closeOnClickModal: false,
            type: 'info'
          }).then(() => {
            this.realPersonAuthentication()
          })
        } else {
          this.realPersonAuthentication()
        }
      }
    },
    // 实人认证
    async realPersonAuthentication(closeDialog = false) {
      // if (!await this.authRecognition()) {
      //   return
      // }
      // if (closeDialog) { // 认证通过关闭二维码弹框
      //   this.ewmDialog.visible = false
      // }
      this.doCallInterface()
    },
    // 金税打印
    interfacePrintHandler() {
      this.doCallInterface(1)
    },
    // 金税作废
    interfaceCancelHandler() {
      if (this.properties.invoice.clearingState !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanTVoidWrittenOffItem').format(this.properties.invoice.title))
        return false
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToVoidTheInvoice'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        this.doCallInterface(2)
      }).catch(() => {
        //
      })
    },
    doCallInterface(opType = 0, machinenr = 0) {
      const office = this.$store.getters.currentOffice
      const item = {}
      item.officeId = office.officeId
      item.wsdlLocation = office.sajtInvoiceService
      item.machinetaxnr = office.taxAccount
      item.machinenr = machinenr
      if (this.properties.interfaceName === 'BAI_WANG_ORIGIN' || this.isHtxx || (this.isFei && this.invoiceTypeFei)) {
        item.invoiceType = this.properties.invoice.invoiceType
      } else {
        // 0-专用发票，2-普通发票
        item.invoiceType = this.properties.invoice.invoiceType === 3 ? 0 : 2
      }
      // 1-电子发票, 0- 纸质发票
      item.invoiceMakeType = this.properties.invoice.makeType
      item.uuid = this.properties.invoice.uuid

      // 电子发票的
      if (this.properties.invoice.makeType.toString() === '1') {
        if (this.properties.invoice.currency !== 'RMB' && !this.properties.isEasyInoivceVietnam) {
          if (opType === 2) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OWCICGTSEEI_2'))
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_OWCICGTSEEI', ['RMB']))
          }
          return
        }

        if (!(this.properties.invoice.ar && [2, 3, 6, 7].includes(this.properties.invoice.invoiceType))) {
          if (opType === 2) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OVICBETGTEI_2'))
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_OVICBETGTEI', ['RMB']))
          }
          return
        }

        item.userName = office.userNameEi // 平台编码
        item.passWord = office.passWordEi // 密码
        item.taxpayerId = office.taxPayerIdEi // 纳税人识别号
        item.authorizationCode = office.authorizationCodeEi // 纳税人授权码
        item.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
        item.production = '1' // 1 = 正式使用时通讯用 CA加密
        item.interfaceName = this.properties.interfaceNameEI
        item.email = office.email // 电子邮箱
        // 正式环境报文不需要传password的，置空就可以了 ?!
        if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
          this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.isAisinoEi) {
          if (StrUtils.isEmpty(office.taxPayerIdEi)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CBTSINNM'))
            return
          }
        } else {
          if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
            StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
            return
          }
          if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY && StrUtils.isEmpty(office.email)) {
            this.$message.warning(this.$t('CargoMsg.CARGO_OFFICE_EMAIL_ISEMPTY'))
            return
          }
        }
      } else { // 非电子发票
        item.interfaceName = this.properties.interfaceName
        if (this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX) { // 百旺金穗云 航天信息-诺诺
          if (StrUtils.isEmpty(office.userNameEi) || StrUtils.isEmpty(office.taxPayerIdEi) ||
            StrUtils.isEmpty(office.authorizationCodeEi) || StrUtils.isEmpty(office.invoiceServiceEi)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CBEIPCTSINACSRANMPC'))
            return
          }
          item.userName = office.userNameEi // 平台编码
          item.passWord = office.passWordEi // 密码
          item.taxpayerId = office.taxPayerIdEi // 纳税人识别号
          item.authorizationCode = office.authorizationCodeEi // 纳税人授权码
          item.wsdlLocation = office.invoiceServiceEi // 电子发票服务请求地址
        }
        if (this.properties.interfaceName === 'BAI_WANG_ORIGIN') {
          if (StrUtils.isEmpty(this.properties.terminalSn)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_ITIOCBNMPCBITIITBCPOTS'))
            return
          }
          item.baiWangOriginTerminalSN = this.properties.terminalSn
        } else if (StrUtils.isEmpty(office.sajtInvoiceService) && this.properties.interfaceName !== InvoiceConstant.INVOICE_TAX_EASY && this.properties.interfaceName !== InvoiceConstant.INVOICE_YSHS && this.properties.interfaceName !== InvoiceConstant.INVOICE_TAX_EASY_THREE &&
                 this.properties.interfaceName !== InvoiceConstant.INVOICE_BWJSY && this.properties.interfaceName !== InvoiceConstant.INVOICE_HTXX) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CBISAWTSNM'))
          return
        }
        if (StrUtils.isEmpty(office.taxAccount)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_CBTSINNM'))
          return
        }
      }

      if (opType === 0) {
        // if (this.properties.invoice.isDirty) {
        //   this.$message.warning('有数据修改过，请保存后再打印.')
        //   return
        // }
        // 开票种类(0.纸质发票 1.电子发票)
        if (this.properties.invoice.makeType.toString() === '1') {
          if (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
            this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_HTXX || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS) {
            if (this.properties.invoice.exportToGoldenTax) {
              if (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE && this.properties.interfaceNameEI !== InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS) {
                this.$confirm(this.$t('CargoMsg.Cargo_RepeatGoldenTaxExport'), this.$t('CargoMsg.Cargo_Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Got_It'),
                  showCancelButton: false,
                  type: 'warning'
                })
              } else {
                this.$confirm(this.$t('CargoMsg.Cargo_RTGTEOMCACC'), this.$t('CargoMsg.Cargo_Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                  type: 'warning'
                }).then(() => {
                  this.doOutInterfaceExportEi(item)
                }).catch(() => {
                  //
                })
              }
            } else {
              this.doOutInterfaceExportEi(item)
            }
          } else {
            this.doOutInterfaceExportEi(item)
          }
        } else {
          if (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceName === InvoiceConstant.INVOICE_YSHS || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE ||
            this.properties.interfaceName === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceName === InvoiceConstant.INVOICE_HTXX) {
            if (this.properties.invoice.exportToGoldenTax) {
              if (this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE) {
                this.$confirm(this.$t('CargoMsg.Cargo_RepeatGoldenTaxExport'), this.$t('CargoMsg.Cargo_Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Got_It'),
                  showCancelButton: false,
                  type: 'warning'
                })
              } else {
                this.$confirm(this.$t('CargoMsg.Cargo_RTGTEOMCACC'), this.$t('CargoMsg.Cargo_Tips'), {
                  confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
                  cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
                  type: 'warning'
                }).then(() => {
                  this.doOutInterfaceExport(item)
                }).catch(() => {
                  //
                })
              }
            } else {
              this.doOutInterfaceExport(item)
            }
          } else {
            this.doOutInterfaceExport(item)
          }
        }
      } else if (opType === 1) {
        if (StrUtils.isEmpty(this.properties.invoice.invoiceNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceNoCanTBeEmpty'))
          return
        }
        // 开票种类(0.纸质发票 1.电子发票)
        if (this.properties.invoice.makeType.toString() === '1') {
          this.$message.warning(this.$t('CargoMsg.Cargo_EInvoiceCanTBePrinted'))
          return
        } else {
          this.doOutInterfacePrint(item)
        }
      } else {
        // 开票种类(0.纸质发票 1.电子发票)
        if (this.properties.invoice.makeType.toString() === '1' && !this.properties.isEasyInoivceVietnam) {
          this.$message.warning(this.$t('CargoMsg.Cargo_EInvoiceCanTBeVoided'))
          return
        } else {
          this.doOutInterfaceCancel(item)
        }
      }
    },
    // 电票接口
    doOutInterfaceExportEi(item) {
      item.location = this.location
      console.log('doOutInterfaceExportEi', item)
      this.loading = getLoading()
      outInterfaceExportEi(item).then(res => {
        console.log('outInterfaceExportEi', res)
        //
        this.outInterfaceExportResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 纸票接口
    doOutInterfaceExport(item) {
      item.location = this.location
      console.log('doOutInterfaceExport', item)
      this.loading = getLoading()
      outInterfaceExport(item).then(res => {
        console.log('outInterfaceExport', res)
        //
        this.outInterfaceExportResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 导出结果
    outInterfaceExportResultHandler(result) {
      if (result.success) {
        this.$alert(this.$t('CargoMsg.Cargo_ExportedSuccessfully'), this.$t('Message.Success'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'success',
          callback: async action => {
            const isYshs = (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_YSHS) || (this.properties.interfaceName === InvoiceConstant.INVOICE_YSHS)
            const isTaxEasyThree = (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY_THREE)
            const isTaxEasy = (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY || this.properties.interfaceName === InvoiceConstant.INVOICE_TAX_EASY)
            const isTaxEasyThreePlus = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS
            const isNuoNuo = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO
            this.properties.invoice = { ...result.invoice, incomePayDate: this.properties.invoice.incomePayDate }
            // CARGO-13524，开票/收票页面金税导出发票号显示
            if (isTaxEasy || isYshs || isTaxEasyThree || this.isBwjsy || this.isHtxx || isTaxEasyThreePlus || isNuoNuo || this.isAisinoEi) {
              const obj = { 'keys': [this.properties.invoice.uuid], 'loadSubDetail': false }
              if (isYshs) {
                if (!this.properties.invoice.exportToGoldenTax) {
                  this.$message.warning(this.$t('Invoice.NotDoInvoice'))
                  return
                }
                obj.interFaceName = InvoiceConstant.INVOICE_YSHS
                obj.officeId = this.$store.getters.currentOfficeId
              }
              this.loading = getLoading()
              if (isYshs) {
                obj.location = this.location
                getInvoiceNos(obj).then(res => {
                  this.refreshInvoice(res, isYshs)
                }).finally(() => {
                  this.loading.close()
                })
              } else {
                getInvoiceDetails(obj).then(res => {
                  this.refreshInvoice(res, isYshs)
                }).finally(() => {
                  this.loading.close()
                })
              }
            }
          }
        })
      } else {
        this.$alert(result.msg, this.$t('CargoMsg.Cargo_OperationFailed'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'warning',
          callback: action => {
            //
          }
        })
      }
    },
    // 刷新发票信息
    refreshInvoice(res, isYshs) {
      if (res.data && res.data.length > 0) {
        if (isYshs) {
          this.$message.success(this.$t('Invoice.GetInvoiceNoSuccess'))
        }
        this.properties.invoice.exportToGoldenTax = true
        this.properties.invoice.version = res.data[0].version
        this.properties.invoice.invoiceNo = res.data[0].invoiceNo
        this.properties.invoice.invoiceDate = res.data[0].invoiceDate
        this.properties.invoice.webPdfFile = res.data[0].webPdfFile
        this.properties.invoice.printed = res.data[0].printed
        this.properties.invoice.returnTaxCode = res.data[0].returnTaxCode
        for (const invoice of this.properties.invoices) {
          if (invoice.uuid === this.properties.invoice.uuid) {
            invoice.exportToGoldenTax = true
            invoice.version = this.properties.invoice.version
            invoice.invoiceNo = this.properties.invoice.invoiceNo
            invoice.invoiceDate = this.properties.invoice.invoiceDate
            invoice.webPdfFile = this.properties.invoice.webPdfFile
            invoice.printed = this.properties.invoice.printed
            invoice.isPrinted = invoice.printed
            invoice.returnTaxCode = this.properties.invoice.returnTaxCode
          }
        }
        this.$emit('pageChange', 'saveSuccess')
        this.$emit('saveSuccess', this.properties.invoices)
      }
    },
    // 打印
    doOutInterfacePrint(item) {
      console.log('doOutInterfacePrint', item)
      this.loading = getLoading()
      outInterfacePrint(item).then(res => {
        console.log('outInterfacePrint', res)
        //
        this.outInterfacePrintResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 打印结果
    outInterfacePrintResultHandler(result) {
      if (result.success) {
        this.$alert(this.$t('CargoMsg.Cargo_PrintedSuccessfully'), this.$t('Message.Success'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'success',
          callback: action => {
            //
          }
        })
      } else {
        this.$alert(result.msg, this.$t('CargoMsg.Cargo_OperationFailed'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'warning',
          callback: action => {
            //
          }
        })
      }
    },
    // 作废
    doOutInterfaceCancel(item) {
      console.log('doOutInterfaceCancel', item)
      this.loading = getLoading()
      const callFunction = this.properties.isEasyInoivceVietnam ? cancelEasyInvoice : outInterfaceCancel
      callFunction(item).then(res => {
        console.log('outInterfaceCancel', res)
        //
        this.outInterfaceCancelResultHandler(res.data)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 作废结果
    outInterfaceCancelResultHandler(result) {
      if (result.success || this.properties.isEasyInoivceVietnam) {
        this.$alert(this.$t('CargoMsg.Cargo_VoidedSuccessfully'), this.$t('Message.Success'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'success',
          callback: action => {
            //
          }
        })
      } else {
        this.$alert(result.msg, this.$t('CargoMsg.Cargo_OperationFailed'), {
          confirmButtonText: this.$t('Clearing.Confirm'),
          type: 'warning',
          callback: action => {
            //
          }
        })
      }
    },
    // 上一张
    btPreClickHandler() {
      let i = this.properties.currentPage
      this.properties.currentPage = --i
      this.$emit('pageChange', 'pre')
    },
    // 下一张
    btNextClickHandler() {
      let i = this.properties.currentPage
      this.properties.currentPage = ++i
      this.$emit('pageChange', 'next')
    },
    // 开票抬头
    async queryTitleList(accountId, opts = {}) {
      const autofillBuyerTitle = opts.autofillBuyerTitle !== false
      const overwriteBuyerTitleIfNotFound = opts.overwriteBuyerTitleIfNotFound !== false
      const fillBuyerFieldsWhenMissing = opts.fillBuyerFieldsWhenMissing !== false
      if (accountId) {
        const res = await queryTitleByCpmIdx(accountId)
        this.titleArray = res.data ? [...res.data] : []
        if (this.titleArray.length > 0) {
          let title = this.titleArray[0]
          // 购货单位名称
          if (!StrUtils.isEmpty(this.properties.invoice.title)) {
            let found = false
            for (const selectItem of this.titleArray) {
              if (this.properties.invoice.title === selectItem.title) {
                title = selectItem
                found = true
              }
            }
            // If buyer title doesn't match any maintained item, overwrite to a real option
            // so sellerTaxAccount auto matching can work.
            if (!found) {
              if (overwriteBuyerTitleIfNotFound) {
                this.properties.invoice.title = title.title
              }
            }
            if (fillBuyerFieldsWhenMissing) {
              // Only fill when title matches a maintained option (or we just overwrote it to a maintained one),
              // otherwise we may mix buyer fields with a free-text title.
              const effectiveMatched = found || (!found && overwriteBuyerTitleIfNotFound)
              if (effectiveMatched) {
                // Fill buyer fields when missing (avoid overriding existing values).
                const invoice = this.properties.invoice
                if (StrUtils.isEmpty(invoice.buyerTaxAccount)) invoice.buyerTaxAccount = title.taxAccount
                if (StrUtils.isEmpty(invoice.buyerAddress)) invoice.buyerAddress = title.address
                if (StrUtils.isEmpty(invoice.buyerTelephone)) invoice.buyerTelephone = title.telephone
                if (invoice.buyerBankMode === 1 && StrUtils.isEmpty(invoice.buyerDepositBankAccount)) {
                  invoice.buyerDepositBankAccount = title.depositBankAccount
                }
              }
            }
          } else {
            if (autofillBuyerTitle) {
              // If buyer title is empty (common after deleting & re-generating invoices),
              // default to the first title so that sellerTaxAccount can be auto-matched.
              // Keep behavior minimal: only auto-fill when empty.
              const invoice = this.properties.invoice
              invoice.title = title.title
              if (title && title.title !== '' && title.uuid) {
                invoice.buyerTaxAccount = title.taxAccount
                invoice.buyerAddress = title.address
                invoice.buyerTelephone = title.telephone
                if (invoice.buyerBankMode === 1) {
                  invoice.buyerDepositBankAccount = title.depositBankAccount
                }
              }
            }
          }
          await this.queryTitleBankList(title)
        }
      } else {
        this.titleArray = []
        this.ourInvoiceTitleLocked = false
        this.autoMatchedSellerTaxAccount = ''
      }
    },
    // 开票抬头银行
    async queryTitleBankList(title) {
      if (title && title['uuid']) {
        await getTitleBankList({ titleUuidList: [title['uuid']] }).then(res => {
          this.titleBankArray = []
          if (res.data && res.data.length > 0) {
            this.titleBankArray = [...res.data]
          }
          // CARGO-20372 修复开票出现选择2条数据的情况（同银行不同币种不同账号）
          if (this.properties.invoice.buyerBank) {
            this.titleBankArray.forEach(element => {
              if (element.bank === this.properties.invoice.buyerBank && element.bankAccount === this.properties.invoice.buyerBankAccount) {
                // this.buyerBankAccount = element.bankAccount
                this.buyerBankUuid = element.uuid
              }
            })
            // 没有找到手动创建一个，否则界面不显示
            if (!this.buyerBankUuid) {
              const key = this.properties.invoice.buyerBank + '_' + this.properties.invoice.buyerBankAccount
              const option = { uuid: key, bank: this.properties.invoice.buyerBank, bankAccount: this.properties.invoice.buyerBankAccount }
              this.titleBankArray.push(option)
              this.buyerBankUuid = key
            }
          }
        })
      }
    },
    // 增票发票项目
    toQueryInvoiceGoodsName() {
      if (this.properties.invoice.ar && [2, 3, 6, 7].includes(this.properties.invoice.invoiceType)) {
        this.invoiceGoodsNameArray = []
        const requestBody = { 'officeId': this.$store.getters.currentOfficeId }
        console.log('officeId', requestBody)
        const loading = getLoading()
        queryInvoiceGoodsName(requestBody).then(res => {
          console.log('queryInvoiceGoodsName', res)
          const list = res.data
          if (list && list.length > 0) {
            // 分公司
            const officeId = this.$store.getters.currentOfficeId
            const checkInvoiceRMB = this.checkInvoiceCurrency('RMB')
            const checkInvoiceUSD = this.checkInvoiceCurrency('USD')
            const checkInvoiceJPY = this.checkInvoiceCurrency('JPY')
            const checkInvoiceEUR = this.checkInvoiceCurrency('EUR')
            for (const item of list) {
              if (officeId === item.officeId && item.invoiceType === this.properties.invoice.invoiceType) {
                if (checkInvoiceRMB) { // RMB
                  this.invoiceGoodsNameArray.push({ 'goodsName': item.goodsNameRMB })
                } else if (checkInvoiceUSD) { // USD
                  this.invoiceGoodsNameArray.push({ 'goodsName': item.goodsNameUSD })
                } else if (checkInvoiceJPY) { // JPY
                  this.invoiceGoodsNameArray.push({ 'goodsName': item.goodsNameJPY })
                } else if (checkInvoiceEUR) { // EUR
                  this.invoiceGoodsNameArray.push({ 'goodsName': item.goodsNameEUR })
                }
              }
            }
            console.log('invoiceGoodsNameArray', this.invoiceGoodsNameArray)
          }
        }).finally(() => {
          loading.close()
        })
      }
    },
    // 判断是否全是RMB/USD
    checkInvoiceCurrency(currency = 'RMB') {
      for (const charge of this.properties.invoice.chargeList) {
        if (charge.currency !== currency) {
          return false
        }
      }
      return true
    },
    // 开票抬头变更回调函数
    titleChangeEvent(titleItem) {
      console.log('titleChangeEvent', titleItem)
      const invoice = this.properties.invoice
      invoice.title = titleItem.title
      if (titleItem && titleItem.title !== '' && titleItem.uuid) {
        invoice.buyerTaxAccount = titleItem.taxAccount
        invoice.buyerAddress = titleItem.address
        invoice.buyerTelephone = titleItem.telephone
        if (invoice.buyerBankMode === 1) {
          invoice.buyerDepositBankAccount = titleItem.depositBankAccount
        }
      }
      this.getTitleBankByTitle(titleItem)
      this.verifyAndLockSellTitle()
    },
    // 应付发票开票抬头修改
    apTitleChangeEvent(titleItem) {
      InvoiceUtils.apTitleChangeEvent(this.properties.invoice, titleItem)
    },
    // 应付发票收票抬头修改
    apReceiptInvoiceTitleChangeEvent(titleItem) {
      InvoiceUtils.apReceiptInvoiceTitleChangeEvent(this.properties.invoice, titleItem)
    },
    // 应付发票税率标识修改
    apInvoiceNatureChangeEvent(p) {
      InvoiceUtils.apInvoiceNatureChangeEvent(this.properties.invoice, p.value)
    },
    // 获取开票抬头所维护的开票银行
    getTitleBankByTitle(title = null) {
      if (title && title['uuid']) {
        const invoice = this.properties.invoice
        getTitleBankList({ titleUuidList: [title['uuid']] }).then(res => {
          // 接口无数据时兜底为空数组，避免后续遍历直接报错
          this.titleBankArray = res.data || []
          if (invoice.buyerBankMode !== 1) {
            let findDefaultTitleBankByCurrency = false
            let defauleTitleBank = null
            const currency = invoice.chargeCurrency1 ? invoice.chargeCurrency1 : invoice.currency
            for (const titleBank of this.titleBankArray) {
              if (currency === titleBank.currency && titleBank.defaultBank) {
                findDefaultTitleBankByCurrency = true
                invoice.buyerBank = titleBank.bank
                invoice.buyerBankAccount = titleBank.bankAccount
              }
              if (titleBank.defaultBank) {
                defauleTitleBank = titleBank
              }
            }
            if (!findDefaultTitleBankByCurrency) {
              // 客户没有维护银行（或没有维护默认银行）时清空购方银行信息，
              // 避免把上一个抬头选中的银行残留到当前发票上
              if (defauleTitleBank === null) {
                invoice.buyerBank = ''
                invoice.buyerBankAccount = ''
              } else {
                invoice.buyerBank = defauleTitleBank.bank
                invoice.buyerBankAccount = defauleTitleBank.bankAccount
              }
            }
            // 先清空选中的银行uuid：切换抬头后残留的uuid在新下拉里匹配不到选项，
            // Element会把uuid原样回显成一串乱码（BUG #84 切换购方抬头银行账号乱码）
            this.buyerBankUuid = ''
            // CARGO-20372 修复开票出现选择2条数据的情况（同银行不同币种不同账号）
            if (invoice.buyerBank && invoice.buyerBankAccount) {
              this.titleBankArray.forEach(element => {
                if (element.bank === invoice.buyerBank && element.bankAccount === invoice.buyerBankAccount) {
                  // this.buyerBankAccount = element.bankAccount
                  this.buyerBankUuid = element.uuid
                }
              })
            }
          }
        })
      }
    },
    // 开户银行
    getBankCusFromChild(obj) {
      console.log('getBankCusFromChild', obj)
      if (obj) {
        if (obj.hasOwnProperty('bank')) {
          this.properties.invoice.buyerBank = obj.bank
        } else {
          this.properties.invoice.buyerBank = obj.value
        }
        if (obj.uuid) {
          this.properties.invoice.buyerBankAccount = obj.bankAccount
        }
      }
    },
    // 计算税额
    taxFreeAmountChangeHandler(value, calcTaxRate = false) {
      value = this.numFormatFunction2(value)
      this.$nextTick(() => {
        const invoice = this.properties.invoice
        // invoice.excludingTaxAmount = value
        // invoice.taxAmount = invoice.amount - invoice.excludingTaxAmount
        invoice.excludingTaxAmount = RateUtil.getAmountByCurrency(value, this.properties.invoice.currency)
        invoice.taxAmount = RateUtil.getAmountByCurrency(invoice.amount - invoice.excludingTaxAmount, this.properties.invoice.currency)
        if (calcTaxRate) {
          if (invoice.taxAmount !== 0 && invoice.excludingTaxAmount !== 0) {
            invoice.taxRate = RateUtil.getAmountByCurrency((invoice.taxAmount / invoice.excludingTaxAmount) * 100, this.properties.invoice.currency)
          } else {
            invoice.taxRate = 0
          }
        }
      })
    },
    // 税率
    taxRateChangeHandler(value) {
      InvoiceUtils.taxRateChangeHandler(this.properties.invoice)
    },
    // 计算不含税
    taxAmountChangeHandler(value) {
      InvoiceUtils.taxAmountChangeHandler(this.properties.invoice, value, this)
    },
    // 添加
    addInvoiceItemHandler() {
      const row = {}
      // 发票UUID
      row.invoiceUuid = this.properties.invoice.uuid
      row.goodsName = ''
      row.dimension = ''
      row.unit = ''
      row.quantity = 0 // 数量
      row.unitRate = 0 // 单价
      row.amount = 0 // 不含税金额
      row.invoiceNature = 0 // 税率标识 默认正常
      row.taxRate = 0 // 税率
      row.taxAmount = 0 // 税额
      if (this.properties.isEasyInoivceVietnam) row.level = this.properties.invoice.invoiceItemList.length + 1 // 序号
      this.properties.invoice.invoiceItemList.push(row)
      console.log('addInvoiceItemHandler', row)
      this.$nextTick(() => {
        this.gridApi.deselectAll()
        const nodes = this.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        lastNode.setSelected(true)
      })
    },
    // 删除
    removeInvoiceItemHandler() {
      const rowDataSelected = getGridSelected(this.vatInvoiceGrid.gridOptions)
      if (rowDataSelected.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      console.log('removeInvoiceItemHandler', rowDataSelected)
      const invoiceItemList = this.properties.invoice.invoiceItemList
      for (const item of rowDataSelected) {
        const index = invoiceItemList.indexOf(item)
        invoiceItemList.splice(index, 1)
        if (this.properties.isEasyInoivceVietnam && invoiceItemList.length > 0) invoiceItemList.forEach(e => { if (e.level > item.level) e.level -= 1 })
      }
    },
    // 应收更新，开票更新
    async saveAndCalcAmountHandler() {
      try {
        await this.checkSave(this.beforeSaveAndCalcAmountHandler)
      } catch (e) {
        if (this.loading) {
          this.loading.close()
        }
      }
    },
    async beforeSaveAndCalcAmountHandler() {
      // 验证是否需要更改汇率，如果是的话则需要弹框确认
      const isUpdateRate = await this.checkExchangeRate()
      if (!this.loading) {
        this.loading = getLoading()
      }
      this.properties.invoice.updateRate = isUpdateRate
      this.recalculateInvoiceSummaryFromItems()
      this.properties.invoice.location = this.location
      saveAmount(this.properties.invoice).then(res => {
        this.properties.invoice = { ...res.data, incomePayDate: this.properties.invoice.incomePayDate }
        this.originalInputUserId = this.properties.invoice.inputBy
        this.$message.success(this.$t('Message.SaveSuccessfully') + (isUpdateRate ? this.$t('Invoice.RateChangedSuccess') : ''))
      }).finally(() => {
        this.closeLoading()
      })
    },
    // 列数据改变
    onCellChange(params) {
      const field = params.colDef.field
      params = { colId: params.colDef.colId, data: params.data, field, originalValue: params.oldValue, value: params.newValue }
      console.log('onCellChange', params)
      const item = params.data
      const value = StrUtils.isEmpty(params.value) ? 0 : params.value
      // let amount = 0.00
      switch (field) {
        case 'goodsName':
          item.goodsName = params.value
          break
        case 'dimension':
          item.dimension = params.value
          break
        case 'unit':
          item.unit = params.value
          break
        case 'quantity':
          item.quantity = value
          // 数量变更后，单价保持不变，重算金额、税额、合计
          item.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.quantity * item.unitRate, this.properties.invoice.currency), 2)
          item.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.amount * (item.taxRate / 100), this.properties.invoice.currency), 2)
          item.sumAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.amount + item.taxAmount, this.properties.invoice.currency), 2)
          break
        case 'unitRate':
          item.unitRate = value
          // 单价变更后，数量保持不变，重算金额、税额、合计
          item.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.quantity * item.unitRate, this.properties.invoice.currency), 2)
          item.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.amount * (item.taxRate / 100), this.properties.invoice.currency), 2)
          item.sumAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.amount + item.taxAmount, this.properties.invoice.currency), 2)
          break
        case 'invoiceNature':
        case 'taxRate':
          // 处理税率标识
          if (this.isNuoNuoFei || this.isNuoNuo) {
            if (field === 'invoiceNature') {
              item.invoiceNature = value
              this.properties.invoice.invoiceNature = value
              if (value !== Number(InvoiceConstant.INVOICE_NATURE_NORMAL.code)) {
                item.taxRate = 0
              } else {
                return
              }
            } else {
              // 发票性质/税率标识为正常时，才可调整税率
              if (item.invoiceNature !== Number(InvoiceConstant.INVOICE_NATURE_NORMAL.code)) {
                this.$message.warning(this.$t('CargoMsg.Cargo_InvoiceNatureTip'))
                item.taxRate = 0
              } else {
                // 根据公式:数量*单价*（1+税率）=合计;合计不变,税率改变，则不含税额发生发变化。数量*单价=不含税金额，所以单价发生变化。不含税金额+税额=合计，所以税额发生变化
                item.taxRate = value
              }
            }
          } else {
            // 根据公式:数量*单价*（1+税率）=合计;合计不变,税率改变，则不含税额发生发变化。数量*单价=不含税金额，所以单价发生变化。不含税金额+税额=合计，所以税额发生变化
            item.taxRate = value
          }
          if (item.amount) {
            // item.amount = NumberUtils.roundHalfUp2(item.sumAmount / (item.taxRate / 100 + 1), 2)
            // item.unitRate = NumberUtils.roundHalfUp2(item.amount / item.quantity, 2)
            // item.taxAmount = NumberUtils.roundHalfUp2(item.sumAmount - item.amount, 2)
            item.amount = NumberUtils.roundHalfUp2(RateUtil.getAmountByCurrency(item.sumAmount / (item.taxRate / 100 + 1), this.properties.invoice.currency), 2)
            if (this.isHtxx || this.isNuoNuo) {
              item.unitRate = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(item.amount / item.quantity, this.properties.invoice.currency), 2)
            } else {
              item.unitRate = NumberUtils.roundHalfUp2(RateUtil.getAmountByCurrency(item.amount / item.quantity, this.properties.invoice.currency), 2)
            }
            item.taxAmount = NumberUtils.roundHalfUp2(RateUtil.getAmountByCurrency(item.sumAmount - item.amount, this.properties.invoice.currency), 2)
          } else {
            // item.taxAmount = NumberUtils.roundHalfUp((isNaN(item.quantity) ? 0 : item.quantity) * (isNaN(item.unitRate) ? 0.0 : item.unitRate) * (item.taxRate / 100), 2)
            // item.sumAmount = NumberUtils.roundHalfUp(item.taxAmount + item.amount, 2)
            item.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency((isNaN(item.quantity) ? 0 : item.quantity) * (isNaN(item.unitRate) ? 0.0 : item.unitRate) * (item.taxRate / 100), this.properties.invoice.currency), 2)
            item.sumAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.taxAmount + item.amount, this.properties.invoice.currency), 2)
          }
          break
        case 'sumAmount':
          // item.sumAmount = value
          item.sumAmount = RateUtil.getAmountByCurrency(value, this.properties.invoice.currency)
          // 根据公式:数量*单价*（1+税率）=合计，数量和税率保持不变，重新计算单价，不含税额，税额
          if (this.isHtxx || this.isNuoNuo) {
            item.unitRate = NumberUtils.ToFixed2(item.sumAmount / (item.taxRate / 100 + 1) / item.quantity, 8)
          } else {
            item.unitRate = NumberUtils.roundHalfUp(item.sumAmount / (item.taxRate / 100 + 1) / item.quantity, 2)
          }
          // 不含税额
          // item.amount = NumberUtils.roundHalfUp(item.quantity * item.unitRate, 2)
          item.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.quantity * item.unitRate, this.properties.invoice.currency), 2)
          // 税额
          // item.taxAmount = NumberUtils.roundHalfUp(item.amount * (item.taxRate / 100), 2)
          item.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.amount * (item.taxRate / 100), this.properties.invoice.currency), 2)
          break
        default:
      }
      if (isNaN(item.unitRate) || item.unitRate === Infinity || item.unitRate === '0.00' || item.unitRate === 0.00 || item.unitRate === '0.00000000') {
        item.unitRate = (this.isHtxx || this.isNuoNuo) ? '0.00000000' : '0.00'
      }
      if (item.quantity === Infinity || item.quantity === 0 || item.quantity === '0') {
        item.quantity = 0
      }
      this.checkAmount(item)
      this.recalculateInvoiceSummaryFromItems()
      this.gridApi.refreshCells({ force: true })
      this.$emit('cellChange', params)
    },
    recalculateInvoiceSummaryFromItems() {
      let total = 0
      let totalTaxAmount = 0
      for (const item of this.properties.invoice.invoiceItemList || []) {
        total += item.amount + item.taxAmount
        total = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(total, this.properties.invoice.currency), 2)
        totalTaxAmount += item.taxAmount
        totalTaxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(totalTaxAmount, this.properties.invoice.currency), 2)
      }
      this.properties.invoice.amount = NumberUtils.roundHalfUp(total, 2)
      this.properties.invoice.taxAmount = NumberUtils.roundHalfUp(totalTaxAmount, 2)
      const excludingTaxAmount = RateUtil.getAmountByCurrency(this.properties.invoice.amount - this.properties.invoice.taxAmount, this.properties.invoice.currency)
      this.properties.invoice.excludingTaxAmount = NumberUtils.roundHalfUp(excludingTaxAmount, 2)
      if (!this.properties.isEasyInoivceVietnam) {
        this.properties.invoice.chineseAmount = RMBBigTransForm.toBigAmt(NumberUtils.ToFixed2(this.properties.invoice.amount, 2))
      }
    },
    // 货物运输列数据改变
    onCargoCellChange(params) {
      // const field = params.colDef.field
      // params = { colId: params.colDef.colId, data: params.data, field, originalValue: params.oldValue, value: params.newValue }
      // const item = params.data
      // switch (field) {
      //   case 'pol':
      //     item.pol = params.value
      //     break
      //   case 'pod':
      //     item.pod = params.value
      //     break
      //   default:
      //     break
      // }
      this.cargoTransportGrid.gridApi.refreshCells({ force: true })
    },
    checkAmount(item) {
      if (item.taxAmount > 0) {
        // const differenceAmount = NumberUtils.roundHalfUp(item.taxAmount + item.amount - item.sumAmount, 2)
        const differenceAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(item.taxAmount + item.amount - item.sumAmount, this.properties.invoice.currency), 2)
        if (differenceAmount !== 0) {
          item.taxAmount -= differenceAmount
          item.taxAmount = RateUtil.getAmountByCurrency(item.taxAmount, this.properties.invoice.currency)
        }
      }
    },
    // 选择发票号按钮回调事件
    selectedInvoiceNoCallBackEvent(invoiceNos = []) {
      const invoices = this.getNonInvoiceNos()
      if (invoiceNos && invoiceNos.length > 0 && invoices && invoices.length > 0 && invoiceNos.length === invoices.length) {
        for (let i = 0; i < invoices.length; i++) {
          const invoice = invoices[i]
          const invoiceNo = invoiceNos[i]
          if (invoice && invoiceNo) {
            invoice.invoiceNo = invoiceNo.invoiceNo
            invoice.selectedInvoiceNo = invoiceNo
            if (invoice.hasOwnProperty('files') && invoice['files'] && invoice['files'].length > 0) {
              invoice.files.push(...JobUtils.createFile(invoice, invoiceNo.invoiceNo))
            } else {
              invoice.files = []
              invoice.files = JobUtils.createFile(invoice, invoiceNo.invoiceNo)
            }
            // 将发票号保存到发票关联的费用中去
            const charges = invoice['chargeList']
            if (charges && charges.length > 0) {
              for (let i = 0; i < charges.length; i++) {
                const charge = charges[i]
                charge['invoiceNo'] = invoiceNo.invoiceNo
              }
            }
          }
        }
      }
      this.selectInvoiceDialog.show = false
    },
    // 获取没有发票号的发票列表
    getNonInvoiceNos() {
      const invoices = this.properties.invoices
      const result = []
      if (invoices && invoices.length > 0) {
        for (let i = 0; i < invoices.length; i++) {
          const invoice = invoices[i]
          if (!invoice['selectedInvoiceNo'] && !invoice['invoiceNo']) {
            result.push(invoice)
          }
        }
      }
      return result
    },
    // 增票合并/显示明细
    rbgShowChargeDetailChangeHandler(value) {
      console.log('rbgShowChargeDetailChangeHandler:', value)
      const invoiceMap = { 'invoiceUuid': this.properties.invoice.uuid, 'showChargeDetail': this.properties.rbgShowChargeDetail === 'detail' }
      this.loading = getLoading()
      showChargeDetailChange(invoiceMap).then(res => {
        console.log('showChargeDetail', res)
        const invoice = res.data
        // 刷新
        this.properties.invoice.partChargeName = invoice.partChargeName
        this.properties.invoice.partQuantity = invoice.partQuantity
        this.properties.invoice.partUnitPrice = invoice.partUnitPrice
        this.properties.invoice.partCurrency = invoice.partCurrency
        this.properties.invoice.partAmount = invoice.partAmount
        this.properties.invoice.partAmount2 = invoice.partAmount2
        this.properties.invoice.invoiceItemList = invoice.invoiceItemList
        this.recalculateInvoiceSummaryFromItems()
      }).finally(() => {
        this.loading.close()
      })
      this.$forceUpdate()
    },
    // 开始打印
    doPrint() {
      console.log('doPrint')
      const params = {}
      const printKeys = []
      if (this.printFlag === 1) {
        printKeys.push(this.properties.invoice.uuid)
      } else if (this.printFlag === 2) {
        for (const invoice of this.properties.invoices) {
          printKeys.push(invoice.uuid)
        }
      }
      params.INVOICE_UUID = printKeys
      params.USER_UUID = this.$store.getters.userInfo.userId
      params.classNameType = SystemConstants.ACT
      // TemplateSelectorWin.getInstance().showThisWin(selections.getItemAt(0) as AbstractEntity, "INVOICELIST", params, this);
      this.templateSelectorDialog.cxt = new Invoice(this.properties.invoice)
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.category = 'INVOICE'
      this.templateSelectorDialog.printedCallback = this.printedCallback
      this.templateSelectorDialog.visible = true
    },
    printedCallback() {
      const keys = []
      if (this.printFlag === 1) {
        keys.push(this.properties.invoice.uuid)
      } else if (this.printFlag === 2) {
        for (const invoice of this.properties.invoices) {
          keys.push(invoice.uuid)
        }
      }
      if (keys.length === 0) return
      const requestBody = { 'keys': keys }
      console.log('printedInvoices', requestBody)
      this.loading = getLoading()
      printedInvoices(requestBody).then(res => {
        console.log('printedInvoices', res)
        // 刷新
        const invoices = []
        if (this.printFlag === 1) {
          this.properties.invoice.printed = true
          invoices.push(this.properties.invoice)
        } else if (this.printFlag === 2) {
          for (const invoice of this.properties.invoices) {
            invoice.printed = true
            invoices.push(invoice)
          }
        }
        // 列表
        for (const invoice of invoices) {
          invoice.isPrinted = true
        }
        this.$emit('saveSuccess', invoices)
        this.$message.success(this.$t('CargoMsg.Cargo_PrintStatusSaved'))
      }).finally(() => {
        this.loading.close()
      })
    },
    onGridReady(params) {
      console.log('onGridReady', params)
      this.gridApi_charge = params.api
      this.columnApi_charge = params.columnApi
    },
    getMainMenuItems(params) {
      return ['pinSubMenu', 'autoSizeAll', { name: this.$t('Clearing.ResetColumn'), action: this.resetState }]
    },
    resetState() {
      console.log('resetState')
      this.columnApi_charge.resetColumnState()
    },
    processCellForClipboard() {
      const txt = window.getSelection ? window.getSelection() : document.selection.createRange().text
      console.log('processCellForClipboard', txt)
      return txt
    },
    cellEventCallback(params) {
      console.log('cellClick', params.event.target, params.event.target.nodeName)
      if (params.event.target.nodeName === 'DIV' || params.event.target.nodeName === 'SPAN') {
        const selection = document.getSelection()
        const range = document.createRange()
        range.selectNode(params.event.target)
        selection.removeAllRanges()
        selection.addRange(range)
      }
    },
    // 打开更新发票备注弹框
    updateInvoiceRemarkHandler() {
      this.remarkUpdateWindow.invoiceUuid = this.properties.invoice.uuid
      this.remarkUpdateWindow.show = true
    },
    // 打开新增邮箱弹框
    addEmailHandler() {
      if (!this.checkCargoHandler()) return
      this.invoiceEmailWindow.invoice = this.properties.invoice
      this.invoiceEmailWindow.visible = true
    },
    // 更新发票备注后 更新页面数据
    async updateRemarkCallBackHandler(invoice = null) {
      // 重新加载费用
      if (invoice) {
        await this.refreshInvoiceDetails(invoice)
      }
      this.$message.success(this.$t('CargoMsg.Cargo_NoteUpdatedSuccessfully'))

      this.remarkUpdateWindow.show = false
    },
    // 保存关联邮箱后，刷新当前发票
    async relationEmailCallBackHandler(invoice = null) {
      if (invoice) {
        await this.refreshInvoiceDetails(invoice)
      }
      this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))

      this.invoiceEmailWindow.visible = false
    },
    async refreshInvoiceDetails(invoice) {
      this.loading = getLoading()
      await getInvoiceDetails({ 'keys': [invoice] }).then(res => {
        if (res.data && res.data.length > 0) {
          this.properties.invoice = { ...res.data[0], incomePayDate: this.properties.invoice.incomePayDate }
          this.originalInputUserId = this.properties.invoice.inputBy
        }
        // 如果是合并明细状态下，保存差额以后会把invoiceItemList返回
        if (this.properties.rbgShowChargeDetail === 'merge') {
          for (const oldInvoice of this.properties.invoices) {
            if (oldInvoice.uuid === this.properties.invoice.uuid) {
              Object.assign(oldInvoice, this.properties.invoice)
            }
          }
          this.$emit('pageChange', 'saveSuccess')
          this.$emit('saveSuccess', this.properties.invoices)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 发票金额
    amountChangeHandler(value) {
      const invoice = this.properties.invoice
      // invoice.amount = value
      // invoice.taxAmount = NumberUtils.roundHalfUp2(invoice.amount * (invoice.taxRate / 100), 2)
      // invoice.excludingTaxAmount = NumberUtils.roundHalfUp2(invoice.amount - invoice.taxAmount, 2)
      invoice.amount = RateUtil.getAmountByCurrency(value, this.properties.invoice.currency)
      invoice.taxAmount = NumberUtils.roundHalfUp2(RateUtil.getAmountByCurrency(invoice.amount * (invoice.taxRate / 100), this.properties.invoice.currency), 2)
      invoice.excludingTaxAmount = NumberUtils.roundHalfUp2(RateUtil.getAmountByCurrency(invoice.amount - invoice.taxAmount, this.properties.invoice.currency), 2)
    },
    // 应付更新、收票更新
    async updateInvoiceAmount() {
      try {
        await this.checkSave(this.beforeUpdateInvoiceAmount)
      } catch (e) {
        if (this.loading) {
          this.loading.close()
        }
      }
    },
    async beforeUpdateInvoiceAmount() {
      // 验证是否需要更改汇率，如果是的话则需要弹框确认
      const isUpdateRate = await this.checkExchangeRate()
      if (!this.loading) {
        this.loading = getLoading()
      }
      this.properties.invoice.updateRate = isUpdateRate
      this.properties.invoice.location = this.location
      saveAmount(this.properties.invoice).then(res => {
        this.properties.invoice = { ...res.data, incomePayDate: this.properties.invoice.incomePayDate }
        this.originalInputUserId = this.properties.invoice.inputBy
        this.$message.success(this.$t('Message.SaveSuccessfully') + (isUpdateRate ? this.$t('Invoice.RateChangedSuccess') : ''))
      }).finally(() => {
        this.closeLoading()
      })
    },
    buyerBankModeChange() {
      const invoice = this.properties.invoice
      const item = this.titleArray.find(p => p.title === invoice.title)
      if (invoice.buyerBankMode === 1) {
        this.buyerBankUuid = ''
        invoice.buyerBank = ''
        invoice.buyerBankAccount = ''
        if (item) {
          invoice.buyerDepositBankAccount = item.depositBankAccount
        } else {
          invoice.buyerDepositBankAccount = ''
        }
      } else {
        invoice.buyerDepositBankAccount = ''
        if (item) {
          this.titleChangeEvent(item)
        } else {
          this.buyerBankUuid = ''
          invoice.buyerBank = ''
          invoice.buyerBankAccount = ''
        }
      }
      LocalStorageUtilsNew.setConfiguration('buyerBankMode', invoice.buyerBankMode)
    },
    sellerBankModeChange() {
      const invoice = this.properties.invoice
      if (invoice.sellerBankMode === 1) {
        const invoiceTitle = this.ourInvoiceTitleArray.find(p => p.invoiceTitle === invoice.sellTitle)
        this.ourBankAccountId = 0
        invoice.bank = ''
        invoice.bankCurrency = ''
        invoice.bankAccount = ''
        if (invoiceTitle) {
          invoice.sellerDepositBankAccount = invoiceTitle.depositBankAccount
        } else {
          invoice.sellerDepositBankAccount = ''
        }
      } else {
        let bankAccount = null
        if (this.ourBankAccountArray) {
          const office = this.$store.getters.currentOffice
          const currency = invoice.chargeCurrency1 ? invoice.chargeCurrency1 : invoice.currency
          let firstMatchCurrency = null
          for (const item of this.ourBankAccountArray) {
            if (currency === item.currency) {
              if (item.defaultPayment) {
                bankAccount = item
                break
              }
              if (!firstMatchCurrency) {
                firstMatchCurrency = item
              }
            }
          }
          if (!bankAccount) {
            bankAccount = firstMatchCurrency
          }
        }
        invoice.sellerDepositBankAccount = ''
        if (bankAccount) {
          this.ourBankAccountId = bankAccount.accountId
          invoice.bankAccount = bankAccount.accountNo
          invoice.bank = bankAccount.bankChineseName
          invoice.bankCurrency = bankAccount.currency
        } else {
          this.ourBankAccountId = 0
          invoice.bankAccount = ''
          invoice.bank = ''
          invoice.bankCurrency = ''
        }
      }
      LocalStorageUtilsNew.setConfiguration('sellerBankMode', invoice.sellerBankMode)
    },
    buyerDepositBankAccountChange(val) {
      this.properties.invoice.buyerDepositBankAccount = val.trimEnd()
    },
    sellerDepositBankAccountChange(val) {
      this.properties.invoice.sellerDepositBankAccount = val.trimEnd()
    },
    // 添加货物
    addCargoHandler() {
      if (this.locked) return
      const row = {}
      // 发票UUID
      row.invoiceUuid = this.properties.invoice.uuid
      row.name = '' // 货物名称
      row.type = '' // 运输工具种类
      row.transportNumber = '' // 运输工具牌号
      row.pol = '' // 起运地
      row.pod = '' // 到达地
      row.tmpUuid = UIDUtil.createUID()
      if (!this.properties.invoice.transportList) this.properties.invoice.transportList = []
      this.properties.invoice.transportList.push(row)
      this.$nextTick(() => {
        this.cargoTransportGrid.gridApi.deselectAll()
        const nodes = this.cargoTransportGrid.gridApi.getRenderedNodes()
        const lastNode = nodes[nodes.length - 1]
        if (lastNode) lastNode.setSelected(true)
      })
    },
    // 删除货物
    delCargoHandler(params) {
      if (this.locked) return
      const transportList = this.properties.invoice.transportList
      if (transportList) {
        for (const item of transportList) {
          if ((item.uuid && params.uuid === item.uuid) || (item.tmpUuid && params.tmpUuid === item.tmpUuid)) {
            const index = transportList.indexOf(params)
            if (index !== -1) transportList.splice(index, 1)
          }
        }
        // 至少留一个
        if (transportList.length === 0) {
          this.addCargoHandler()
        }
      }
    },
    // 验证货物运输服务
    checkCargoHandler() {
      if (!this.invoiceTypeFei) return true
      if (this.properties.invoice.specificConstraintType !== InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code) return true
      if (!this.properties.invoice.transportList || this.properties.invoice.transportList.length <= 0) {
        this.$message.warning(this.$t('Invoice.ServiceOfGoodsTransported') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      for (const transport of this.properties.invoice.transportList) {
        if (StrUtils.isEmpty(transport.name)) {
          this.$message.warning(this.$t('Invoice.NameOfGoodsTransported') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
        if (StrUtils.isEmpty(transport.type)) {
          this.$message.warning(this.$t('Invoice.TypeOfTransport') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
        if (StrUtils.isEmpty(transport.transportNumber)) {
          this.$message.warning(this.$t('Invoice.TransportVehicleBrand') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
        if (StrUtils.isEmpty(transport.pol)) {
          this.$message.warning(this.$t('Invoice.Origin') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
        if (StrUtils.isEmpty(transport.pod)) {
          this.$message.warning(this.$t('Invoice.Destination') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
          return false
        }
      }
      return true
    },
    // 起运地目的地【中国 = CN】取到市级（直辖市取到区级）
    // type 1.省份;2.城市;3.地区
    initCityList() {
      if (this.properties.invoice.specificConstraintType !== InvoiceConstant.SPECIFIC_CONSTRAINT_TYPE_CTS.code) {
        return []
      }
      if (this.cityListOptions && this.cityListOptions.length > 0) {
        return this.cityListOptions
      }
      const countryList = getCacheListByKey(TYPE_NAMES.basic_data_Country)
      const divisionList = getCacheListByKey(TYPE_NAMES.basic_data_AdministrativeDivision)

      const hasChildOptions = []
      for (const country of countryList) {
        if (country.code !== 'CN') continue
        const provinceList = divisionList.filter(p => p.parentId === country.uuid)
        if (provinceList.length > 0) {
          for (const province of provinceList) { // 省
            let provinceOption = {
              value: province.code,
              label: this.isZh ? province.name : province.englishName
            }
            const cityList = divisionList.filter(p => p.parentId === province.uuid)
            if (cityList.length > 0) {
              const provinceChildren = []
              for (const city of cityList) { // 市
                let cityOption = {
                  value: city.code,
                  label: this.isZh ? city.name : city.englishName
                }
                if (['北京市', '天津市', '重庆市', '上海市'].includes(province.code)) {
                  provinceOption = cityOption
                  const districtList = divisionList.filter(p => p.parentId === city.uuid)
                  if (districtList.length > 0) {
                    for (const district of districtList) { // 区
                      cityOption = {
                        value: district.code,
                        label: this.isZh ? district.name : district.englishName
                      }
                      provinceChildren.push(cityOption)
                    }
                  }
                } else {
                  provinceChildren.push(cityOption)
                }
              }
              provinceOption.children = provinceChildren
            }
            hasChildOptions.push(provinceOption)
          }
        }
      }
      return hasChildOptions
    },
    // 格式化城市显示
    formatCity(value) {
      if (value && value.indexOf(',') !== -1) {
        value = value.split(',')
      }
      if (value && value.length === 2) {
        const provinceCode = value[0]
        const cityCode = value[1]
        let label = ''
        this.cityListOptions = this.initCityList()
        for (const province of this.cityListOptions) {
          if (province.value === provinceCode) {
            label = province.label
            for (const child of province.children) {
              if (child.value === cityCode) {
                label = label + ' / ' + child.label
                break
              }
            }
            return label
          }
        }
      }
      return value
    },
    // 全电认证二维码弹窗
    async authRecognition() {
      if (!this.properties.FeiByAuth) { // 全电开票是否开启验证
        return true
      }
      if (!this.isFei || !this.invoiceTypeFei) return true
      // 全电实人认证校验
      const loading = getLoading4Cxt()
      const obj = { 'officeId': this.$store.getters.currentOfficeId }
      await authRecognition(obj).then(res => {
        const result = res.data
        if (result.success && result.ewm) { // 二维码 弹框
          this.ewmDialog.ewm = result.ewm
          this.ewmDialog.visible = true
          this.ewmDialog.curTime = setInterval(() => {
            if (this.ewmDialog.time === 0) {
              this.ewmDialog.time = 15
              clearInterval(this.ewmDialog.curTime)
            } else {
              this.ewmDialog.time--
            }
          }, 1000)
          return false
        } else if (!result.success && result.msg) {
          this.$message.error(result.msg)
          return false
        }
        return true
      }).finally(() => {
        loading.close()
      })
    },
    // 获取开票员
    getInvoicerUsersList() {
      const office = this.$store.getters.currentOffice
      this.invoicerUsersList = []
      // 多抬头情况下
      if (office.titleMode === 1) {
        this.queryInvoiceTitleByOfficeHandler(office)
      } else {
        getInvoicerList(this.$store.getters.currentOfficeUuid).then(res => {
          this.invoicerUsersList = res.data || []
        })
      }
    },
    queryInvoiceTitleByOfficeHandler() {
      if (this.properties && this.properties.invoice && this.properties.invoice.taxAccount) {
        queryInvoiceTitleByOfficeFunc({
          officeId: this.$store.getters.currentOffice.officeId,
          hasUser: true
        }).then(res => {
          this.taxAccountMap = new Map()
          this.invoiceIssuerMap = new Map()
          const rowData = res.data
          if (rowData && rowData.length > 0) {
            for (const data of rowData) {
              const taxAccount = data.taxAccount
              const users = data.users || []
              const nowUser = users.filter(p => p.userId === this.$store.getters.userInfo.userId)
              if (!(nowUser && nowUser.length > 0)) {
                users.push(this.$store.getters.userInfo)
              }
              this.taxAccountMap[taxAccount] = users
              this.invoiceIssuerMap[taxAccount] = data.invoiceIssuer
            }
          }
          this.getTitleByOffice(false)
        })
      }
    },
    getTitleByOffice(n) {
      const office = this.$store.getters.currentOffice
      if (!office || office.titleMode !== 1 || !this.isFei || !this.invoiceTypeFei) {
        return
      }
      this.invoicerUsersList = []
      this.invoiceIssuer = 0
      if (this.properties && this.properties.invoice && this.properties.invoice.taxAccount) {
        const taxAccount = this.properties.invoice.taxAccount
        this.invoicerUsersList = this.taxAccountMap[taxAccount]
        this.invoiceIssuer = this.invoiceIssuerMap[taxAccount]
      }
      if (!this.invoicerUsersList || this.invoicerUsersList.length === 0) {
        this.invoicerUsersList = [this.$store.getters.userInfo]
      }
      // 是否存在默认开票员
      let needR = true
      if (n && this.invoiceIssuer === 1) {
        for (const data of this.invoicerUsersList) {
          if (data.defaultInvoiceIssuer) {
            this.properties.invoice.inputBy = data.userId
            needR = false
            break
          }
        }
      }
      if (needR) {
        // 没有默认开票员的，使用发票上的原开票员
        const originalUser = this.invoicerUsersList.filter(p => p.userId === this.originalInputUserId)
        if (!(originalUser && originalUser.length > 0)) {
          const user = getObjectByCache(basicCacheKeys.basic_data_User, 'userId', this.originalInputUserId)
          if (user) {
            // 开票员列表没有原开票员，添加一份
            this.invoicerUsersList.push(user)
          }
        }
        // 还原之前的开票员
        this.properties.invoice.inputBy = this.originalInputUserId
      }
    },
    // 保存之前校验是否需要更新汇率
    async checkExchangeRate(loading = null) {
      const getInvoiceRateByInvoiceDate = parseInt(cache.config.get('getInvoiceRateByInvoiceDate')) === 1
      if (!getInvoiceRateByInvoiceDate) return false
      const obj = {
        'anyStr': this.properties.invoice.uuid,
        'anyDate': this.properties.invoice.invoiceDate,
        'branchId': this.$store.getters.currentOfficeId
      }
      const flag = await checkExchangeRate(obj).then(res => res.data).catch(() => {
        this.closeLoading()
      })
      if (flag) {
        this.closeLoading()
        return await this.$confirm(this.$t('Invoice.RateChangedTip'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => true).catch(() => false)
      }
      return false
    },
    // 开票-费用设置
    toQueryInvoiceChargeItem() {
      this.invoiceChargeItemArray = []
      if (this.properties.invoice.ar && [2, 3].includes(this.properties.invoice.invoiceType) && this.properties.isEasyInoivceVietnam) {
        const loading = getLoading()
        queryInvoiceChargeItem({ 'officeId': this.$store.getters.currentOfficeId }).then(res => {
          this.invoiceChargeItemArray = res.data
        }).finally(() => {
          loading.close()
        })
      }
    },
    goodsNameVietnamTipFunc(value) {
      if (value && this.invoiceChargeItemArray.length > 0) {
        for (const item of this.invoiceChargeItemArray) {
          if (this.properties.invoice.invoiceType === item.invoiceType && value === item.chargeItemName) {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId, 'zhName')
          }
        }
      }
      return value
    },
    invoiceDateChange() {
      InvoiceUtils.invoiceDateChange(this)
    },
    closeLoading() {
      if (this.loading) {
        this.loading.close()
        this.loading = null
      }
    },
    // 加载运输工具历史数据
    loadTransportServiceHistory() {
      getTransportServiceHistory({ accountId: this.properties.invoice.accountId }).then(res => {
        if (res.data && res.data.length > 0) {
          // 整理历史数据
          const history = {
            transportNumber: [],
            pol: [],
            pod: [],
            name: []
          }
          res.data.forEach(item => {
            if (item.transportGrade && history.transportNumber.indexOf(item.transportGrade) === -1) {
              history.transportNumber.push(item.transportGrade)
            }
            if (item.originalPlace && history.pol.indexOf(item.originalPlace) === -1) {
              history.pol.push(item.originalPlace)
            }
            if (item.destination && history.pod.indexOf(item.destination) === -1) {
              history.pod.push(item.destination)
            }
            if (item.transportGoodName && history.name.indexOf(item.transportGoodName) === -1) {
              history.name.push(item.transportGoodName)
            }
          })
          this.transportServiceHistory = history
        }
      })
    }
  }
}
</script>

<style lang="scss">
.make-invoice-dialog {
  .el-dialog__body {
    font-size: 12px;
    padding: 0 !important;
    min-height: 450px;
  }
  .el-form-item-w320 {
    width: 320px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 260px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w250 {
    width: 250px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 190px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-label65-w250 {
    width: 250px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__label {
      width: 65px !important;
    }
    .el-form-item__content {
      width: 185px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w230 {
    width: 230px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__label {
      width: 80px !important;
    }
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w210 {
    width: 210px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 150px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w190 {
    width: 190px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 130px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-date-w190 {
    width: 190px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-date-editor {
      width: 130px;
    }
  }
  .el-form-item-w150 {
    width: 150px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 90px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w130 {
    width: 130px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 70px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-w110 {
    width: 110px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 50px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
  }
  .el-form-item-textarea-w150 {
    width: 150px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 150px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 150px;
      .el-textarea__inner {
        padding: 2px 4px !important;
        height: 200px;
        resize:none;
      }
    }
  }
  .el-form-item-textarea-w140 {
    width: 140px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 140px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 140px;
      .el-textarea__inner {
        padding: 2px 4px !important;
        height: 200px;
        resize:none;
      }
    }
  }
  .el-form-item-textarea-w100 {
    width: 100px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 100px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 100px;
      .el-textarea__inner {
        padding: 2px 4px !important;
        height: 200px;
        resize:none;
      }
    }
  }
  .el-form-item-textarea-w80 {
    width: 80px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__label {
      padding: 0;
      width: 80px !important;
      text-align: center;
    }
    .el-form-item__content {
      width: 80px;
      .el-textarea__inner {
        padding: 2px 4px !important;
        height: 200px;
        resize:none;
      }
    }
  }

  .el-form-item-w260 {
    width: 260px;
    .el-form-item__content {
      width: 200px;
    }
  }
  .el-form-item-w200 {
    width: 200px;
    .el-form-item__content {
      width: 140px;
    }
  }
  .el-form-item-w100 {
    width: 100px;
    .el-form-item__content {
      width: 40px;
    }
  }
  .el-form-item-label40-w120 {
    width: 120px;
    .el-form-item__label {
      width: 40px !important;
    }
    .el-form-item__content {
      width: 80px;
    }
  }
  .el-form-item-label50-w130 {
    width: 130px;
    .el-form-item__label {
      width: 50px !important;
    }
    .el-form-item__content {
      width: 80px;
    }
  }
  .el-form-item-w300 {
    width: 300px;
    .el-form-item__content {
      width: 240px;
    }
  }
  .el-form-item-label40-w180 {
    width: 180px;
    .el-form-item__label {
      width: 40px !important;
    }
    .el-form-item__content {
      width: 140px;
    }
  }
  .el-form-item-label80-w200 {
    width: 200px;
    .el-form-item__label {
      width: 80px !important;
    }
    .el-form-item__content {
      width: 120px;
    }
  }
  .el-form-item-label90-w280 {
    width: 380px;
    .el-form-item__label {
      width: 90px !important;
    }
    .el-form-item__content {
      width: 290px;
    }
  }
  .el-form-item-label100-w290 {
    width: 290px;
    .el-form-item__label {
      width: 100px !important;
    }
    .el-form-item__content {
      width: 190px;
    }
  }
  .el-form-item-textarea-label90-w350 {
    width: 350px;
    .el-form-item__label {
      width: 90px !important;
    }
    .el-form-item__content {
      width: 260px;
    }
    .el-textarea__inner {
      padding: 2px 4px !important;
      height: 70px;
      resize: none;
    }
  }
  .el-form-item-textarea-label100-w360 {
    width: 360px;
    .el-form-item__label {
      width: 100px !important;
    }
    .el-form-item__content {
      width: 260px;
    }
    .el-textarea__inner {
      padding: 2px 4px !important;
      height: 70px;
      resize: none;
    }
  }
  .el-form-item-textarea-label120-w380 {
    width: 380px;
    .el-form-item__label {
      width: 120px !important;
    }
    .el-form-item__content {
      width: 260px;
    }
    .el-textarea__inner {
      padding: 2px 4px !important;
      height: 70px;
      resize: none;
    }
  }
  .el-form-item-label90-w220 {
    width: 220px;
    .el-form-item__content {
      width: 130px;
    }
  }
  .el-form-item-label100-w230 {
    width: 230px;
    .el-form-item__content {
      width: 130px;
    }
  }
  .el-form-item-label90-w240 {
    width: 240px;
    .el-form-item__content {
      width: 150px;
    }
  }
  .el-form-item-textarea-w120 {
    width: 120px;
    .el-form-item__label {
      padding: 0;
      width: 120px !important;
      text-align: center;
    }
    .el-textarea__inner {
      height: 180px;
      resize:none;
    }
  }
  .el-form-item-textarea-w90 {
    width: 90px;
    .el-form-item__label {
      padding: 0;
      width: 90px !important;
      text-align: center;
    }
    .el-textarea__inner {
      height: 180px;
      resize:none;
    }
  }
  .el-form-item-textarea-w60 {
    width: 60px;
    .el-form-item__label {
      padding: 0;
      width: 60px !important;
      text-align: center;
    }
    .el-textarea__inner {
      height: 180px;
      resize:none;
    }
  }
  .el-form-item-date-w100 {
    .el-date-editor {
      width: 100px;
    }
  }
  .el-form-item-date-w130 {
    .el-date-editor {
      width: 130px;
    }
  }
  .dense-btns {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    .el-button {
      margin-left: 5px;
    }
    .el-button--mini {
      padding: 7px 12px;
    }
  }
  .vatInvoiceForm {
    margin: 5px 40px;
    .el-form-item {
      margin-bottom: 2px !important;
      .el-form-item__label {
        color: red !important;
      }
      .el-checkbox__label {
        color: red !important;
      }
    }
    .el-form-item-w388 {
       width: 388px;
       margin-right: 2px;
       margin-bottom: 4px !important;
       .el-form-item__content {
         width: 288px;
         .el-input__inner {
           padding: 0px 4px !important;
         }
       }
     }
    .el-form-item-w240 {
      width: 240px;
      margin-right: 2px;
      margin-bottom: 4px !important;
      .el-form-item__content {
        width: 140px;
        .el-input__inner {
          padding: 0px 4px !important;
        }
      }
    }
    .el-form-item-date-w240 {
      width: 240px;
      margin-right: 2px;
      margin-bottom: 4px !important;
      .el-date-editor {
        width: 140px;
      }
    }
    .el-form-item-w180 {
      width: 180px;
      .el-form-item__label {
        width: 80px !important;
      }
      .el-form-item__content {
        width: 100px;
        margin-left: 80px !important;
        .el-input__inner {
          padding: 0px 4px !important;
        }
      }
    }
    .el-input-w140 {
      width: 140px;
      margin-right: 2px;
      margin-bottom: 4px !important;
      padding-left: 20px;
      .el-input__inner {
        padding: 0px 4px !important;
      }
    }
    .el-form-item-textarea-w-full {
      width: 100%;
      .el-textarea__inner {
        height: 70px;
        resize:none;
      }
    }
    .el-col {
      margin-top: 0 !important;
    }
  }
  .red-left-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid red;
    border-left: 1px solid red;
  }
  .red-both-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid red;
    border-left: 1px solid red;
    border-right: 1px solid red;
  }
  .red-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid red;
  }
  .ag-theme-balham {
    .ag-cell{
      user-select: text;
    }
  }
  #invoiceAddValueBoard,#invoiceFei {
    .vatInvoiceForm {
      .el-col {
        margin-bottom:0;
      }
      .title-vertical {
        color: red;
        writing-mode: vertical-rl;
        flex:1;
        text-align: center;
      }
      .title-horizontal {
        color: red;
      }
      &-header {
        .el-col{
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          font-size:12px;
          &.left{
            .el-form-item {
              &__label {
                width:auto!important;
              }
              &__content{
                display: flex;
                font-size:12px;
                margin-left:auto!important;
                .el-input{
                  flex:1;
                  margin-left:5px
                }
              }
            }
          }
          &.center{
          }
          &.right{

          }
        }
      }
      &-section {
        &>.el-col{
          display: flex;
          flex-direction: column;
          height: auto;
          align-items: center;
          justify-content: center;
          .bank-mode .el-form-item__label {
            padding-right: 0;
            input.el-input__inner {
              color: red;
            }
            .el-input__suffix {
              width: 23px;
            }
          }
        }
      }
      .bank-mode {
        .cargo-rich-textarea {
          .ql-editor {
            overflow: hidden;
            p {
              width: fit-content;
              word-break: keep-all;
            }
          }
        }
      }
    }
  }
  #invoiceIncomeBoard,#invoicePayBoard {
    .el-form-item {
      margin-right:5px;
      /*.el-input,.el-textarea {
        &.is-disabled {
          .el-input__inner,.el-textarea__inner {
            background: #fff;
          }
        }
      }*/
    }
  }
  .vatInvoiceFormVietnam {
    margin: 5px 40px;
    .el-form-item {
      margin-bottom: 2px !important;
      .el-form-item__label {
        color: black !important;
      }
      .el-checkbox__label {
        color: black !important;
      }
    }
    .el-col {
      margin-top: 0 !important;
    }
  }
  .vietnam-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid black;
  }
  .vietnam-left-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid black;
    border-left: 1px solid black;
  }
  .vietnam-both-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
  }
  .vietnam-top-border-w1 {
    height: 100%;
    box-sizing: border-box;
    border-top: 1px solid black;
  }
}
.make-invoice-adjust-balance-dialog {
  .el-form-item {
    margin: 0 auto;
    width: 300px;
    .el-form-item__content {
      width: 200px;
      .el-date-editor.el-input {
        width: 200px;
      }
    }
  }
}
.make-invoice-select-invoice-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
</style>
